var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDeviceConection01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 816.07 848.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-75);}.cls-2{fill:url(#Degradado_sin_nombre_25-2);}.cls-3{fill:url(#linear-gradient-119);}.cls-4{stroke:url(#radial-gradient-8);}.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45{fill:none;}.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45{stroke-miterlimit:10;}.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-32,.cls-33,.cls-36,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45{stroke-width:1.01px;}.cls-46{fill:url(#Degradado_sin_nombre_208);}.cls-47{fill:url(#Degradado_sin_nombre_25-48);}.cls-48{fill:url(#Degradado_sin_nombre_219-2);}.cls-5{stroke:url(#radial-gradient-13);}.cls-49{fill:url(#linear-gradient-2);}.cls-50{fill:url(#Degradado_sin_nombre_221);}.cls-51{fill:url(#Degradado_sin_nombre_207-2);}.cls-52{fill:url(#Degradado_sin_nombre_19-21);}.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83{mix-blend-mode:screen;}.cls-84{fill:url(#linear-gradient-51);}.cls-85{fill:url(#Degradado_sin_nombre_25-5);}.cls-86{fill:url(#Degradado_sin_nombre_2134);}.cls-87{fill:#262626;}.cls-6{stroke:url(#radial-gradient-20);}.cls-88{fill:url(#Degradado_sin_nombre_231);}.cls-89{fill:url(#Degradado_sin_nombre_2082);}.cls-90{fill:url(#Degradado_sin_nombre_2138);}.cls-7{stroke:url(#radial-gradient-14);}.cls-91{fill:url(#Degradado_sin_nombre_200-2);}.cls-92{fill:#0f0f0f;}.cls-53{fill:url(#Degradado_sin_nombre_19-12);}.cls-93,.cls-94,.cls-95{fill:#fff;}.cls-96{fill:url(#Degradado_sin_nombre_25-12);}.cls-97{fill:url(#Degradado_sin_nombre_25-9);}.cls-98{fill:url(#Degradado_sin_nombre_25-33);}.cls-99{fill:#090909;}.cls-100{fill:url(#linear-gradient-122);}.cls-54{fill:url(#radial-gradient);}.cls-101{fill:url(#linear-gradient-17);}.cls-102{fill:url(#linear-gradient-130);}.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110{mix-blend-mode:multiply;}.cls-102,.cls-104,.cls-107{opacity:.25;}.cls-55{fill:url(#Degradado_sin_nombre_19-8);}.cls-111{fill:url(#linear-gradient-87);}.cls-112{fill:url(#Degradado_sin_nombre_2143);}.cls-56{fill:url(#Degradado_sin_nombre_19-15);}.cls-113{fill:url(#Degradado_sin_nombre_2135);}.cls-114{fill:url(#Degradado_sin_nombre_25-24);}.cls-115{fill:url(#linear-gradient-93);}.cls-116{fill:url(#Degradado_sin_nombre_25-20);}.cls-117{fill:url(#linear-gradient-92);}.cls-118{fill:url(#Degradado_sin_nombre_25-46);}.cls-8{stroke:url(#radial-gradient-24);}.cls-119{fill:#fbb3ff;}.cls-119,.cls-120{opacity:.7;}.cls-121{fill:url(#Degradado_sin_nombre_218-2);}.cls-122{fill:url(#linear-gradient-80);}.cls-123{fill:url(#Degradado_sin_nombre_25-7);}.cls-124{fill:url(#Degradado_sin_nombre_2081);}.cls-125{fill:url(#Degradado_sin_nombre_226);}.cls-126{fill:url(#linear-gradient-109);}.cls-9{stroke:url(#radial-gradient-12);}.cls-10{stroke:url(#radial-gradient-35);}.cls-127{fill:url(#Degradado_sin_nombre_229-2);}.cls-128{fill:url(#linear-gradient-43);}.cls-129{fill:url(#linear-gradient-125);}.cls-130{fill:url(#Degradado_sin_nombre_2126);}.cls-131{fill:url(#linear-gradient-133);}.cls-132{fill:url(#Degradado_sin_nombre_2099);}.cls-133{fill:url(#Degradado_sin_nombre_225);}.cls-134{fill:url(#Degradado_sin_nombre_25-25);}.cls-135{fill:url(#Degradado_sin_nombre_2076);}.cls-136{fill:url(#Degradado_sin_nombre_25-30);}.cls-137{fill:url(#Degradado_sin_nombre_2083);}.cls-11{stroke:#80e4ff;stroke-width:1.23px;}.cls-138{fill:url(#Degradado_sin_nombre_2106);}.cls-139{fill:url(#Degradado_sin_nombre_25-27);}.cls-140{fill:url(#Degradado_sin_nombre_25-60);}.cls-141{fill:url(#Degradado_sin_nombre_25-53);}.cls-57{fill:url(#Degradado_sin_nombre_19-14);}.cls-142{fill:url(#Degradado_sin_nombre_25-10);}.cls-143{fill:#0c0c0c;}.cls-144{fill:url(#linear-gradient-15);}.cls-145{fill:url(#linear-gradient-58);}.cls-58{fill:url(#Degradado_sin_nombre_19-4);}.cls-12{stroke:url(#radial-gradient-28);}.cls-59{fill:url(#Degradado_sin_nombre_19-2);}.cls-146,.cls-147,.cls-148,.cls-149{mix-blend-mode:lighten;}.cls-150{fill:url(#linear-gradient-69);}.cls-151{fill:url(#Degradado_sin_nombre_25-52);}.cls-152{fill:url(#linear-gradient-81);}.cls-120,.cls-153{fill:#b6e7ff;}.cls-13{stroke:url(#radial-gradient-10);}.cls-154{fill:url(#linear-gradient-18);}.cls-155{fill:url(#linear-gradient-56);}.cls-156{fill:url(#Degradado_sin_nombre_2085);}.cls-157{fill:url(#Degradado_sin_nombre_2088);}.cls-158{fill:url(#Degradado_sin_nombre_25-38);}.cls-159{fill:url(#Degradado_sin_nombre_25-4);}.cls-60{fill:url(#Degradado_sin_nombre_19-5);}.cls-160{fill:url(#Degradado_sin_nombre_204-2);}.cls-161{fill:url(#linear-gradient-40);}.cls-162{fill:#222;}.cls-163{fill:url(#Degradado_sin_nombre_2128);}.cls-164{fill:#aa58f9;}.cls-164,.cls-165{opacity:.9;}.cls-166{fill:#040404;}.cls-103{opacity:.32;}.cls-167{fill:url(#linear-gradient-131);}.cls-14{stroke:url(#radial-gradient-37);}.cls-15{stroke:url(#radial-gradient-39);}.cls-168{fill:url(#Degradado_sin_nombre_25-43);}.cls-169{fill:url(#linear-gradient-52);}.cls-170{fill:url(#linear-gradient-28);}.cls-171{fill:url(#Degradado_sin_nombre_2130);}.cls-172{fill:url(#Degradado_sin_nombre_25-36);}.cls-173{fill:url(#linear-gradient-14);}.cls-16{stroke:url(#radial-gradient-30);}.cls-174{fill:url(#Degradado_sin_nombre_219);}.cls-175{fill:url(#linear-gradient-36);}.cls-61{fill:url(#Degradado_sin_nombre_19-19);}.cls-176{fill:url(#Degradado_sin_nombre_215);}.cls-177{fill:url(#linear-gradient-78);}.cls-178{fill:url(#linear-gradient-20);}.cls-62{fill:url(#Degradado_sin_nombre_19-20);}.cls-104{fill:url(#linear-gradient-128);}.cls-179{fill:url(#linear-gradient-53);}.cls-180{fill:url(#Degradado_sin_nombre_25-67);}.cls-17{stroke:url(#radial-gradient-5);}.cls-181{isolation:isolate;}.cls-182{fill:url(#Degradado_sin_nombre_234);}.cls-183{fill:url(#Degradado_sin_nombre_2123);}.cls-184{fill:url(#Degradado_sin_nombre_25-84);}.cls-185{fill:#020202;}.cls-186{fill:#151515;}.cls-187{fill:url(#Degradado_sin_nombre_25-58);}.cls-188{fill:#131313;}.cls-18{stroke:url(#radial-gradient-38);}.cls-189{fill:url(#radial-gradient-40);}.cls-189,.cls-65,.cls-77,.cls-190,.cls-83{opacity:.35;}.cls-191{fill:url(#linear-gradient-91);}.cls-192{fill:url(#Degradado_sin_nombre_25-83);}.cls-193{fill:url(#Degradado_sin_nombre_25-80);}.cls-19{stroke:url(#radial-gradient-15);}.cls-194{fill:url(#Degradado_sin_nombre_209);}.cls-195{fill:url(#linear-gradient-60);}.cls-20{stroke-width:1.93px;}.cls-20,.cls-34{stroke:#fff;}.cls-94,.cls-196,.cls-197,.cls-198,.cls-199{mix-blend-mode:overlay;}.cls-200{fill:url(#Degradado_sin_nombre_2105);}.cls-201{fill:url(#Degradado_sin_nombre_25-71);}.cls-21{stroke:#bff2ff;stroke-width:1.58px;}.cls-63{fill:url(#Degradado_sin_nombre_19-17);}.cls-202{fill:url(#linear-gradient-108);}.cls-203{fill:url(#linear-gradient-84);}.cls-204{fill:url(#Degradado_sin_nombre_25-37);}.cls-205{fill:#0a0a0a;}.cls-206{fill:#303030;}.cls-207{fill:url(#Degradado_sin_nombre_2142);}.cls-208{fill:url(#Degradado_sin_nombre_25-23);}.cls-209{fill:url(#Degradado_sin_nombre_223-2);}.cls-64{fill:url(#Degradado_sin_nombre_19-11);}.cls-210{fill:url(#Degradado_sin_nombre_2065);}.cls-211{fill:url(#Degradado_sin_nombre_25-21);}.cls-65{fill:url(#radial-gradient-42);}.cls-212{fill:url(#Degradado_sin_nombre_2064);}.cls-95,.cls-106{opacity:.5;}.cls-213{fill:url(#Degradado_sin_nombre_25-79);}.cls-214{fill:url(#linear-gradient-104);}.cls-215{fill:url(#Degradado_sin_nombre_202);}.cls-216{fill:url(#linear-gradient-35);}.cls-217{fill:url(#Degradado_sin_nombre_2077);}.cls-218{fill:url(#linear-gradient-48);}.cls-219{fill:#232323;}.cls-220{fill:#1c1c1c;}.cls-221{fill:#2f2f2f;}.cls-222{fill:url(#Degradado_sin_nombre_25-63);}.cls-66{fill:url(#radial-gradient-47);}.cls-223{fill:url(#linear-gradient-32);}.cls-224{fill:url(#linear-gradient-120);}.cls-225{fill:url(#Degradado_sin_nombre_201-2);}.cls-226{fill:url(#Degradado_sin_nombre_2090);}.cls-227{fill:url(#linear-gradient-97);}.cls-228{fill:url(#Degradado_sin_nombre_2100);}.cls-229{fill:url(#Degradado_sin_nombre_211);}.cls-230{fill:url(#linear-gradient-11);}.cls-231{fill:url(#linear-gradient-50);}.cls-22{stroke:url(#radial-gradient-36);}.cls-23{stroke:url(#radial-gradient-19);}.cls-232{fill:url(#Degradado_sin_nombre_227);}.cls-233{fill:url(#linear-gradient-106);}.cls-234{fill:url(#linear-gradient-111);}.cls-235{fill:url(#Degradado_sin_nombre_2095);}.cls-236{fill:url(#Degradado_sin_nombre_25-65);}.cls-165{fill:#59d5f7;}.cls-237{fill:url(#Degradado_sin_nombre_214-2);}.cls-67{fill:url(#radial-gradient-43);opacity:.24;}.cls-238{fill:url(#Degradado_sin_nombre_2066);}.cls-239{fill:url(#linear-gradient-63);}.cls-240{fill:url(#linear-gradient-67);}.cls-241{fill:url(#Degradado_sin_nombre_2084);}.cls-105{fill:url(#linear-gradient-6);}.cls-242{fill:url(#linear-gradient-95);}.cls-243{fill:url(#Degradado_sin_nombre_25-14);}.cls-244{fill:url(#Degradado_sin_nombre_25-11);}.cls-245{fill:url(#Degradado_sin_nombre_2115);}.cls-24{stroke:url(#radial-gradient-26);}.cls-246{fill:url(#linear-gradient-86);}.cls-247{fill:url(#Degradado_sin_nombre_25-51);}.cls-248{fill:url(#linear-gradient-39);}.cls-249{fill:url(#Degradado_sin_nombre_2087);}.cls-25{stroke:url(#radial-gradient-32);}.cls-250{fill:url(#Degradado_sin_nombre_210);}.cls-251{fill:#1b1b1b;}.cls-252{fill:#111;}.cls-253{fill:url(#linear-gradient-110);}.cls-196{fill:url(#radial-gradient-45);}.cls-254{fill:url(#Degradado_sin_nombre_2071);}.cls-255{fill:url(#Degradado_sin_nombre_25-62);}.cls-256{fill:url(#linear-gradient-124);}.cls-257{fill:url(#Degradado_sin_nombre_25-35);}.cls-258{clip-path:url(#clippath-1);}.cls-259{fill:url(#Degradado_sin_nombre_230);}.cls-260{fill:url(#Degradado_sin_nombre_2108);}.cls-261{fill:url(#Degradado_sin_nombre_210-2);}.cls-262{fill:url(#Degradado_sin_nombre_2127);}.cls-263{fill:url(#linear-gradient-10);}.cls-68{fill:url(#linear-gradient-123);opacity:.2;}.cls-264{fill:url(#Degradado_sin_nombre_2075);}.cls-265{fill:url(#Degradado_sin_nombre_25-74);}.cls-26{stroke:url(#radial-gradient-7);}.cls-27{stroke:url(#radial-gradient-33);}.cls-266{fill:url(#Degradado_sin_nombre_2131);}.cls-267{fill:url(#Degradado_sin_nombre_225-2);}.cls-268{fill:url(#linear-gradient-59);}.cls-269{opacity:.34;}.cls-270{fill:url(#Degradado_sin_nombre_25-6);}.cls-271{fill:#2a2a2a;}.cls-69{fill:url(#Degradado_sin_nombre_19-3);}.cls-147,.cls-199{opacity:.39;}.cls-272{fill:#282828;}.cls-273{fill:#030303;}.cls-274{fill:url(#Degradado_sin_nombre_2061);}.cls-275{fill:url(#linear-gradient-117);}.cls-276{fill:#101010;}.cls-277{fill:url(#Degradado_sin_nombre_224);}.cls-278{fill:url(#Degradado_sin_nombre_222-2);}.cls-279,.cls-280{fill:#0c0816;}.cls-70{fill:url(#Degradado_sin_nombre_19-10);}.cls-281{fill:url(#Degradado_sin_nombre_232-2);}.cls-282{fill:url(#Degradado_sin_nombre_221-2);}.cls-283{fill:url(#Degradado_sin_nombre_25-50);}.cls-284{fill:url(#Degradado_sin_nombre_230-2);}.cls-285{fill:url(#Degradado_sin_nombre_2080);}.cls-71{fill:url(#radial-gradient-44);}.cls-286{fill:url(#Degradado_sin_nombre_228);}.cls-287{fill:url(#Degradado_sin_nombre_226-2);}.cls-288{fill:url(#Degradado_sin_nombre_25-82);}.cls-289{fill:url(#linear-gradient-49);}.cls-290{fill:url(#linear-gradient-37);}.cls-291{fill:url(#Degradado_sin_nombre_212-2);}.cls-72{fill:url(#radial-gradient-46);}.cls-148,.cls-149{opacity:.81;}.cls-292{fill:#0d0d0d;}.cls-293{fill:url(#linear-gradient-82);}.cls-294{fill:url(#Degradado_sin_nombre_25-73);}.cls-295{fill:#242424;}.cls-73{fill:url(#Degradado_sin_nombre_19-6);}.cls-296{fill:url(#linear-gradient-16);}.cls-297{fill:#080808;}.cls-298{fill:url(#Degradado_sin_nombre_2072);}.cls-299{fill:url(#Degradado_sin_nombre_2062);}.cls-300{fill:url(#Degradado_sin_nombre_220-2);}.cls-301{fill:url(#Degradado_sin_nombre_2111);}.cls-28{stroke:url(#radial-gradient-6);}.cls-302{fill:url(#Degradado_sin_nombre_229);}.cls-303{fill:url(#Degradado_sin_nombre_205-2);}.cls-304{fill:#272727;}.cls-305{fill:url(#linear-gradient-31);}.cls-29{stroke:url(#radial-gradient-18);}.cls-306{fill:url(#linear-gradient-85);}.cls-307{fill:url(#Degradado_sin_nombre_25-64);}.cls-308{fill:#351066;}.cls-30{stroke:url(#radial-gradient-17);}.cls-309{fill:url(#linear-gradient-127);}.cls-310{fill:url(#linear-gradient-112);}.cls-311{fill:url(#Degradado_sin_nombre_215-2);}.cls-312{fill:url(#Degradado_sin_nombre_2124);}.cls-313{fill:url(#Degradado_sin_nombre_203);}.cls-314{fill:url(#Degradado_sin_nombre_2133);}.cls-315{fill:url(#Degradado_sin_nombre_223);}.cls-316{fill:url(#linear-gradient-61);}.cls-317{fill:url(#Degradado_sin_nombre_2110);}.cls-318{fill:url(#linear-gradient-114);}.cls-319{fill:url(#linear-gradient-68);}.cls-320{fill:url(#Degradado_sin_nombre_25-54);}.cls-321{fill:url(#linear-gradient-103);}.cls-322{fill:url(#Degradado_sin_nombre_2109);}.cls-323{fill:url(#linear-gradient-62);}.cls-324{fill:url(#Degradado_sin_nombre_25);}.cls-325{fill:url(#linear-gradient-107);}.cls-326{fill:url(#linear-gradient-41);}.cls-327{fill:#181818;}.cls-328{fill:#2b2b2b;}.cls-329{fill:url(#Degradado_sin_nombre_2096);}.cls-330{fill:url(#linear-gradient-76);}.cls-331{fill:url(#Degradado_sin_nombre_25-55);}.cls-149{fill:url(#Degradado_sin_nombre_199);}.cls-332{fill:url(#linear-gradient-98);}.cls-333{fill:url(#Degradado_sin_nombre_208-2);}.cls-31{stroke:#00c9ff;stroke-width:.53px;}.cls-334{fill:url(#Degradado_sin_nombre_209-2);}.cls-335{fill:url(#Degradado_sin_nombre_214);}.cls-336{fill:url(#Degradado_sin_nombre_25-29);}.cls-337{fill:#482f68;}.cls-338{fill:url(#linear-gradient-21);}.cls-339{fill:url(#Degradado_sin_nombre_2101);}.cls-340{fill:url(#Degradado_sin_nombre_25-39);}.cls-341{fill:url(#linear-gradient-72);}.cls-342{fill:url(#Degradado_sin_nombre_2139);}.cls-343{fill:url(#Degradado_sin_nombre_200);}.cls-32{stroke:url(#radial-gradient-27);}.cls-344{fill:url(#Degradado_sin_nombre_25-59);}.cls-345{fill:url(#Degradado_sin_nombre_213);}.cls-346{fill:url(#Degradado_sin_nombre_2069);}.cls-347{fill:url(#Degradado_sin_nombre_2102);}.cls-348{fill:url(#Degradado_sin_nombre_2097);}.cls-349{fill:url(#Degradado_sin_nombre_2068);}.cls-350{fill:url(#Degradado_sin_nombre_2140);}.cls-33{stroke:url(#radial-gradient-23);}.cls-351{fill:url(#Degradado_sin_nombre_211-2);}.cls-352{fill:url(#Degradado_sin_nombre_2089);}.cls-353{fill:url(#linear-gradient-25);}.cls-354{fill:url(#linear-gradient-121);}.cls-355{fill:url(#linear-gradient-89);}.cls-356{fill:#171717;}.cls-357{fill:url(#Degradado_sin_nombre_203-2);}.cls-358{fill:url(#linear-gradient-5);}.cls-359{fill:url(#linear-gradient-64);}.cls-360{fill:#212121;}.cls-75{fill:url(#Degradado_sin_nombre_19-9);}.cls-361{fill:url(#Degradado_sin_nombre_25-22);}.cls-362{fill:url(#Degradado_sin_nombre_2136);}.cls-363{fill:url(#linear-gradient-102);}.cls-364{fill:url(#Degradado_sin_nombre_2070);}.cls-365{fill:url(#linear-gradient-83);}.cls-366{fill:url(#linear-gradient-54);}.cls-367{fill:url(#linear-gradient-45);}.cls-368{fill:url(#Degradado_sin_nombre_233);}.cls-369{fill:url(#Degradado_sin_nombre_232);}.cls-370{fill:#0e0e0e;}.cls-371{fill:url(#linear-gradient-113);}.cls-372{fill:url(#Degradado_sin_nombre_25-49);}.cls-373{fill:url(#linear-gradient-55);}.cls-374{clip-path:url(#clippath);}.cls-34{stroke-linecap:round;stroke-linejoin:round;stroke-width:2.03px;}.cls-375{fill:url(#Degradado_sin_nombre_25-32);}.cls-376{fill:url(#Degradado_sin_nombre_206);}.cls-377{fill:#2c2c2c;}.cls-378{fill:#1d1d1d;}.cls-379{fill:url(#Degradado_sin_nombre_25-13);}.cls-380{fill:url(#linear-gradient-34);}.cls-381{fill:url(#linear-gradient-118);}.cls-382{fill:url(#linear-gradient-65);}.cls-383{fill:url(#Degradado_sin_nombre_213-2);}.cls-384{fill:url(#linear-gradient-70);}.cls-385{fill:url(#Degradado_sin_nombre_2125);}.cls-76{fill:url(#Degradado_sin_nombre_19);}.cls-386{fill:#121212;}.cls-387{fill:#202020;}.cls-388{fill:url(#Degradado_sin_nombre_2063);}.cls-389{fill:#2e2e2e;}.cls-390{fill:url(#Degradado_sin_nombre_25-28);}.cls-391{fill:url(#Degradado_sin_nombre_228-2);}.cls-392{fill:url(#Degradado_sin_nombre_25-78);}.cls-393{fill:url(#Degradado_sin_nombre_25-40);}.cls-394{fill:url(#Degradado_sin_nombre_216-2);}.cls-395{fill:url(#Degradado_sin_nombre_25-8);}.cls-396{fill:url(#Degradado_sin_nombre_2103);}.cls-197{opacity:.3;}.cls-397{fill:url(#Degradado_sin_nombre_2091);}.cls-398{fill:url(#Degradado_sin_nombre_2079);}.cls-77{fill:url(#radial-gradient-41);}.cls-399{fill:url(#linear-gradient-79);}.cls-36{stroke:url(#radial-gradient-22);}.cls-78{fill:url(#Degradado_sin_nombre_19-16);}.cls-400{fill:#050505;}.cls-401{fill:#161616;}.cls-402{fill:url(#linear-gradient-88);}.cls-403{fill:#141414;}.cls-404{fill:url(#Degradado_sin_nombre_2137);}.cls-405{fill:url(#linear-gradient-7);}.cls-406{fill:url(#Degradado_sin_nombre_2120);}.cls-407{fill:url(#linear-gradient-134);}.cls-408{fill:url(#Degradado_sin_nombre_212);}.cls-409{fill:url(#Degradado_sin_nombre_227-2);}.cls-410{fill:url(#Degradado_sin_nombre_2092);}.cls-37{stroke:#40d7ff;stroke-width:.88px;}.cls-411{fill:url(#Degradado_sin_nombre_2104);}.cls-412{fill:url(#linear-gradient-66);}.cls-413{fill:#2d2d2d;}.cls-414{fill:url(#Degradado_sin_nombre_25-75);}.cls-415{fill:url(#Degradado_sin_nombre_2132);}.cls-416{fill:url(#Degradado_sin_nombre_25-70);}.cls-417{fill:#292929;}.cls-418{fill:url(#Degradado_sin_nombre_25-81);}.cls-419{fill:#0b0b0b;}.cls-420{fill:url(#Degradado_sin_nombre_61);}.cls-421{fill:url(#Degradado_sin_nombre_2112);}.cls-422{fill:#252525;}.cls-423{fill:url(#linear-gradient-96);}.cls-424{fill:url(#Degradado_sin_nombre_2119);}.cls-425{fill:url(#Degradado_sin_nombre_25-72);}.cls-79{fill:url(#radial-gradient-4);}.cls-107{fill:url(#linear-gradient-129);}.cls-426{fill:url(#Degradado_sin_nombre_217-2);}.cls-427{fill:url(#Degradado_sin_nombre_25-86);}.cls-428{fill:url(#linear-gradient-24);}.cls-108{fill:#af6bb2;opacity:.75;}.cls-429{fill:url(#Degradado_sin_nombre_25-34);}.cls-430{fill:url(#Degradado_sin_nombre_2067);}.cls-431{fill:url(#linear-gradient-73);}.cls-38{stroke:url(#radial-gradient-25);}.cls-190{fill:url(#radial-gradient-2);}.cls-432{fill:url(#linear-gradient-100);}.cls-433{fill:url(#Degradado_sin_nombre_206-2);}.cls-434{fill:url(#Degradado_sin_nombre_2074);}.cls-435{fill:url(#Degradado_sin_nombre_2107);}.cls-436{fill:url(#linear-gradient-105);}.cls-437{fill:url(#linear-gradient-9);}.cls-39{stroke:url(#radial-gradient-16);}.cls-438{fill:url(#Degradado_sin_nombre_205);}.cls-439{fill:url(#linear-gradient-22);}.cls-440{fill:#191919;}.cls-40{stroke:url(#radial-gradient-31);}.cls-441{fill:url(#Degradado_sin_nombre_25-17);}.cls-442{fill:url(#Degradado_sin_nombre_25-68);}.cls-443{fill:url(#linear-gradient-74);}.cls-41{stroke:url(#radial-gradient-11);}.cls-444{fill:url(#linear-gradient-42);}.cls-445{mask:url(#mask);}.cls-446{fill:url(#Degradado_sin_nombre_25-3);}.cls-447{fill:url(#Degradado_sin_nombre_25-76);}.cls-448{fill:#1f1f1f;}.cls-449{fill:url(#linear-gradient-99);}.cls-42{stroke:url(#radial-gradient-29);}.cls-450{fill:url(#Degradado_sin_nombre_202-2);}.cls-451{fill:url(#Degradado_sin_nombre_25-31);}.cls-452{fill:url(#Degradado_sin_nombre_2086);}.cls-453{fill:url(#linear-gradient-3);}.cls-454{fill:#1a1a1a;}.cls-455{fill:#00e1ff;}.cls-456{fill:url(#Degradado_sin_nombre_25-85);}.cls-457{fill:url(#Degradado_sin_nombre_25-56);}.cls-80{fill:url(#Degradado_sin_nombre_19-7);}.cls-458{fill:url(#Degradado_sin_nombre_25-16);}.cls-459{fill:url(#Degradado_sin_nombre_25-18);}.cls-460{fill:url(#linear-gradient);}.cls-461{fill:#070707;}.cls-462{fill:url(#Degradado_sin_nombre_233-2);}.cls-81{fill:url(#Degradado_sin_nombre_19-18);}.cls-82{fill:url(#Degradado_sin_nombre_19-13);}.cls-463{fill:url(#linear-gradient-27);}.cls-464{fill:url(#Degradado_sin_nombre_25-19);}.cls-465{fill:url(#Degradado_sin_nombre_217);}.cls-466{fill:url(#linear-gradient-116);}.cls-467{fill:url(#linear-gradient-132);}.cls-468{fill:url(#Degradado_sin_nombre_25-57);}.cls-469{fill:url(#Degradado_sin_nombre_2141);}.cls-470{fill:url(#linear-gradient-33);}.cls-471{fill:url(#linear-gradient-38);}.cls-472{fill:url(#Degradado_sin_nombre_25-41);}.cls-473{fill:url(#linear-gradient-94);}.cls-474{fill:url(#Degradado_sin_nombre_2118);}.cls-475{fill:url(#Degradado_sin_nombre_234-2);}.cls-476{fill:url(#linear-gradient-29);}.cls-477{fill:url(#Degradado_sin_nombre_224-2);}.cls-478{fill:url(#Degradado_sin_nombre_2116);}.cls-479{fill:url(#Degradado_sin_nombre_2117);}.cls-480{fill:url(#Degradado_sin_nombre_220);}.cls-280{opacity:.38;}.cls-481{fill:url(#linear-gradient-30);}.cls-482{fill:url(#Degradado_sin_nombre_2113);}.cls-43{stroke:url(#radial-gradient-21);}.cls-483{fill:url(#Degradado_sin_nombre_2093);}.cls-484{fill:url(#Degradado_sin_nombre_2094);}.cls-485{fill:#1e1e1e;}.cls-486{fill:url(#linear-gradient-126);}.cls-487{fill:url(#linear-gradient-23);}.cls-488{fill:url(#linear-gradient-19);}.cls-489{fill:url(#Degradado_sin_nombre_207);}.cls-490{fill:url(#Degradado_sin_nombre_25-15);}.cls-491{fill:url(#Degradado_sin_nombre_25-77);}.cls-492{fill:url(#Degradado_sin_nombre_25-61);}.cls-493{fill:url(#linear-gradient-71);}.cls-494{fill:url(#linear-gradient-4);}.cls-495{fill:url(#Degradado_sin_nombre_25-45);}.cls-496{fill:url(#linear-gradient-77);}.cls-497{fill:url(#Degradado_sin_nombre_2098);}.cls-498{fill:url(#Degradado_sin_nombre_25-42);}.cls-44{stroke:url(#radial-gradient-9);}.cls-499{fill:url(#Degradado_sin_nombre_25-44);}.cls-500{fill:url(#Degradado_sin_nombre_25-26);}.cls-501{fill:url(#Degradado_sin_nombre_222);}.cls-502{fill:url(#linear-gradient-115);}.cls-503{fill:url(#Degradado_sin_nombre_2129);}.cls-504{fill:url(#Degradado_sin_nombre_231-2);}.cls-505{fill:#010101;}.cls-506{fill:url(#linear-gradient-8);}.cls-507{fill:url(#Degradado_sin_nombre_25-69);}.cls-508{fill:url(#Degradado_sin_nombre_2122);}.cls-83{fill:url(#radial-gradient-3);}.cls-509{fill:url(#linear-gradient-90);}.cls-510{fill:url(#linear-gradient-44);}.cls-511{fill:url(#Degradado_sin_nombre_2073);}.cls-512{fill:url(#linear-gradient-57);}.cls-513{fill:url(#Degradado_sin_nombre_201);}.cls-514{fill:url(#Degradado_sin_nombre_25-47);}.cls-515{fill:#170c28;}.cls-516{fill:url(#linear-gradient-47);}.cls-517{fill:url(#linear-gradient-46);}.cls-518{fill:url(#Degradado_sin_nombre_204);}.cls-519{fill:url(#Degradado_sin_nombre_2078);}.cls-520{fill:url(#linear-gradient-12);}.cls-521{fill:#171415;}.cls-522{fill:url(#Degradado_sin_nombre_25-66);}.cls-523{fill:url(#linear-gradient-13);}.cls-45{stroke:url(#radial-gradient-34);}.cls-524{fill:url(#Degradado_sin_nombre_2114);}.cls-525{fill:#060606;}.cls-526{fill:url(#Degradado_sin_nombre_2121);}.cls-527{fill:url(#Degradado_sin_nombre_218);}.cls-528{fill:url(#linear-gradient-26);}.cls-110{opacity:.43;}.cls-529{fill:url(#linear-gradient-101);}.cls-530{fill:url(#Degradado_sin_nombre_216);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    width: 1272.5,
    height: 848.33
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 380.42,
    cy: 129.58,
    fx: 380.42,
    fy: 129.58,
    r: 137.96,
    gradientTransform: "translate(1191.69 -22.36) rotate(-180) scale(2.06 -2.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b5ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#60ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#02f7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#19b6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2c7ec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3c51b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#482ea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#51149c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#570596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#590094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#55008d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3e0068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2b0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1b002d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#0f0019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#06000a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "224.65 457.34 356.86 380.55 572.66 436.26 636.9 751.14 89.73 744.25 107.66 563.73 224.65 457.34"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19",
    cx: 3733.74,
    cy: 3079.27,
    fx: 3733.74,
    fy: 3079.27,
    r: 66.96,
    gradientTransform: "translate(2629.82 -5947.5) rotate(137.8) scale(2.49 -1.06) skewX(-22.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fffdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#00edff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#00bfeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#009bdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0085d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#007ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0070ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#00568e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#003f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#002b47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#001b2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#000f19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00060a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#000102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-2",
    cx: 3542.86,
    cy: 2665.99,
    fx: 3542.86,
    fy: 2665.99,
    r: 63.04,
    gradientTransform: "translate(-2272.82 6690.63) rotate(-41.33) scale(2.49 -1.06) skewX(-22.1)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-3",
    cx: 3657.79,
    cy: 2846.42,
    fx: 3657.79,
    fy: 2846.42,
    r: 63.04,
    gradientTransform: "translate(1795.09 13293.33) rotate(-57.85) scale(2.73 -2.78) skewX(1.28)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-4",
    cx: 3608.2,
    cy: 2798.78,
    fx: 3608.2,
    fy: 2798.78,
    r: 34.53,
    gradientTransform: "translate(1795.09 13293.33) rotate(-57.85) scale(2.73 -2.78) skewX(1.28)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_61",
    x1: 489.63,
    y1: 614.29,
    x2: 737.83,
    y2: 573.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13002a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0f2a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#05958a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d4b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#05d5b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#14d9b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2ee1b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ce5b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 645.05,
    y1: 616.21,
    x2: 397.28,
    y2: 667.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37006a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 407.81,
    cy: 2051.37,
    fx: 407.81,
    fy: 2051.37,
    r: 21.06,
    gradientTransform: "translate(1548.4 1181.97) rotate(-149.51) scale(3.04 -.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f1eaf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#cfb5e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#9760bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#590094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#55008d",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3e0068",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2b0047",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1b002d",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0f0019",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#06000a",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#010002",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 462.57,
    cy: 2404.38,
    fx: 462.57,
    fy: 2404.38,
    r: 21.06,
    gradientTransform: "translate(2599.71 -734.51) rotate(149.87) scale(5.31 -.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#55e3fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#55c7ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#5699d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5759bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#580898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#590094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#54008b",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#460075",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#300051",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#12001f",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 632.77,
    y1: 590.83,
    x2: 28.26,
    y2: 682.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1dbfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1fb5f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3362cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3c42b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3e39b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#402eae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#47149f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4b0597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4d0094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#441fa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3e38b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3c42b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#1f1354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13002a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -387.48,
    cy: 830.69,
    fx: -387.48,
    fy: 830.69,
    r: 56.16,
    gradientTransform: "translate(-270.78 4.41) rotate(-58.67) scale(.07 1.24) skewX(-.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fffdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#b5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ab40f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#901df0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7f07eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#7900e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6000ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4a008e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#360068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#250047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#17002d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0d0019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#05000a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 353.96,
    cy: 303.01,
    fx: 353.96,
    fy: 303.01,
    r: 183.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 350.14,
    cy: 301.05,
    fx: 350.14,
    fy: 301.05,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 346.33,
    cy: 299.1,
    fx: 346.33,
    fy: 299.1,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 342.51,
    cy: 297.14,
    fx: 342.51,
    fy: 297.14,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 338.69,
    cy: 295.18,
    fx: 338.69,
    fy: 295.18,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 334.87,
    cy: 293.22,
    fx: 334.87,
    fy: 293.22,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 331.05,
    cy: 291.26,
    fx: 331.05,
    fy: 291.26,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 327.24,
    cy: 289.3,
    fx: 327.24,
    fy: 289.3,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 323.42,
    cy: 287.34,
    fx: 323.42,
    fy: 287.34,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 319.6,
    cy: 285.38,
    fx: 319.6,
    fy: 285.38,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 315.78,
    cy: 283.43,
    fx: 315.78,
    fy: 283.43,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 311.96,
    cy: 281.47,
    fx: 311.96,
    fy: 281.47,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 308.15,
    cy: 279.51,
    fx: 308.15,
    fy: 279.51,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 304.33,
    cy: 277.55,
    fx: 304.33,
    fy: 277.55,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 300.51,
    cy: 275.59,
    fx: 300.51,
    fy: 275.59,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 296.69,
    cy: 273.63,
    fx: 296.69,
    fy: 273.63,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 292.87,
    cy: 271.67,
    fx: 292.87,
    fy: 271.67,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 289.06,
    cy: 269.71,
    fx: 289.06,
    fy: 269.71,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 350.14,
    cy: 301.05,
    fx: 350.14,
    fy: 301.05,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 346.33,
    cy: 299.1,
    fx: 346.33,
    fy: 299.1,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 342.51,
    cy: 297.14,
    fx: 342.51,
    fy: 297.14,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 338.69,
    cy: 295.18,
    fx: 338.69,
    fy: 295.18,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 334.87,
    cy: 293.22,
    fx: 334.87,
    fy: 293.22,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 331.05,
    cy: 291.26,
    fx: 331.05,
    fy: 291.26,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 327.24,
    cy: 289.3,
    fx: 327.24,
    fy: 289.3,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 323.42,
    cy: 287.34,
    fx: 323.42,
    fy: 287.34,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 319.6,
    cy: 285.38,
    fx: 319.6,
    fy: 285.38,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 315.78,
    cy: 283.43,
    fx: 315.78,
    fy: 283.43,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 311.96,
    cy: 281.47,
    fx: 311.96,
    fy: 281.47,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 308.15,
    cy: 279.51,
    fx: 308.15,
    fy: 279.51,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 304.33,
    cy: 277.55,
    fx: 304.33,
    fy: 277.55,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 300.51,
    cy: 275.59,
    fx: 300.51,
    fy: 275.59,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 296.69,
    cy: 273.63,
    fx: 296.69,
    fy: 273.63,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 292.87,
    cy: 271.67,
    fx: 292.87,
    fy: 271.67,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 289.06,
    cy: 269.71,
    fx: 289.06,
    fy: 269.71,
    r: 183.32,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_199",
    x1: 104.04,
    y1: 458,
    x2: 643.17,
    y2: 86.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003dc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36ffff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-5",
    cx: 3278,
    cy: 2414.86,
    fx: 3278,
    fy: 2414.86,
    r: 97,
    gradientTransform: "translate(-3725.31 4131.68) rotate(-32.85) scale(2.53 -.39) skewX(-25.15)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-6",
    cx: 3920.58,
    cy: 3257.55,
    fx: 3920.58,
    fy: 3257.55,
    r: 97,
    gradientTransform: "translate(-2061.2 -275.11) rotate(36.74) scale(.88 -.36) skewX(-22.4)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-7",
    cx: 3673.96,
    cy: 2719.63,
    fx: 3673.96,
    fy: 2719.63,
    r: 84.49,
    gradientTransform: "translate(512.97 3852.59) rotate(-55.34) scale(.82 -.79) skewX(-2.43)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-8",
    cx: 435.17,
    cy: 411.39,
    fx: 435.17,
    fy: 411.39,
    r: 56.15,
    gradientTransform: "translate(-82.92 -316.09) scale(.91 2.1)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2143",
    x1: 549.16,
    y1: 319.38,
    x2: 803.39,
    y2: 204.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#240848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#3b0872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#41087d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3f0d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3b1c89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392990"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 550.01,
    y1: 320.07,
    x2: 804.23,
    y2: 204.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13002a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2a0054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4d0094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4b0597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#47149f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#412eae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c42b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 554.31,
    y1: 318.17,
    x2: 25.5,
    y2: 583.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -743.17,
    y1: 2144.27,
    x2: -745.35,
    y2: 2142.09,
    gradientTransform: "translate(-214.64 -1435.53) rotate(150) scale(1.15 -.87) skewX(23.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25",
    x1: 505.04,
    y1: 444.26,
    x2: 917.13,
    y2: 309.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13002a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0f2a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#05958a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d4b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#02ceb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#08bfb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#13a5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#2181b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3454b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c42b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-2",
    x1: 555.6,
    y1: 387.45,
    x2: 690.67,
    y2: 536.72,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 584.01,
    y1: 437.72,
    x2: 665.18,
    y2: 437.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#040207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#12081a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#29123a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#481f66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662d91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-3",
    x1: 590.4,
    y1: 451.58,
    x2: 833.58,
    y2: 354.65,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 650.63,
    y1: 385.72,
    x2: 490.37,
    y2: 438.46,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 640.84,
    y1: 355.97,
    x2: 480.58,
    y2: 408.72,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 643.25,
    y1: 363.29,
    x2: 482.99,
    y2: 416.04,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 646.2,
    y1: 372.25,
    x2: 485.94,
    y2: 425,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 649.06,
    y1: 380.94,
    x2: 488.8,
    y2: 433.69,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 653.04,
    y1: 393.02,
    x2: 492.78,
    y2: 445.77,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 655.53,
    y1: 400.61,
    x2: 495.27,
    y2: 453.36,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 657.94,
    y1: 407.93,
    x2: 497.68,
    y2: 460.68,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 660.89,
    y1: 416.89,
    x2: 500.63,
    y2: 469.63,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 656.47,
    y1: 403.45,
    x2: 496.21,
    y2: 456.19,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 648.35,
    y1: 378.8,
    x2: 488.1,
    y2: 431.55,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 647.68,
    y1: 376.76,
    x2: 487.43,
    y2: 429.51,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 647.04,
    y1: 374.82,
    x2: 486.79,
    y2: 427.57,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 646.41,
    y1: 372.88,
    x2: 486.15,
    y2: 425.63,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 645.77,
    y1: 370.94,
    x2: 485.51,
    y2: 423.69,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 645.13,
    y1: 369,
    x2: 484.87,
    y2: 421.75,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 644.49,
    y1: 367.06,
    x2: 484.23,
    y2: 419.81,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 643.85,
    y1: 365.12,
    x2: 483.59,
    y2: 417.87,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 643.21,
    y1: 363.18,
    x2: 482.96,
    y2: 415.93,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 642.57,
    y1: 361.24,
    x2: 482.32,
    y2: 413.99,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 641.94,
    y1: 359.3,
    x2: 481.68,
    y2: 412.05,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 641.3,
    y1: 357.36,
    x2: 481.04,
    y2: 410.11,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 640.66,
    y1: 355.42,
    x2: 480.4,
    y2: 408.17,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 639.97,
    y1: 353.32,
    x2: 479.71,
    y2: 406.07,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 639.33,
    y1: 351.38,
    x2: 479.07,
    y2: 404.13,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 638.69,
    y1: 349.44,
    x2: 478.43,
    y2: 402.19,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 638.05,
    y1: 347.5,
    x2: 477.79,
    y2: 400.25,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 649.86,
    y1: 383.38,
    x2: 489.6,
    y2: 436.12,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 648.42,
    y1: 379.01,
    x2: 488.17,
    y2: 431.76,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 649.14,
    y1: 381.19,
    x2: 488.88,
    y2: 433.94,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 647.71,
    y1: 376.83,
    x2: 487.45,
    y2: 429.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 646.99,
    y1: 374.65,
    x2: 486.73,
    y2: 427.39,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 646.27,
    y1: 372.46,
    x2: 486.01,
    y2: 425.21,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 645.55,
    y1: 370.28,
    x2: 485.29,
    y2: 423.03,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 644.83,
    y1: 368.1,
    x2: 484.57,
    y2: 420.85,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 644.11,
    y1: 365.92,
    x2: 483.86,
    y2: 418.66,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 643.4,
    y1: 363.73,
    x2: 483.14,
    y2: 416.48,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 642.68,
    y1: 361.55,
    x2: 482.42,
    y2: 414.3,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 641.96,
    y1: 359.37,
    x2: 481.7,
    y2: 412.12,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 652.09,
    y1: 390.16,
    x2: 491.84,
    y2: 442.91,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 651.37,
    y1: 387.98,
    x2: 491.12,
    y2: 440.72,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 650.66,
    y1: 385.79,
    x2: 490.4,
    y2: 438.54,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 649.94,
    y1: 383.61,
    x2: 489.68,
    y2: 436.36,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 649.22,
    y1: 381.43,
    x2: 488.96,
    y2: 434.18,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 648.5,
    y1: 379.24,
    x2: 488.24,
    y2: 431.99,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 647.78,
    y1: 377.06,
    x2: 487.53,
    y2: 429.81,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 647.06,
    y1: 374.88,
    x2: 486.81,
    y2: 427.63,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 646.35,
    y1: 372.7,
    x2: 486.09,
    y2: 425.44,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 645.63,
    y1: 370.51,
    x2: 485.37,
    y2: 423.26,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 644.91,
    y1: 368.33,
    x2: 484.65,
    y2: 421.08,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 644.19,
    y1: 366.15,
    x2: 483.93,
    y2: 418.9,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 654.62,
    y1: 397.84,
    x2: 494.36,
    y2: 450.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 653.9,
    y1: 395.65,
    x2: 493.64,
    y2: 448.4,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 653.18,
    y1: 393.47,
    x2: 492.93,
    y2: 446.22,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 652.46,
    y1: 391.29,
    x2: 492.21,
    y2: 444.04,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 651.75,
    y1: 389.11,
    x2: 491.49,
    y2: 441.85,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 651.03,
    y1: 386.92,
    x2: 490.77,
    y2: 439.67,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 650.31,
    y1: 384.74,
    x2: 490.05,
    y2: 437.49,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 649.59,
    y1: 382.56,
    x2: 489.33,
    y2: 435.31,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 648.87,
    y1: 380.38,
    x2: 488.61,
    y2: 433.12,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 648.15,
    y1: 378.19,
    x2: 487.9,
    y2: 430.94,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 647.44,
    y1: 376.01,
    x2: 487.18,
    y2: 428.76,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 656,
    y1: 402.05,
    x2: 495.75,
    y2: 454.79,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 655.29,
    y1: 399.86,
    x2: 495.03,
    y2: 452.61,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 660.05,
    y1: 414.35,
    x2: 499.8,
    y2: 467.1,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 659.34,
    y1: 412.17,
    x2: 499.08,
    y2: 464.92,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 658.62,
    y1: 409.99,
    x2: 498.36,
    y2: 462.73,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 654.28,
    y1: 396.81,
    x2: 494.02,
    y2: 449.56,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 653.56,
    y1: 394.63,
    x2: 493.31,
    y2: 447.37,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 652.84,
    y1: 392.44,
    x2: 492.59,
    y2: 445.19,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 651.23,
    y1: 387.55,
    x2: 490.98,
    y2: 440.3,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 652.96,
    y1: 392.79,
    x2: 492.7,
    y2: 445.54,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 653.65,
    y1: 394.9,
    x2: 493.39,
    y2: 447.64,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 652.27,
    y1: 390.69,
    x2: 492.01,
    y2: 443.44,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 654.57,
    y1: 397.68,
    x2: 494.31,
    y2: 450.43,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 653.85,
    y1: 395.5,
    x2: 493.59,
    y2: 448.25,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 653.13,
    y1: 393.32,
    x2: 492.87,
    y2: 446.06,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 652.41,
    y1: 391.13,
    x2: 492.16,
    y2: 443.88,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 651.7,
    y1: 388.95,
    x2: 491.44,
    y2: 441.7,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 650.98,
    y1: 386.77,
    x2: 490.72,
    y2: 439.52,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 650.26,
    y1: 384.58,
    x2: 490,
    y2: 437.33,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 656.72,
    y1: 404.23,
    x2: 496.47,
    y2: 456.98,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-4",
    x1: 684.25,
    y1: 344.02,
    x2: 471.18,
    y2: 447.26,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-5",
    x1: 679.41,
    y1: 334.04,
    x2: 466.34,
    y2: 437.27,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-6",
    x1: 683.33,
    y1: 342.12,
    x2: 470.26,
    y2: 445.36,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-7",
    x1: 687.61,
    y1: 350.95,
    x2: 474.54,
    y2: 454.19,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-8",
    x1: 691.85,
    y1: 359.69,
    x2: 478.77,
    y2: 462.93,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-9",
    x1: 688.17,
    y1: 352.1,
    x2: 475.09,
    y2: 455.34,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-10",
    x1: 692.12,
    y1: 360.27,
    x2: 479.05,
    y2: 463.51,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-11",
    x1: 696.04,
    y1: 368.35,
    x2: 482.97,
    y2: 471.59,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-12",
    x1: 700.22,
    y1: 376.98,
    x2: 487.15,
    y2: 480.22,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-13",
    x1: 698.04,
    y1: 372.47,
    x2: 484.96,
    y2: 475.71,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-14",
    x1: 680.65,
    y1: 336.59,
    x2: 467.58,
    y2: 439.82,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-15",
    x1: 680.32,
    y1: 335.9,
    x2: 467.24,
    y2: 439.14,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-16",
    x1: 680,
    y1: 335.25,
    x2: 466.93,
    y2: 438.49,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-17",
    x1: 679.68,
    y1: 334.6,
    x2: 466.61,
    y2: 437.84,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-18",
    x1: 679.37,
    y1: 333.95,
    x2: 466.3,
    y2: 437.18,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-19",
    x1: 679.05,
    y1: 333.29,
    x2: 465.98,
    y2: 436.53,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-20",
    x1: 678.74,
    y1: 332.64,
    x2: 465.67,
    y2: 435.88,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-21",
    x1: 678.42,
    y1: 331.99,
    x2: 465.35,
    y2: 435.23,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-22",
    x1: 678.11,
    y1: 331.34,
    x2: 465.03,
    y2: 434.58,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-23",
    x1: 677.79,
    y1: 330.69,
    x2: 464.72,
    y2: 433.93,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-24",
    x1: 677.48,
    y1: 330.04,
    x2: 464.4,
    y2: 433.28,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-25",
    x1: 677.16,
    y1: 329.39,
    x2: 464.09,
    y2: 432.63,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-26",
    x1: 676.85,
    y1: 328.74,
    x2: 463.77,
    y2: 431.97,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-27",
    x1: 676.5,
    y1: 328.03,
    x2: 463.43,
    y2: 431.27,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-28",
    x1: 676.19,
    y1: 327.38,
    x2: 463.12,
    y2: 430.62,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-29",
    x1: 675.87,
    y1: 326.73,
    x2: 462.8,
    y2: 429.97,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-30",
    x1: 675.56,
    y1: 326.08,
    x2: 462.49,
    y2: 429.31,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-31",
    x1: 683.87,
    y1: 343.23,
    x2: 470.8,
    y2: 446.47,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-32",
    x1: 683.16,
    y1: 341.77,
    x2: 470.09,
    y2: 445.01,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-33",
    x1: 683.51,
    y1: 342.5,
    x2: 470.44,
    y2: 445.74,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-34",
    x1: 682.81,
    y1: 341.04,
    x2: 469.73,
    y2: 444.27,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-35",
    x1: 682.45,
    y1: 340.3,
    x2: 469.38,
    y2: 443.54,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-36",
    x1: 682.09,
    y1: 339.57,
    x2: 469.02,
    y2: 442.81,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-37",
    x1: 681.74,
    y1: 338.84,
    x2: 468.67,
    y2: 442.08,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-38",
    x1: 681.38,
    y1: 338.11,
    x2: 468.31,
    y2: 441.34,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-39",
    x1: 681.03,
    y1: 337.37,
    x2: 467.96,
    y2: 440.61,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-40",
    x1: 680.68,
    y1: 336.64,
    x2: 467.6,
    y2: 439.88,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-41",
    x1: 680.32,
    y1: 335.91,
    x2: 467.25,
    y2: 439.14,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-42",
    x1: 679.96,
    y1: 335.17,
    x2: 466.89,
    y2: 438.41,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-43",
    x1: 687.7,
    y1: 351.14,
    x2: 474.63,
    y2: 454.37,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-44",
    x1: 687.34,
    y1: 350.4,
    x2: 474.27,
    y2: 453.64,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-45",
    x1: 686.99,
    y1: 349.67,
    x2: 473.92,
    y2: 452.91,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-46",
    x1: 686.63,
    y1: 348.94,
    x2: 473.56,
    y2: 452.18,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-47",
    x1: 686.28,
    y1: 348.21,
    x2: 473.21,
    y2: 451.44,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-48",
    x1: 685.92,
    y1: 347.47,
    x2: 472.85,
    y2: 450.71,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-49",
    x1: 685.57,
    y1: 346.74,
    x2: 472.5,
    y2: 449.98,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-50",
    x1: 685.21,
    y1: 346.01,
    x2: 472.14,
    y2: 449.25,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-51",
    x1: 684.86,
    y1: 345.27,
    x2: 471.79,
    y2: 448.51,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-52",
    x1: 684.5,
    y1: 344.54,
    x2: 471.43,
    y2: 447.78,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-53",
    x1: 684.15,
    y1: 343.81,
    x2: 471.08,
    y2: 447.05,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-54",
    x1: 683.79,
    y1: 343.08,
    x2: 470.72,
    y2: 446.31,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-55",
    x1: 691.77,
    y1: 359.54,
    x2: 478.7,
    y2: 462.78,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-56",
    x1: 691.42,
    y1: 358.81,
    x2: 478.34,
    y2: 462.05,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-57",
    x1: 691.06,
    y1: 358.08,
    x2: 477.99,
    y2: 461.31,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-58",
    x1: 690.71,
    y1: 357.34,
    x2: 477.63,
    y2: 460.58,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-59",
    x1: 690.35,
    y1: 356.61,
    x2: 477.28,
    y2: 459.85,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-60",
    x1: 690,
    y1: 355.88,
    x2: 476.92,
    y2: 459.11,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-61",
    x1: 689.64,
    y1: 355.14,
    x2: 476.57,
    y2: 458.38,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-62",
    x1: 689.29,
    y1: 354.41,
    x2: 476.21,
    y2: 457.65,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-63",
    x1: 688.93,
    y1: 353.68,
    x2: 475.86,
    y2: 456.92,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-64",
    x1: 688.58,
    y1: 352.95,
    x2: 475.5,
    y2: 456.18,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-65",
    x1: 688.22,
    y1: 352.21,
    x2: 475.15,
    y2: 455.45,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-66",
    x1: 695.08,
    y1: 366.38,
    x2: 482.01,
    y2: 469.62,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-67",
    x1: 694.73,
    y1: 365.64,
    x2: 481.66,
    y2: 468.88,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-68",
    x1: 699.81,
    y1: 376.13,
    x2: 486.74,
    y2: 479.37,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-69",
    x1: 699.45,
    y1: 375.4,
    x2: 486.38,
    y2: 478.64,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-70",
    x1: 699.1,
    y1: 374.67,
    x2: 486.03,
    y2: 477.91,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-71",
    x1: 696.96,
    y1: 370.25,
    x2: 483.89,
    y2: 473.48,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-72",
    x1: 696.6,
    y1: 369.51,
    x2: 483.53,
    y2: 472.75,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-73",
    x1: 696.25,
    y1: 368.78,
    x2: 483.18,
    y2: 472.02,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-74",
    x1: 695.21,
    y1: 366.64,
    x2: 482.14,
    y2: 469.88,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-75",
    x1: 697.88,
    y1: 372.16,
    x2: 484.81,
    y2: 475.4,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-76",
    x1: 698.23,
    y1: 372.86,
    x2: 485.16,
    y2: 476.1,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-77",
    x1: 697.54,
    y1: 371.45,
    x2: 484.47,
    y2: 474.69,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-78",
    x1: 694.37,
    y1: 364.91,
    x2: 481.3,
    y2: 468.15,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-79",
    x1: 694.02,
    y1: 364.18,
    x2: 480.95,
    y2: 467.42,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-80",
    x1: 693.66,
    y1: 363.45,
    x2: 480.59,
    y2: 466.68,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-81",
    x1: 693.31,
    y1: 362.71,
    x2: 480.24,
    y2: 465.95,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-82",
    x1: 692.95,
    y1: 361.98,
    x2: 479.88,
    y2: 465.22,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-83",
    x1: 692.6,
    y1: 361.25,
    x2: 479.53,
    y2: 464.49,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-84",
    x1: 692.24,
    y1: 360.52,
    x2: 479.17,
    y2: 463.75,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-85",
    x1: 695.44,
    y1: 367.11,
    x2: 482.37,
    y2: 470.35,
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 668.62,
    y1: 351.44,
    x2: 710.74,
    y2: 315.91,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 416.61,
    cy: 1213.54,
    fx: 416.61,
    fy: 1213.54,
    r: 21.06,
    gradientTransform: "translate(1628.46 1046) rotate(-149.51) scale(3.04 -.06)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_25-86",
    x1: 411.58,
    y1: 1960.97,
    x2: 449.31,
    y2: 1960.97,
    gradientTransform: "translate(2341.62 -1179.41) rotate(149.87) scale(5.31 -.28)",
    xlinkHref: "#Degradado_sin_nombre_25"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 429.75,
    cy: 1217.76,
    fx: 429.75,
    fy: 1217.76,
    r: 21.06,
    gradientTransform: "translate(2347.56 -882.22) rotate(149.87) scale(5.02 -.07)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 529.54,
    cy: 1474.81,
    fx: 529.54,
    fy: 1474.81,
    r: 21.06,
    gradientTransform: "translate(340.18 -1073.83) rotate(90.1) scale(2.74 -.07)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 438.71,
    cy: 1566.09,
    fx: 438.71,
    fy: 1566.09,
    r: 21.06,
    gradientTransform: "translate(2377.61 -832.24) rotate(149.49) scale(5.02 -.07)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2142",
    x1: 109.23,
    y1: 482.29,
    x2: 155.25,
    y2: 530.64,
    gradientTransform: "translate(14.6) scale(.9 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#190f29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#160b26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2141",
    x1: 108.59,
    y1: 480.37,
    x2: 156.45,
    y2: 530.67,
    gradientTransform: "translate(29.21) scale(.8 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b112b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150b24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2140",
    x1: 107.69,
    y1: 477.83,
    x2: 157.99,
    y2: 530.69,
    gradientTransform: "translate(43.81) scale(.7 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d142c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#140a22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2139",
    x1: 106.39,
    y1: 474.32,
    x2: 160.04,
    y2: 530.7,
    gradientTransform: "translate(58.42) scale(.6 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f162d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120a20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2138",
    x1: 104.45,
    y1: 469.26,
    x2: 162.91,
    y2: 530.69,
    gradientTransform: "translate(73.02) scale(.5 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22192f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11091e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2137",
    x1: 101.35,
    y1: 461.43,
    x2: 167.22,
    y2: 530.65,
    gradientTransform: "translate(87.63) scale(.4 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#241c30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10081c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2136",
    x1: 95.9,
    y1: 448.07,
    x2: 174.4,
    y2: 530.56,
    gradientTransform: "translate(102.23) scale(.3 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#261e31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f081a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2135",
    x1: 84.6,
    y1: 420.86,
    x2: 188.74,
    y2: 530.3,
    gradientTransform: "translate(116.84) scale(.2 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#282132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e0718"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2134",
    x1: 49.89,
    y1: 338.31,
    x2: 231.78,
    y2: 529.45,
    gradientTransform: "translate(131.44) scale(.1 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0716"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2133",
    x1: -8481.81,
    y1: 3649.83,
    x2: -8459.16,
    y2: 3673.64,
    gradientTransform: "translate(146.05) scale(0 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c2635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c0614"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2132",
    x1: -144.41,
    y1: 318.73,
    x2: 56,
    y2: 529.33,
    gradientTransform: "translate(160.65) rotate(-180) scale(.1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e2936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0512"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2131",
    x1: -21.76,
    y1: 401.54,
    x2: 100.75,
    y2: 530.28,
    gradientTransform: "translate(175.26) rotate(-180) scale(.2 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#302b38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090510"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2130",
    x1: 19.02,
    y1: 429.06,
    x2: 115.67,
    y2: 530.63,
    gradientTransform: "translate(189.86) rotate(-180) scale(.3 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#322e39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08040e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2129",
    x1: 39.35,
    y1: 442.79,
    x2: 123.13,
    y2: 530.83,
    gradientTransform: "translate(204.47) rotate(-180) scale(.4 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34303a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07040c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2128",
    x1: 51.51,
    y1: 451.01,
    x2: 127.6,
    y2: 530.97,
    gradientTransform: "translate(219.07) rotate(-180) scale(.5 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#36333b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06030a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2127",
    x1: 59.6,
    y1: 456.48,
    x2: 130.59,
    y2: 531.08,
    gradientTransform: "translate(233.68) rotate(-180) scale(.6 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39363d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050208"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2126",
    x1: 65.37,
    y1: 460.39,
    x2: 132.72,
    y2: 531.17,
    gradientTransform: "translate(248.28) rotate(-180) scale(.7 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b383e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030206"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2125",
    x1: 69.68,
    y1: 463.33,
    x2: 134.32,
    y2: 531.25,
    gradientTransform: "translate(262.89) rotate(-180) scale(.8 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d3b3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2124",
    x1: 73.04,
    y1: 465.62,
    x2: 135.56,
    y2: 531.32,
    gradientTransform: "translate(277.49) rotate(-180) scale(.9 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3d41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 75.72,
    y1: 467.46,
    x2: 136.55,
    y2: 531.39,
    gradientTransform: "translate(292.1) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2123",
    x1: 177.8,
    y1: 508.17,
    x2: -46.71,
    y2: 729.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#47346d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#48306b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#482f6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#482d6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#48306b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#462d66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2122",
    x1: 177.8,
    y1: 508.18,
    x2: -46.61,
    y2: 729.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#453972"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#47306e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#47306d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#482c6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#47306e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#442c64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2121",
    x1: 177.81,
    y1: 508.18,
    x2: -46.52,
    y2: 729.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#443e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#473170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#473070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#472f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#492a6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#473170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#432a62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2120",
    x1: 177.81,
    y1: 508.19,
    x2: -46.42,
    y2: 728.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#42437d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#463273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#473072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#472e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#49296e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#463273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41295f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2119",
    x1: 177.82,
    y1: 508.2,
    x2: -46.32,
    y2: 728.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#414882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#463276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#463175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#472c72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#492770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#482870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#463276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f275d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2118",
    x1: 177.83,
    y1: 508.21,
    x2: -46.22,
    y2: 728.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3f4d87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#463379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#463178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#472a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#492571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#472973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#463379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d255b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2117",
    x1: 177.83,
    y1: 508.22,
    x2: -46.13,
    y2: 728.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3e528c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#45347c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#46317a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#472975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#492473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#472a76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#45347c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b2459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2116",
    x1: 177.84,
    y1: 508.22,
    x2: -46.03,
    y2: 728.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3c5792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3c5490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#45347e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#45327d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#472777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#492274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#472a78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#45347e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392257"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2115",
    x1: 177.84,
    y1: 508.23,
    x2: -45.93,
    y2: 728.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3b5c97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3c5593"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#443581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#453280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#482579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4a2076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#462b7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#443581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#43347f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#382055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2114",
    x1: 177.85,
    y1: 508.24,
    x2: -45.84,
    y2: 728.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#39619c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#3b5696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#443684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#453282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#48247a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4a1f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#462c7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#443684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#42327d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361f53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2113",
    x1: 177.86,
    y1: 508.25,
    x2: -45.74,
    y2: 728.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3866a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3b5698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#433687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#443385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#443184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#48227b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4a1d79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#452c81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#433687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3f307a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#341d50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2112",
    x1: 177.86,
    y1: 508.26,
    x2: -45.64,
    y2: 728.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#366ba6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3a579b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#43378a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#443387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#443085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#48217d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4a1c7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#452d84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#43378a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3d2f78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#321c4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2111",
    x1: 177.87,
    y1: 508.27,
    x2: -45.55,
    y2: 728.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3570ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#3a589e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#43388c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#44338a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#442e87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#481f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4a1a7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#452e87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#43388c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3c2d76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#301a4c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2110",
    x1: 177.87,
    y1: 508.27,
    x2: -45.45,
    y2: 728.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3375b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#3958a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#42388f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#43348d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#442c88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#481d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4a187d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#442e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#42388f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#3a2b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e184a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2109",
    x1: 177.88,
    y1: 508.28,
    x2: -45.35,
    y2: 728.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3279b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#3959a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#423992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#43348f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#452b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#491c81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4b177f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#442f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#423992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#382a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d1748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2108",
    x1: 177.88,
    y1: 508.29,
    x2: -45.26,
    y2: 727.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#307ebb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3859a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#413995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#423592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#45298b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#491a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4b1580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4a1681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#432f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#413995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#362870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b1546"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2107",
    x1: 177.89,
    y1: 508.3,
    x2: -45.16,
    y2: 727.89,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2f83c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#385aa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#413a97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#423595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#45278d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#491885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4b1382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#491784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#433092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#413a97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#35266e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#291344"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2106",
    x1: 177.9,
    y1: 508.31,
    x2: -45.06,
    y2: 727.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2d88c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#385bac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#413b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#423597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#45268e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#491786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4b1283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#491886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#433194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#413b9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#33256c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2105",
    x1: 177.9,
    y1: 508.31,
    x2: -44.97,
    y2: 727.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2c8dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#385baf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#403b9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#41369a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#452490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#491587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4b1085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#481889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#423197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#403b9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#312369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25103f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2104",
    x1: 177.91,
    y1: 508.32,
    x2: -44.87,
    y2: 727.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2a92d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#375cb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#403ca0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#41369c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#452391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#491489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4b0f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#48198c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#42329a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#403ca0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2f2267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#230f3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2103",
    x1: 177.91,
    y1: 508.33,
    x2: -44.77,
    y2: 727.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2997d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#375db5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3f3da3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#41369f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#462193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4a128b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4c0d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#481a8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#41339d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3f3da3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2d2065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#220d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2102",
    x1: 177.92,
    y1: 508.34,
    x2: -44.68,
    y2: 727.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#279cdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#365db7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3f3da5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4037a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#461f94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4a108c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4c0b89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#471a91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#41339f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3f3da5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2c1e63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200b39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2101",
    x1: 177.93,
    y1: 508.35,
    x2: -44.58,
    y2: 727.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#26a1e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#365eba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3e3ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4037a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#461e96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4a0f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4c0a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#471b94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4034a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3e3ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a1d61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e0a37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2100",
    x1: 177.93,
    y1: 508.36,
    x2: -44.48,
    y2: 727.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#24a6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#355fbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3e3fab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4037a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4036a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#461c98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4a0d8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4c088c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#461c97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4035a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3e3fab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#281b5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c0835"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2099",
    x1: 177.94,
    y1: 508.36,
    x2: -44.39,
    y2: 727.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#23abea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#355fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3e3fae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3f38aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#3f34a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#461a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4a0b91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4c068e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#461c9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4035a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3e3fae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#26195d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2098",
    x1: 177.94,
    y1: 508.37,
    x2: -44.29,
    y2: 727.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#21b0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3460c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3d40b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3f38ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#4033a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#46199a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4a0a92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4c058f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#451d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3f36ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3d40b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#24185a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2097",
    x1: 177.95,
    y1: 508.38,
    x2: -44.19,
    y2: 727.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#20b5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#20b4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3461c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3d41b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3f38af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#4031ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#47179c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4b0894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4d0391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#451ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3f37ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3d41b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#231658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17032e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2096",
    x1: 177.96,
    y1: 508.39,
    x2: -44.1,
    y2: 727,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1ebafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1fb4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3361c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3c41b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3e39b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#4030ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#47169d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4b0795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4d0292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#451ea2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3e37b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3c41b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#211556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15022c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 177.96,
    y1: 508.4,
    x2: -44,
    y2: 726.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2095",
    x1: 115.98,
    y1: 548.41,
    x2: 120.22,
    y2: 548.41,
    gradientTransform: "translate(8.11) scale(.94 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2094",
    x1: 114.12,
    y1: 548.4,
    x2: 118.59,
    y2: 548.4,
    gradientTransform: "translate(16.23) scale(.89 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2093",
    x1: 112,
    y1: 548.4,
    x2: 116.73,
    y2: 548.4,
    gradientTransform: "translate(24.34) scale(.83 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#050506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2092",
    x1: 109.59,
    y1: 548.39,
    x2: 114.62,
    y2: 548.39,
    gradientTransform: "translate(32.46) scale(.78 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#040304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#070707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#040304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2091",
    x1: 106.8,
    y1: 548.39,
    x2: 112.18,
    y2: 548.39,
    gradientTransform: "translate(40.57) scale(.72 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#050404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#050404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2090",
    x1: 103.54,
    y1: 548.38,
    x2: 109.33,
    y2: 548.38,
    gradientTransform: "translate(48.68) scale(.67 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#060505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#060505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2089",
    x1: 99.7,
    y1: 548.38,
    x2: 105.96,
    y2: 548.38,
    gradientTransform: "translate(56.8) scale(.61 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#070606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0d0c0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#070606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2088",
    x1: 95.08,
    y1: 548.37,
    x2: 101.92,
    y2: 548.37,
    gradientTransform: "translate(64.91) scale(.56 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#080707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0e0e0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#080707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2087",
    x1: 89.44,
    y1: 548.37,
    x2: 96.99,
    y2: 548.37,
    gradientTransform: "translate(73.02) scale(.5 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#090808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#101011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#090808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2086",
    x1: 82.39,
    y1: 548.36,
    x2: 90.82,
    y2: 548.36,
    gradientTransform: "translate(81.14) scale(.44 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0a0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0a0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2085",
    x1: 73.32,
    y1: 548.36,
    x2: 82.88,
    y2: 548.36,
    gradientTransform: "translate(89.25) scale(.39 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0b090a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0b090a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2084",
    x1: 61.24,
    y1: 548.35,
    x2: 72.31,
    y2: 548.35,
    gradientTransform: "translate(97.37) scale(.33 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0c0a0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#161516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0c0a0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2083",
    x1: 44.31,
    y1: 548.35,
    x2: 57.5,
    y2: 548.35,
    gradientTransform: "translate(105.48) scale(.28 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0d0b0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#171718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0d0b0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2082",
    x1: 18.93,
    y1: 548.35,
    x2: 35.28,
    y2: 548.35,
    gradientTransform: "translate(113.59) scale(.22 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0e0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#19191a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0e0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2081",
    x1: -23.38,
    y1: 548.34,
    x2: -1.74,
    y2: 548.34,
    gradientTransform: "translate(121.71) scale(.17 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0f0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1b1b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0f0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2080",
    x1: -107.99,
    y1: 548.34,
    x2: -75.78,
    y2: 548.34,
    gradientTransform: "translate(129.82) scale(.11 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#100e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1d1c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#100e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2079",
    x1: -361.83,
    y1: 548.33,
    x2: -297.9,
    y2: 548.33,
    gradientTransform: "translate(137.94) scale(.06 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#110f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1f1e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#110f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2078",
    x1: 117.85,
    y1: 548.33,
    x2: 121.37,
    y2: 548.33,
    gradientTransform: "translate(146.05) scale(0 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#110f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#202021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#110f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2077",
    x1: 590.58,
    y1: 548.32,
    x2: 653.52,
    y2: 548.32,
    gradientTransform: "translate(154.16) rotate(-180) scale(.06 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#121011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#222223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#121011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2076",
    x1: 368.46,
    y1: 548.32,
    x2: 399.69,
    y2: 548.32,
    gradientTransform: "translate(162.28) rotate(-180) scale(.11 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#131112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#242425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#131112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2075",
    x1: 294.42,
    y1: 548.31,
    x2: 315.07,
    y2: 548.31,
    gradientTransform: "translate(170.39) rotate(-180) scale(.17 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#141213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#262526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#141213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2074",
    x1: 257.4,
    y1: 548.31,
    x2: 272.77,
    y2: 548.31,
    gradientTransform: "translate(178.5) rotate(-180) scale(.22 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#151314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#282728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#151314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2073",
    x1: 235.18,
    y1: 548.3,
    x2: 247.38,
    y2: 548.3,
    gradientTransform: "translate(186.62) rotate(-180) scale(.28 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#161414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2a292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#161414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2072",
    x1: 220.37,
    y1: 548.3,
    x2: 230.46,
    y2: 548.3,
    gradientTransform: "translate(194.73) rotate(-180) scale(.33 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#171515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2b2b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#171515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2071",
    x1: 209.8,
    y1: 548.29,
    x2: 218.37,
    y2: 548.29,
    gradientTransform: "translate(202.85) rotate(-180) scale(.39 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#181616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2d2c2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#181616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2070",
    x1: 201.86,
    y1: 548.29,
    x2: 209.31,
    y2: 548.29,
    gradientTransform: "translate(210.96) rotate(-180) scale(.44 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#191617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2f2e30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#191617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2069",
    x1: 195.69,
    y1: 548.28,
    x2: 202.26,
    y2: 548.28,
    gradientTransform: "translate(219.07) rotate(-180) scale(.5 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1a1718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#313031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1a1718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2068",
    x1: 190.75,
    y1: 548.28,
    x2: 196.62,
    y2: 548.28,
    gradientTransform: "translate(227.19) rotate(-180) scale(.56 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1b1819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#333233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1b1819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2067",
    x1: 186.71,
    y1: 548.27,
    x2: 192,
    y2: 548.27,
    gradientTransform: "translate(235.3) rotate(-180) scale(.61 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1c191a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#343435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1c191a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2066",
    x1: 183.35,
    y1: 548.27,
    x2: 188.15,
    y2: 548.27,
    gradientTransform: "translate(243.42) rotate(-180) scale(.67 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1d1a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#363537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1d1a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2065",
    x1: 180.5,
    y1: 548.27,
    x2: 184.9,
    y2: 548.27,
    gradientTransform: "translate(251.53) rotate(-180) scale(.72 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1e1b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1e1b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2064",
    x1: 178.05,
    y1: 548.26,
    x2: 182.11,
    y2: 548.26,
    gradientTransform: "translate(259.64) rotate(-180) scale(.78 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1f1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1f1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2063",
    x1: 175.93,
    y1: 548.26,
    x2: 179.69,
    y2: 548.26,
    gradientTransform: "translate(267.76) rotate(-180) scale(.83 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#201c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3c3b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#201c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2062",
    x1: 174.08,
    y1: 548.25,
    x2: 177.58,
    y2: 548.25,
    gradientTransform: "translate(275.87) rotate(-180) scale(.89 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#211d1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3d3c3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#211d1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2061",
    x1: 172.44,
    y1: 548.25,
    x2: 175.71,
    y2: 548.25,
    gradientTransform: "translate(283.99) rotate(-180) scale(.94 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#221e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3f3e40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#221e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 170.99,
    y1: 548.24,
    x2: 174.05,
    y2: 548.24,
    gradientTransform: "translate(292.1) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 106.26,
    y1: 530.36,
    x2: 169.62,
    y2: 530.36,
    gradientTransform: "translate(292.1) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f003c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_234",
    x1: 116.85,
    y1: 503.65,
    x2: 119.03,
    y2: 503.65,
    gradientTransform: "translate(8.11) scale(.94 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_233",
    x1: 115.03,
    y1: 503.65,
    x2: 117.33,
    y2: 503.65,
    gradientTransform: "translate(16.23) scale(.89 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_232",
    x1: 112.97,
    y1: 503.65,
    x2: 115.41,
    y2: 503.65,
    gradientTransform: "translate(24.34) scale(.83 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_231",
    x1: 110.61,
    y1: 503.65,
    x2: 113.22,
    y2: 503.65,
    gradientTransform: "translate(32.46) scale(.78 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#040304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0c0c0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#040304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_230",
    x1: 107.9,
    y1: 503.65,
    x2: 110.68,
    y2: 503.65,
    gradientTransform: "translate(40.57) scale(.72 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#050404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0f0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#050404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_229",
    x1: 104.72,
    y1: 503.65,
    x2: 107.73,
    y2: 503.65,
    gradientTransform: "translate(48.68) scale(.67 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#060505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#121213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#060505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_228",
    x1: 100.98,
    y1: 503.65,
    x2: 104.23,
    y2: 503.65,
    gradientTransform: "translate(56.8) scale(.61 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#070606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#151516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#070606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_227",
    x1: 96.48,
    y1: 503.65,
    x2: 100.04,
    y2: 503.65,
    gradientTransform: "translate(64.91) scale(.56 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#080707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#181819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#080707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_226",
    x1: 90.99,
    y1: 503.65,
    x2: 94.92,
    y2: 503.65,
    gradientTransform: "translate(73.02) scale(.5 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#090808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1b1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#090808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_225",
    x1: 84.12,
    y1: 503.65,
    x2: 88.51,
    y2: 503.65,
    gradientTransform: "translate(81.14) scale(.44 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0a0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1e1f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0a0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_224",
    x1: 75.28,
    y1: 503.65,
    x2: 80.28,
    y2: 503.65,
    gradientTransform: "translate(89.25) scale(.39 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0b090a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#212223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0b090a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_223",
    x1: 63.51,
    y1: 503.65,
    x2: 69.3,
    y2: 503.65,
    gradientTransform: "translate(97.37) scale(.33 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0c0a0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#242526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0c0a0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_222",
    x1: 47.02,
    y1: 503.65,
    x2: 53.92,
    y2: 503.65,
    gradientTransform: "translate(105.48) scale(.28 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0d0b0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#272829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0d0b0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_221",
    x1: 22.29,
    y1: 503.65,
    x2: 30.86,
    y2: 503.65,
    gradientTransform: "translate(113.59) scale(.22 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0e0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2a2b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0e0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_220",
    x1: -18.92,
    y1: 503.65,
    x2: -7.57,
    y2: 503.65,
    gradientTransform: "translate(121.71) scale(.17 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0f0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2d2e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0f0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_219",
    x1: -101.36,
    y1: 503.65,
    x2: -84.43,
    y2: 503.65,
    gradientTransform: "translate(129.82) scale(.11 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#100e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#303132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#100e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_218",
    x1: -348.66,
    y1: 503.65,
    x2: -315.02,
    y2: 503.65,
    gradientTransform: "translate(137.94) scale(.06 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#110f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#333435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#110f0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_217",
    x1: 118.57,
    y1: 503.65,
    x2: 120.43,
    y2: 503.65,
    gradientTransform: "translate(146.05) scale(0 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#110f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#363738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#110f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_216",
    x1: 607.33,
    y1: 503.65,
    x2: 640.54,
    y2: 503.65,
    gradientTransform: "translate(154.16) rotate(-180) scale(.06 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#121011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3a3a3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#121011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_215",
    x1: 376.74,
    y1: 503.64,
    x2: 393.24,
    y2: 503.64,
    gradientTransform: "translate(162.28) rotate(-180) scale(.11 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#131112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3d3d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#131112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_214",
    x1: 299.88,
    y1: 503.64,
    x2: 310.81,
    y2: 503.64,
    gradientTransform: "translate(170.39) rotate(-180) scale(.17 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#141213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#404042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#141213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_213",
    x1: 261.45,
    y1: 503.64,
    x2: 269.59,
    y2: 503.64,
    gradientTransform: "translate(178.5) rotate(-180) scale(.22 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#151314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#434345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#151314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_212",
    x1: 238.39,
    y1: 503.64,
    x2: 244.86,
    y2: 503.64,
    gradientTransform: "translate(186.62) rotate(-180) scale(.28 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#161414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#464648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#161414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_211",
    x1: 223.02,
    y1: 503.64,
    x2: 228.37,
    y2: 503.64,
    gradientTransform: "translate(194.73) rotate(-180) scale(.33 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#171515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#49494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#171515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_210",
    x1: 212.04,
    y1: 503.64,
    x2: 216.6,
    y2: 503.64,
    gradientTransform: "translate(202.85) rotate(-180) scale(.39 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#181616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4c4c4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#181616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_209",
    x1: 203.8,
    y1: 503.64,
    x2: 207.77,
    y2: 503.64,
    gradientTransform: "translate(210.96) rotate(-180) scale(.44 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#191617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4f4f52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#191617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_208",
    x1: 197.4,
    y1: 503.64,
    x2: 200.9,
    y2: 503.64,
    gradientTransform: "translate(219.07) rotate(-180) scale(.5 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1a1718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#525255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1a1718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_207",
    x1: 192.27,
    y1: 503.64,
    x2: 195.4,
    y2: 503.64,
    gradientTransform: "translate(227.19) rotate(-180) scale(.56 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1b1819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#555658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1b1819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_206",
    x1: 188.08,
    y1: 503.64,
    x2: 190.9,
    y2: 503.64,
    gradientTransform: "translate(235.3) rotate(-180) scale(.61 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1c191a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1c191a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_205",
    x1: 184.59,
    y1: 503.64,
    x2: 187.16,
    y2: 503.64,
    gradientTransform: "translate(243.42) rotate(-180) scale(.67 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1d1a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5b5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1d1a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_204",
    x1: 181.63,
    y1: 503.64,
    x2: 183.99,
    y2: 503.64,
    gradientTransform: "translate(251.53) rotate(-180) scale(.72 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1e1b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#5e5f61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1e1b1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_203",
    x1: 179.1,
    y1: 503.64,
    x2: 181.27,
    y2: 503.64,
    gradientTransform: "translate(259.64) rotate(-180) scale(.78 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1f1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#616264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1f1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_202",
    x1: 176.9,
    y1: 503.64,
    x2: 178.91,
    y2: 503.64,
    gradientTransform: "translate(267.76) rotate(-180) scale(.83 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#201c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#646568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#201c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_201",
    x1: 174.98,
    y1: 503.64,
    x2: 176.85,
    y2: 503.64,
    gradientTransform: "translate(275.87) rotate(-180) scale(.89 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#211d1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#67686b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#211d1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_200",
    x1: 173.29,
    y1: 503.64,
    x2: 175.04,
    y2: 503.64,
    gradientTransform: "translate(283.99) rotate(-180) scale(.94 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#221e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6a6b6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#221e1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 171.78,
    y1: 503.64,
    x2: 173.42,
    y2: 503.64,
    gradientTransform: "translate(292.1) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_234-2",
    x1: 116.85,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_234"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_233-2",
    x1: 115.03,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_233"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_232-2",
    x1: 112.97,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_232"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_231-2",
    x1: 110.61,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_231"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_230-2",
    x1: 107.9,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_230"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_229-2",
    x1: 104.72,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_229"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_228-2",
    x1: 100.98,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_228"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_227-2",
    x1: 96.48,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_227"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_226-2",
    x1: 90.99,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_226"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_225-2",
    x1: 84.12,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_225"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_224-2",
    x1: 75.28,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_224"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_223-2",
    x1: 63.51,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_223"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_222-2",
    x1: 47.02,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_222"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_221-2",
    x1: 22.29,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_221"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_220-2",
    x1: -18.92,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_220"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_219-2",
    x1: -101.36,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_218-2",
    x1: -348.66,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_218"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_217-2",
    x1: 118.57,
    y1: 516.88,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_217"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_216-2",
    y1: 516.88,
    x2: 640.54,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_216"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_215-2",
    y1: 516.88,
    x2: 393.24,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_215"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_214-2",
    y1: 516.88,
    x2: 310.81,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_214"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_213-2",
    y1: 516.88,
    x2: 269.59,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_213"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_212-2",
    y1: 516.88,
    x2: 244.86,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_212"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_211-2",
    y1: 516.88,
    x2: 228.37,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_210-2",
    y1: 516.88,
    x2: 216.6,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_210"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_209-2",
    y1: 516.88,
    x2: 207.77,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_209"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_208-2",
    y1: 516.88,
    x2: 200.9,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_208"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_207-2",
    y1: 516.88,
    x2: 195.4,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_207"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_206-2",
    y1: 516.88,
    x2: 190.9,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_206"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_205-2",
    y1: 516.88,
    x2: 187.16,
    y2: 516.88,
    xlinkHref: "#Degradado_sin_nombre_205"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_204-2",
    y1: 516.87,
    x2: 183.99,
    y2: 516.87,
    xlinkHref: "#Degradado_sin_nombre_204"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_203-2",
    y1: 516.87,
    x2: 181.27,
    y2: 516.87,
    xlinkHref: "#Degradado_sin_nombre_203"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_202-2",
    y1: 516.87,
    x2: 178.91,
    y2: 516.87,
    xlinkHref: "#Degradado_sin_nombre_202"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_201-2",
    y1: 516.87,
    x2: 176.85,
    y2: 516.87,
    xlinkHref: "#Degradado_sin_nombre_201"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_200-2",
    y1: 516.87,
    x2: 175.04,
    y2: 516.87,
    xlinkHref: "#Degradado_sin_nombre_200"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    y1: 516.87,
    y2: 516.87,
    xlinkHref: "#linear-gradient-94"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 104.89,
    cy: 401.33,
    fx: 104.89,
    fy: 401.33,
    r: 41.82,
    gradientTransform: "translate(198.62 653.27) rotate(-90.2) scale(1.36 -.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#02f7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#19b6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2c7ec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3c51b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#482ea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#51149c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#570596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#590094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#55008d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3e0068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2b0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1b002d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0f0019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#06000a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 467.65,
    cy: 2556.19,
    fx: 467.65,
    fy: 2556.19,
    r: 17.4,
    gradientTransform: "translate(912.47 -152.28) rotate(149.43) scale(2.06 -.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#eaffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b5ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#60ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "aqua"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#02f7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#19b6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2c7ec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3c51b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#482ea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#51149c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#570596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#590094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#55008d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3e0068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2b0047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1b002d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0f0019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#06000a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 131.12,
    y1: 456.12,
    x2: 139.23,
    y2: 456.12,
    gradientTransform: "translate(292.1) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 130.92,
    y1: 456.33,
    x2: 139.64,
    y2: 455.87,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 130.76,
    y1: 456.56,
    x2: 139.99,
    y2: 455.58,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 130.66,
    y1: 456.8,
    x2: 140.28,
    y2: 455.26,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 130.6,
    y1: 457.04,
    x2: 140.49,
    y2: 454.92,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 130.59,
    y1: 457.29,
    x2: 140.64,
    y2: 454.57,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 130.63,
    y1: 457.53,
    x2: 140.7,
    y2: 454.22,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 130.72,
    y1: 457.75,
    x2: 140.7,
    y2: 453.88,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 130.85,
    y1: 457.95,
    x2: 140.63,
    y2: 453.56,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 131.03,
    y1: 458.13,
    x2: 140.48,
    y2: 453.27,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 131.25,
    y1: 458.28,
    x2: 140.28,
    y2: 453.02,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 131.51,
    y1: 458.39,
    x2: 140.01,
    y2: 452.81,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 131.8,
    y1: 458.45,
    x2: 139.69,
    y2: 452.66,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 132.11,
    y1: 458.47,
    x2: 139.32,
    y2: 452.57,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 132.45,
    y1: 458.44,
    x2: 138.92,
    y2: 452.54,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 141.54,
    y1: 459.95,
    x2: 142.84,
    y2: 460.42,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 140.83,
    y1: 459.82,
    x2: 143.1,
    y2: 460.39,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 140.17,
    y1: 459.86,
    x2: 143.32,
    y2: 460.29,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 139.61,
    y1: 460.05,
    x2: 143.51,
    y2: 460.15,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 139.16,
    y1: 460.35,
    x2: 143.65,
    y2: 459.97,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 138.79,
    y1: 460.74,
    x2: 143.77,
    y2: 459.77,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 138.5,
    y1: 461.21,
    x2: 143.85,
    y2: 459.54,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 138.26,
    y1: 461.75,
    x2: 143.92,
    y2: 459.28,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 138.04,
    y1: 462.4,
    x2: 143.99,
    y2: 458.99,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 137.83,
    y1: 463.19,
    x2: 144.06,
    y2: 458.65,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 137.64,
    y1: 464.14,
    x2: 144.12,
    y2: 458.24,
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 87.32,
    y1: 485.74,
    x2: 112.29,
    y2: 499.24,
    gradientTransform: "translate(292.1) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15b3ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-9",
    cx: 590.45,
    cy: 442.31,
    fx: 590.45,
    fy: 442.31,
    r: 56.15,
    gradientTransform: "translate(-265.78 -69.29) scale(.91 .94)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-10",
    cx: 480.35,
    cy: 521.8,
    fx: 480.35,
    fy: 521.8,
    r: 56.15,
    gradientTransform: "translate(-161.71 -18.7) scale(.91 .94)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-11",
    cx: 518.87,
    cy: 538.65,
    fx: 518.87,
    fy: 538.65,
    r: 56.15,
    gradientTransform: "translate(-163.8 -54.27) scale(.91 .94)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-12",
    cx: 483.51,
    cy: 619.83,
    fx: 483.51,
    fy: 619.83,
    r: 56.15,
    gradientTransform: "translate(-87.58 -60.31) scale(.91 .94)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-13",
    cx: 437.18,
    cy: 524.65,
    fx: 437.18,
    fy: 524.65,
    r: 56.15,
    gradientTransform: "translate(20.79 -131.63) scale(.69 1.21)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-14",
    cx: 489.54,
    cy: 528.21,
    fx: 489.54,
    fy: 528.21,
    r: 56.15,
    gradientTransform: "translate(8.99 -162.88) scale(.69 1.21)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-15",
    cx: 378.63,
    cy: 502.35,
    fx: 378.63,
    fy: 502.35,
    r: 56.15,
    gradientTransform: "translate(15.91 -87.27) scale(.69 1.21)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-16",
    cx: 255.02,
    cy: 531.93,
    fx: 255.02,
    fy: 531.93,
    r: 56.16,
    gradientTransform: "translate(190.71 -65.24) scale(.69 1.21)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-17",
    cx: 436.79,
    cy: 501.12,
    fx: 436.79,
    fy: 501.12,
    r: 56.15,
    gradientTransform: "translate(-160.62 22.22) scale(.91 .94)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-18",
    cx: 278.21,
    cy: 531.84,
    fx: 278.21,
    fy: 531.84,
    r: 56.15,
    gradientTransform: "translate(-75.16 128.69) scale(.91 .94)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-19",
    cx: 278.74,
    cy: 505.88,
    fx: 278.74,
    fy: 505.88,
    r: 56.15,
    gradientTransform: "translate(-95.31 138.69) scale(.91 .94)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-20",
    cx: 620.37,
    cy: 456.25,
    fx: 620.37,
    fy: 456.25,
    r: 56.15,
    gradientTransform: "translate(-266.76 -97.25) scale(.91 .94)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_19-21",
    cx: 3703.9,
    cy: 3152.83,
    fx: 3703.9,
    fy: 3152.83,
    r: 25.07,
    gradientTransform: "translate(9415.55 -12366.29) rotate(143.34) scale(6.56 -1.51) skewX(-24.61)",
    xlinkHref: "#Degradado_sin_nombre_19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 481.97,
    y1: 315.3,
    x2: 667.42,
    y2: 315.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c0f0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#c5f1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#d4f4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eefbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 2356.11,
    cy: 138.74,
    fx: 2356.11,
    fy: 138.74,
    r: 49.59,
    gradientTransform: "translate(-2006.92 1907.95) rotate(-32.23) scale(1.34 -.12) skewX(-25.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fffdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#b5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ab40f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#901df0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7f07eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#7900e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6000ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4a008e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#360068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#250047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#17002d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0d0019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#05000a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#010002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 571.02,
    cy: -2818.61,
    fx: 571.02,
    fy: -2818.61,
    r: 49.6,
    gradientTransform: "translate(369.65 2945.69) rotate(-91.45) scale(1.34 -.06) skewX(-25.55)",
    xlinkHref: "#radial-gradient-46"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 488.43,
    y: 263.8,
    width: 174.43,
    height: 140.18,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M488.43,389.7c0-11.71,8.09-23.64,17.63-28.93,14.1-7.83,16.95,1.42,26.13-3.52,12.89-6.94,14.94-28.78,25.85-34.83,11.72-6.5,12.73,13.55,28.48,4.81,7-3.88,7.7-8.72,17.85-14.36,8.91-4.95,11.62-1.15,18.09-4.73,9.73-5.38,10.94-16.56,24.63-24.16,8.23-4.56,15.76-.21,15.76,8.94v14.24l-174.43,96.82v-14.28Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 437.81,
    y1: 597.46,
    x2: 455.96,
    y2: 597.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13002a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2a0054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4d0094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4b0597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#47149f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#402eae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3e39b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c42b9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    y1: 565.7,
    y2: 565.7,
    xlinkHref: "#linear-gradient-124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 481.93,
    y1: 593.89,
    x2: 514.08,
    y2: 593.89,
    xlinkHref: "#linear-gradient-124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 481.93,
    y1: 553.7,
    x2: 514.08,
    y2: 553.7,
    xlinkHref: "#linear-gradient-124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 460.55,
    y1: 626.85,
    x2: 480.99,
    y2: 657.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 512.43,
    y1: 613,
    x2: 533.02,
    y2: 643.89,
    xlinkHref: "#linear-gradient-128"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 546.03,
    y1: 574.68,
    x2: 564.39,
    y2: 602.22,
    xlinkHref: "#linear-gradient-128"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 259.33,
    y1: 535.78,
    x2: 268.76,
    y2: 696.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32003f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 394.73,
    y1: 364.2,
    x2: 399.16,
    y2: 439.92,
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: -60.66,
    y1: 149.62,
    x2: -51.23,
    y2: 310.75,
    gradientTransform: "translate(571.56 430.45) rotate(-180)",
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 475.46,
    y1: -93.31,
    x2: 479.03,
    y2: -32.28,
    gradientTransform: "translate(571.56 430.45) rotate(-180)",
    xlinkHref: "#linear-gradient-131"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-374"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-54",
    cx: 407.15,
    cy: 244.52,
    rx: 284.52,
    ry: 284.13
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 816.66,
    height: 848.33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("image", {
    width: 342,
    height: 228,
    transform: "translate(333 545)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("image", {
    width: 342,
    height: 228,
    transform: "translate(423 351)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 273.7,
    y1: 400.27,
    x2: 273.7,
    y2: 345.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 301.23,
    y1: 382.2,
    x2: 301.23,
    y2: 328.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M229.78,421.63v-32.79c0-11.68,6.14-22.51,16.18-28.49l144.11-86.03c8.09-4.83,12.89-13.68,12.53-23.09l-.73-13.68"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-258"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M313.27,544.8v26.15c0,4.35-2.21,8.39-5.87,10.75l-121.28,78.01c-3.24,2.08-7.49-.24-7.49-4.09v-28.94l-21.34-13.49v-23.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M542.55,623.67v44.43c0,3.85-4.26,6.17-7.49,4.09l-121.28-78.01c-3.66-2.35-5.87-6.4-5.87-10.75v-26.15l-127.54-81.85c-4.06-2.61-6.52-7.1-6.52-11.93v-39.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M501.75,452.84l-1.7,37.49c-.24,5.24-3.02,10.02-7.45,12.83l-107.6,68.05c-10.4,6.58-23.72,6.32-33.86-.64l-107.12-73.57c-8.91-6.12-14.23-16.23-14.23-27.03v-17.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M313.27,544.8l64.66-37.07c4.82-2.77,4.98-9.67,.29-12.65l-64.99-41.28c-5.95-3.78-9.56-10.35-9.56-17.4v-27.67"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M123.4,732.49c54,3.96,153.01-42.92,221.14-104.71,68.13-61.79,79.59-115.08,25.59-119.05-54.01-3.95-153.01,42.93-221.14,104.71-68.13,61.79-79.59,115.09-25.59,119.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M573.84,423.58c-50.77-4.51-144.65,38.21-209.67,95.39-65.02,57.19-76.57,107.19-25.8,111.7,50.78,4.5,144.66-38.21,209.67-95.39,65.02-57.18,76.57-107.19,25.8-111.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M595.94,324.18c-80.85-53.33-187.43-31.24-238.05,49.32-50.62,80.57-26.12,189.1,54.73,242.43,80.86,53.32,187.44,31.24,238.05-49.32,50.62-80.56,26.11-189.11-54.73-242.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M593.01,577.88c-44.28-29.21-102.65-17.11-130.37,27.01-27.72,44.13-14.3,103.57,29.98,132.77,44.28,29.2,102.65,17.11,130.37-27.01,27.72-44.12,14.3-103.57-29.98-132.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-420",
    d: "M363.13,629.68v.31c.05,1.27,.92,2.54,2.6,3.51l100.89,58.24c3.48,2.01,9.14,2.01,12.61,0l163.04-94.13c1.68-.97,2.55-2.23,2.6-3.51v-.29c-.07-1.26-.93-2.53-2.6-3.48l-100.89-58.24c-3.48-2.01-9.14-2.01-12.61,0l-163.04,94.12c-1.66,.96-2.53,2.2-2.6,3.46Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-460",
    d: "M363.13,629.81v3.49c-.08,1.38,.79,2.77,2.6,3.81l100.89,58.24c3.48,2.01,9.14,2.01,12.61,0l163.04-94.12c1.02-.59,1.74-1.29,2.15-2.03,.21-.62,.35-1.03,.41-1.19t0-.01c.01-.05,.02-.08,.02-.08v-3.99c-.05,1.27-.92,2.54-2.6,3.51l-163.04,94.13c-3.47,2.01-9.13,2.01-12.61,0l-100.89-58.24c-1.68-.98-2.55-2.24-2.6-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M366.08,635.58l94.59,57.95c.93,.55,2.04,.38,2.48-.38h0c.44-.75,.05-1.81-.88-2.35l-94.59-57.95c-.93-.55-2.04-.38-2.48,.38h0c-.44,.75-.05,1.81,.88,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M479.81,694.14l168.38-95.16c1.62-.94,2.54-2.4,2.04-3.26h0c-.5-.86-2.22-.79-3.84,.15l-168.38,95.16c-1.62,.94-2.54,2.4-2.04,3.26h0c.5,.86,2.22,.79,3.84-.15Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "473.58 683.46 377.8 626.23 529.5 538.04 625.28 595.26 473.58 683.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M596.04,560.79c27.14,16.54,48.39,31.2,47.44,32.75-.94,1.55-23.71-10.61-50.86-27.14-27.14-16.54-48.39-31.2-47.44-32.75,.94-1.55,23.71,10.61,50.86,27.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M512.35,286.39c-4.77,5.59-16.55,13.88-25.8,19.32L200.11,471.08c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M508.53,284.43c-4.77,5.59-16.55,13.88-25.8,19.32L196.29,469.12c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M504.71,282.47c-4.77,5.59-16.55,13.88-25.8,19.32L192.48,467.17c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M500.89,280.51c-4.77,5.59-16.55,13.88-25.8,19.32L188.66,465.21c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M497.08,278.55c-4.77,5.59-16.55,13.88-25.8,19.32L184.84,463.25c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M493.26,276.59c-4.77,5.59-16.55,13.88-25.8,19.32L181.02,461.29c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M489.44,274.64c-4.77,5.59-16.55,13.88-25.8,19.32L177.2,459.33c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M485.62,272.68c-4.77,5.59-16.55,13.88-25.8,19.32L173.39,457.37c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M481.8,270.72c-4.77,5.59-16.55,13.88-25.8,19.32L169.57,455.41c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M477.99,268.76c-4.77,5.59-16.55,13.88-25.8,19.32L165.75,453.45c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M474.17,266.8c-4.77,5.59-16.55,13.88-25.8,19.32L161.93,451.49c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M470.35,264.84c-4.77,5.59-16.55,13.88-25.8,19.32L158.11,449.54c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M466.53,262.88c-4.77,5.59-16.55,13.88-25.8,19.32L154.3,447.58c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M462.71,260.92c-4.77,5.59-16.55,13.88-25.8,19.32L150.48,445.62c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M458.9,258.96c-4.77,5.59-16.55,13.88-25.8,19.32L146.66,443.66c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M455.08,257.01c-4.77,5.59-16.55,13.88-25.8,19.32L142.84,441.7c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M451.26,255.05c-4.77,5.59-16.55,13.88-25.8,19.32L139.02,439.74c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M447.44,253.09c-4.77,5.59-16.55,13.88-25.8,19.32L135.21,437.78c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M512.35,286.39c-4.77,5.59-16.55,13.88-25.8,19.32L200.11,471.08c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M508.53,284.43c-4.77,5.59-16.55,13.88-25.8,19.32L196.29,469.12c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M504.71,282.47c-4.77,5.59-16.55,13.88-25.8,19.32L192.48,467.17c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M500.89,280.51c-4.77,5.59-16.55,13.88-25.8,19.32L188.66,465.21c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M497.08,278.55c-4.77,5.59-16.55,13.88-25.8,19.32L184.84,463.25c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M493.26,276.59c-4.77,5.59-16.55,13.88-25.8,19.32L181.02,461.29c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M489.44,274.64c-4.77,5.59-16.55,13.88-25.8,19.32L177.2,459.33c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M485.62,272.68c-4.77,5.59-16.55,13.88-25.8,19.32L173.39,457.37c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M481.8,270.72c-4.77,5.59-16.55,13.88-25.8,19.32L169.57,455.41c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M477.99,268.76c-4.77,5.59-16.55,13.88-25.8,19.32L165.75,453.45c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M474.17,266.8c-4.77,5.59-16.55,13.88-25.8,19.32L161.93,451.49c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M470.35,264.84c-4.77,5.59-16.55,13.88-25.8,19.32L158.11,449.54c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M466.53,262.88c-4.77,5.59-16.55,13.88-25.8,19.32L154.3,447.58c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M462.71,260.92c-4.77,5.59-16.55,13.88-25.8,19.32L150.48,445.62c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M458.9,258.96c-4.77,5.59-16.55,13.88-25.8,19.32L146.66,443.66c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M455.08,257.01c-4.77,5.59-16.55,13.88-25.8,19.32L142.84,441.7c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M451.26,255.05c-4.77,5.59-16.55,13.88-25.8,19.32L139.02,439.74c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M447.44,253.09c-4.77,5.59-16.55,13.88-25.8,19.32L135.21,437.78c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M513.22,285.99c-4.77,5.59-16.55,13.88-25.8,19.32L200.99,470.69c-21.22,12.25-38.59-.87-38.59-29.17s17.36-61.47,38.59-73.73l5.37-3.1c1.71-.99,2.88-2.71,3.15-4.67,7.06-49.49,41.64-103.93,83.24-127.95,10.86-6.27,21.23-9.91,30.77-11.13,2-.26,3.77-1.44,4.77-3.19,17.84-31.15,42.68-58.43,70.15-74.29,45.94-26.52,84.51-12.63,95.3,30.01,.21,.85,.8,1.55,1.59,1.92,.79,.37,1.71,.37,2.49-.01,27.7-13.29,49.46,.8,49.46,33.29,0,26.16-14.1,56.66-34.05,77.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M442.56,134.01c23.53,0,40.75,14.74,47.25,40.45,.51,2.03,1.9,3.71,3.8,4.6,.92,.43,1.94,.66,2.96,.66s2.08-.24,3.01-.68c6.33-3.04,12.35-4.57,17.89-4.57,7.55,0,13.9,2.94,18.37,8.51,4.83,6.02,7.38,14.9,7.38,25.69,0,12.09-3.18,25.6-9.19,39.07-5.91,13.23-14.11,25.48-23.72,35.44l-.09,.09-.08,.09c-4.38,5.13-15.78,13.17-24.74,18.44L198.96,467.18c-4.65,2.69-9.09,4.05-13.2,4.05-11.73,0-19.3-11.66-19.3-29.71,0-13.04,3.86-27.6,10.87-41,6.96-13.29,16.08-23.67,25.69-29.22l5.37-3.1c2.77-1.6,4.69-4.44,5.14-7.61,3.36-23.55,13.33-49.09,28.06-71.89,14.88-23.04,33.77-41.9,53.2-53.11,10.14-5.86,19.99-9.43,29.26-10.62,3.24-.42,6.14-2.36,7.77-5.2,18.29-31.94,42.67-57.79,68.66-72.79,14.89-8.6,29.05-12.96,42.09-12.96m0-4.06c-13.27,0-28.25,4.34-44.12,13.5-27.48,15.86-52.31,43.14-70.15,74.29-1,1.75-2.77,2.93-4.77,3.19-9.54,1.23-19.91,4.87-30.77,11.13-41.6,24.02-76.18,78.46-83.24,127.95-.28,1.96-1.44,3.68-3.15,4.67l-5.37,3.1c-21.22,12.25-38.59,45.43-38.59,73.73,0,21.1,9.65,33.76,23.36,33.76,4.68,0,9.83-1.47,15.23-4.59l286.44-165.38c9.25-5.44,21.02-13.73,25.8-19.32,19.95-20.66,34.05-51.17,34.05-77.32,0-24.26-12.13-38.26-29.81-38.26-5.99,0-12.63,1.61-19.64,4.97-.4,.19-.83,.29-1.26,.29s-.84-.09-1.24-.28c-.79-.37-1.37-1.08-1.59-1.92-7.06-27.92-26.03-43.51-51.18-43.51h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-455",
    d: "M376.43,97.04c25.05,0,43.37,15.59,50.24,42.78,.29,1.13,1.06,2.07,2.11,2.56,.51,.24,1.08,.37,1.65,.37s1.16-.13,1.68-.38c6.75-3.24,13.22-4.88,19.23-4.88,17.79,0,28.84,14.29,28.84,37.3,0,25.31-13.26,55.4-33.78,76.65l-.02,.02-.02,.02c-4.82,5.64-16.62,13.86-25.54,19.11L134.37,435.97c-5.13,2.96-10.09,4.46-14.74,4.46-13.6,0-22.39-12.87-22.39-32.8,0-28.06,17.09-60.76,38.1-72.89l5.37-3.1c1.95-1.13,3.31-3.13,3.63-5.37,3.42-23.99,13.55-49.96,28.52-73.14,15.14-23.44,34.41-42.66,54.25-54.11,10.5-6.06,20.73-9.77,30.41-11.01,2.29-.29,4.33-1.67,5.48-3.67,18.56-32.41,43.34-58.66,69.8-73.94,15.37-8.87,30.05-13.37,43.63-13.37m0-.97c-13.27,0-28.25,4.34-44.12,13.5-27.48,15.86-52.31,43.14-70.15,74.29-1,1.75-2.77,2.93-4.77,3.19-9.54,1.23-19.91,4.87-30.77,11.13-41.6,24.02-76.18,78.46-83.24,127.95-.28,1.96-1.44,3.68-3.15,4.67l-5.37,3.1c-21.22,12.25-38.59,45.43-38.59,73.73,0,21.1,9.65,33.76,23.36,33.76,4.68,0,9.83-1.47,15.23-4.59l286.44-165.38c9.25-5.44,21.02-13.73,25.8-19.32,19.95-20.66,34.05-51.17,34.05-77.32,0-24.26-12.13-38.26-29.81-38.26-5.99,0-12.63,1.61-19.64,4.97-.4,.19-.83,.29-1.26,.29s-.84-.09-1.24-.28c-.79-.37-1.37-1.08-1.59-1.92-7.06-27.92-26.03-43.51-51.18-43.51h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M535.15,259.72c-64.88,17.01-209.94,90.49-323.97,164.12-114.04,73.63-153.89,119.52-89,102.51,64.9-17.02,209.95-90.5,323.98-164.12,114.04-73.63,153.89-119.52,89-102.51Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M537.6,196.84c-4.06-27.18-38.12-72.17-76.06-100.5-37.95-28.33-65.41-29.26-61.35-2.08,4.07,27.18,38.12,72.17,76.07,100.5,37.95,28.33,65.42,29.26,61.35,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M443.01,183.43c-31.18-19.6-74.04-10.04-95.73,21.34-21.69,31.38-14,72.7,17.18,92.3,31.18,19.59,74.05,10.03,95.73-21.34,21.69-31.38,14-72.7-17.18-92.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 408.46,
    cy: 243.55,
    rx: 90.55,
    ry: 62.63,
    transform: "translate(12.84 507.44) rotate(-64.51)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 408.46,
    cy: 243.55,
    rx: 72.82,
    ry: 50.37,
    transform: "translate(12.84 507.44) rotate(-64.51)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 408.46,
    cy: 243.55,
    rx: 55.1,
    ry: 38.11,
    transform: "translate(12.84 507.44) rotate(-64.51)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 408.46,
    cy: 243.55,
    rx: 37.38,
    ry: 25.85,
    transform: "translate(12.84 507.44) rotate(-64.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M423.37,238.29c0,9.9-6.67,20.28-14.91,23.18-8.23,2.9-14.91-2.78-14.91-12.68s6.67-20.28,14.91-23.18c8.23-2.9,14.91,2.78,14.91,12.68Z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-55",
    cx: 314.05,
    cy: 547.2,
    rx: 42.45,
    ry: 97.38,
    transform: "translate(-314.36 490.98) rotate(-55.04)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M440.75,327.67v101.19c0,2.99,2.44,4.01,5.42,2.29l55.65-32.13,107.89-62.29c2.98-1.72,5.42-5.57,5.42-8.55v-101.19c0-2.98-2.44-4.01-5.42-2.29l-77.63,44.82-85.91,49.6c-2.98,1.72-5.42,5.57-5.42,8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M441.59,328.36v101.19c0,2.99,2.44,4.01,5.42,2.29l55.65-32.13,107.89-62.29c2.98-1.72,5.42-5.57,5.42-8.55v-101.19c0-2.98-2.44-4.01-5.42-2.29l-77.63,44.82-85.91,49.6c-2.98,1.72-5.42,5.57-5.42,8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-453",
    d: "M442.43,329.06v101.19c0,2.99,2.44,4.01,5.42,2.29l55.65-32.13,107.89-62.29c2.98-1.72,5.42-5.57,5.42-8.55v-101.19c0-2.98-2.44-4.01-5.42-2.29l-77.63,44.82-85.91,49.6c-2.98,1.72-5.42,5.57-5.42,8.55Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-403",
    points: "447.34 329.62 447.34 427.2 612.77 330.97 612.85 233.96 447.34 329.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-494",
    d: "M447.34,329.9v95.78c0,.37,.4,.6,.72,.42l164.59-95.14c.15-.09,.24-.24,.24-.42l-.13-95.57c0-.37-.4-.6-.72-.41l-164.46,94.92c-.15,.09-.24,.24-.24,.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M528.08,278.8c0-.85,.69-1.94,1.54-2.44,.85-.49,1.54-.2,1.54,.65s-.69,1.94-1.54,2.43c-.85,.49-1.54,.2-1.54-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-521",
    d: "M528.26,278.41c0-.48,.39-1.09,.86-1.36s.86-.11,.86,.37-.39,1.09-.86,1.36c-.48,.28-.86,.11-.86-.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M446.73,434.96v.31c.05,1.27,.92,2.54,2.6,3.51l100.89,58.24c3.48,2.01,9.14,2.01,12.61,0l163.04-94.13c1.68-.97,2.55-2.23,2.6-3.51v-.29c-.07-1.26-.93-2.53-2.6-3.48l-100.89-58.24c-3.48-2.01-9.14-2.01-12.61,0l-163.04,94.12c-1.66,.96-2.53,2.2-2.6,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M468.61,433.87c.13,.64,.63,1.26,1.48,1.75l57.61,33.25c2.04,1.18,5.34,1.18,7.38,0l144.13-83.22c.85-.49,1.35-1.11,1.48-1.75,.2-.89-.29-1.83-1.48-2.51l-57.6-33.26c-2.04-1.18-5.35-1.18-7.39,0l-144.13,83.22c-1.19,.69-1.68,1.62-1.48,2.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M584.05,443.21c.08,.27,.3,.53,.66,.74l29.11,16.81c.92,.53,2.43,.53,3.36,0l47.32-27.32c.36-.21,.58-.47,.66-.75,.13-.42-.1-.87-.66-1.19l-29.11-16.81c-.93-.53-2.43-.53-3.36,0l-47.32,27.32c-.56,.33-.78,.77-.66,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-446",
    d: "M584.05,443.21c.08,.27,.3,.53,.66,.74l29.11,16.81c.92,.53,2.43,.53,3.36,0l47.32-27.32c.36-.21,.58-.47,.66-.75-.07-.27-.29-.53-.66-.74l-29.11-16.81c-.93-.53-2.43-.53-3.36,0l-47.32,27.32c-.36,.21-.59,.47-.66,.75Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-405",
    d: "M489.15,443.87c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l8.62-4.98c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-8.62,4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-506",
    d: "M617.08,370.01c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l18.39-10.62c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-18.39,10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-437",
    d: "M631.52,372.77c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l13.56-7.83c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-13.56,7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M634.15,382.74c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l20.89-12.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-20.89,12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M639.21,391.31c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l25.78-14.88c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-25.78,14.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-520",
    d: "M498.76,449.41c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l13.54-7.82c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-13.54,7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-523",
    d: "M508.37,454.96c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l15.99-9.23c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-15.99,9.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M517.98,460.51c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l20.79-12c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-20.79,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M527.59,466.06c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l11-6.35c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-11,6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M570.13,441.5c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l45.94-26.53c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-45.94,26.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M479.55,438.32c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M488.66,433.06c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-488",
    d: "M497.32,428.06c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M505.98,423.05c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M514.65,418.05c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-439",
    d: "M523.31,413.05c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-487",
    d: "M531.97,408.05c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-428",
    d: "M540.64,403.05c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M549.3,398.04c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-528",
    d: "M557.97,393.04c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-463",
    d: "M566.63,388.04c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M575.29,383.04c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-476",
    d: "M583.96,378.04c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-481",
    d: "M593.34,372.62c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M602.01,367.62c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M610.67,362.61c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-470",
    d: "M619.33,357.61c-.45,.26-1.2,.26-1.65,0l-5.28-3.05c-.45-.26-.45-.69,0-.95l6.53-3.77c.45-.26,1.2-.26,1.65,0l5.28,3.05c.45,.26,.45,.69,0,.95l-6.53,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M500.4,437.38c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M519.89,426.12c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M510.14,431.75c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M529.64,420.49c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-471",
    d: "M539.38,414.87c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M549.13,409.24c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M558.88,403.61c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M568.62,397.99c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-444",
    d: "M578.37,392.36c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M588.12,386.73c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-510",
    d: "M597.86,381.1c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M607.61,375.48c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-517",
    d: "M514.82,440.14c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-516",
    d: "M524.57,434.52c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M534.31,428.89c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M544.06,423.26c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M553.81,417.64c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M563.55,412.01c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M573.3,406.38c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M583.05,400.75c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M592.79,395.13c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M602.54,389.5c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M612.29,383.87c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-512",
    d: "M622.03,378.25c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M526.84,444.7c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M536.58,439.07c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M546.33,433.45c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M556.07,427.82c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M565.82,422.19c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M575.57,416.56c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M585.31,410.94c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M595.06,405.31c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-412",
    d: "M604.81,399.68c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M614.55,394.06c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M624.3,388.43c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M551.14,441.36c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M560.89,435.74c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-493",
    d: "M540.9,458.38c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M550.64,452.75c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-431",
    d: "M560.39,447.12c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-443",
    d: "M619.23,413.15c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M628.98,407.52c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M638.72,401.9c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-496",
    d: "M655.83,390.08c-.45,.26-1.2,.26-1.65,0l-5.34-3.08c-.45-.26-.45-.69,0-.95l7.03-4.06c.45-.26,1.2-.26,1.65,0l5.34,3.08c.45,.26,.45,.69,0,.95l-7.03,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M662.24,393.78c-.45,.26-1.2,.26-1.65,0l-5.34-3.08c-.45-.26-.45-.69,0-.95l7.03-4.06c.45-.26,1.2-.26,1.65,0l5.34,3.08c.45,.26,.45,.69,0,.95l-7.03,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-399",
    d: "M652.85,399.2c-.45,.26-1.2,.26-1.65,0l-5.34-3.08c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l5.34,3.08c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M671.62,388.37c-.45,.26-1.2,.26-1.65,0l-5.34-3.08c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l5.34,3.08c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M570.63,430.11c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M580.38,424.48c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M590.13,418.86c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M599.87,413.23c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M609.62,407.6c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M619.37,401.97c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M629.11,396.35c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-402",
    d: "M541.39,446.99c-.45,.26-1.2,.26-1.65,0l-7.02-4.06c-.45-.26-.45-.69,0-.95l7.02-4.06c.45-.26,1.2-.26,1.65,0l7.02,4.06c.45,.26,.45,.69,0,.95l-7.02,4.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M497.2,437.62c.45,.26,.45,.69,0,.95l-8.04,4.64c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l8.04-4.64c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M634.9,358.12c.45,.26,.45,.69,0,.95l-17.82,10.29c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l17.82-10.29c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M644.51,363.67c.45,.26,.45,.69,0,.95l-12.99,7.5c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l12.99-7.5c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M654.46,369.42c.45,.26,.45,.69,0,.95l-20.31,11.73c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l20.31-11.73c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-395",
    d: "M664.41,375.16c.45,.26,.45,.69,0,.95l-25.2,14.55c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l25.2-14.55c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M511.72,440.33c.45,.26,.45,.69,0,.95l-12.96,7.48c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l12.96-7.48c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M523.79,444.46c.45,.26,.45,.69,0,.95l-15.42,8.9c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l15.42-8.9c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M538.19,447.24c.45,.26,.45,.69,0,.95l-20.21,11.67c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l20.21-11.67c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M538.01,458.44c.45,.26,.45,.69,0,.95l-10.42,6.02c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l10.42-6.02c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M615.5,413.7c.45,.26,.45,.69,0,.95l-45.37,26.19c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l45.37-26.19c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M485.5,433.28c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-490",
    d: "M494.61,428.02c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-458",
    d: "M503.28,423.02c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-441",
    d: "M511.94,418.02c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-459",
    d: "M520.6,413.02c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-464",
    d: "M529.27,408.01c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M537.93,403.01c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M546.59,398.01c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M555.26,393.01c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M563.92,388.01c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M572.58,383c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M581.25,378c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-500",
    d: "M589.91,373c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M599.3,367.58c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "M607.96,362.58c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M616.62,357.58c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M625.29,352.58c.45,.26,.45,.69,0,.95l-5.96,3.44c-.45,.26-1.2,.26-1.65,0l-4.7-2.71c-.45-.26-.45-.69,0-.95l5.96-3.44c.45-.26,1.2-.26,1.65,0l4.7,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-451",
    d: "M506.84,432.05c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M526.34,420.8c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M516.59,426.43c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-429",
    d: "M536.08,415.17c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M545.83,409.55c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M555.58,403.92c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M565.32,398.29c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M575.07,392.66c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M584.82,387.04c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "M594.56,381.41c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-472",
    d: "M604.31,375.78c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-498",
    d: "M614.06,370.16c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M521.27,434.82c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-499",
    d: "M531.01,429.2c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-495",
    d: "M540.76,423.57c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M550.51,417.94c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-514",
    d: "M560.25,412.31c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M570,406.69c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M579.74,401.06c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M589.49,395.43c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M599.24,389.81c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M608.98,384.18c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M618.73,378.55c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M628.48,372.93c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M533.28,439.38c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-457",
    d: "M543.03,433.75c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-468",
    d: "M552.77,428.12c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M562.52,422.5c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M572.27,416.87c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M582.01,411.24c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-492",
    d: "M591.76,405.62c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M601.51,399.99c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M611.25,394.36c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M621,388.73c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M630.75,383.11c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-522",
    d: "M557.59,436.04c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M567.33,430.42c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-442",
    d: "M547.34,453.05c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-507",
    d: "M557.09,447.43c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-416",
    d: "M566.84,441.8c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M625.68,407.83c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-425",
    d: "M635.42,402.2c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M645.17,396.57c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M655.86,382.01c.45-.26,1.2-.26,1.65,0l4.76,2.75c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-4.76-2.75c-.45-.26-.45-.69,0-.95l6.45-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-414",
    d: "M662.27,385.71c.45-.26,1.2-.26,1.65,0l4.76,2.75c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-4.76-2.75c-.45-.26-.45-.69,0-.95l6.45-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-447",
    d: "M659.29,393.88c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-4.76-2.75c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l4.76,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-491",
    d: "M678.06,383.04c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-4.76-2.75c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l4.76,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M577.08,424.79c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M586.83,419.16c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M596.57,413.54c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-418",
    d: "M606.32,407.91c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M616.07,402.28c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M625.81,396.65c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M635.56,391.03c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-456",
    d: "M547.84,441.67c.45,.26,.45,.69,0,.95l-6.45,3.72c-.45,.26-1.2,.26-1.65,0l-6.45-3.72c-.45-.26-.45-.69,0-.95l6.45-3.72c.45-.26,1.2-.26,1.65,0l6.45,3.72Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M617.47,342.87c0,1.17-1.66,2.11-3.71,2.11s-3.71-.95-3.71-2.11,1.66-2.11,3.71-2.11,3.71,.95,3.71,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M616.94,342.85c0,1-1.42,1.81-3.17,1.81s-3.17-.81-3.17-1.81,1.42-1.81,3.17-1.81,3.17,.81,3.17,1.81Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M446.73,435.09v3.49c-.08,1.38,.79,2.77,2.6,3.81l100.89,58.24c3.48,2.01,9.14,2.01,12.61,0l163.04-94.12c1.02-.59,1.74-1.29,2.15-2.03,.21-.62,.35-1.03,.41-1.19t0-.01c.01-.05,.02-.08,.02-.08v-3.99c-.05,1.27-.92,2.54-2.6,3.51l-163.04,94.13c-3.47,2.01-9.13,2.01-12.61,0l-100.89-58.24c-1.68-.98-2.55-2.24-2.6-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M449.68,440.86l94.59,57.95c.93,.55,2.04,.38,2.48-.38h0c.44-.75,.05-1.81-.88-2.35l-94.59-57.95c-.93-.55-2.04-.38-2.48,.38h0c-.44,.75-.05,1.81,.88,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-427",
    d: "M563.41,499.42l168.38-95.16c1.62-.94,2.53-2.4,2.04-3.26h0c-.5-.86-2.22-.79-3.84,.15l-168.38,95.16c-1.62,.94-2.54,2.4-2.04,3.26h0c.5,.86,2.22,.79,3.84-.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M447.18,321.68l159.33-89.92c1.54-.89,2.38-2.31,1.88-3.17h0c-.5-.86-2.15-.83-3.68,.06l-159.33,89.92c-1.54,.89-2.38,2.31-1.88,3.17h0c.5,.86,2.15,.83,3.68-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M443.11,428.96l2.38-100c0-.97-.8-1.76-1.79-1.76h0c-.99,0-1.8,.78-1.8,1.75l-2.38,100c0,.97,.8,1.76,1.79,1.76h0c.99,0,1.8-.78,1.8-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M459.09,428.46l158.73-90.98c1.53-.9,2.36-2.33,1.86-3.18h0c-.5-.86-2.15-.82-3.68,.08l-158.73,90.98c-1.53,.9-2.36,2.33-1.86,3.18h0c.5,.86,2.15,.82,3.68-.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-515",
    d: "M129.51,624.57l50.55-29.14c4.36-2.51,7.89-8.7,7.89-13.82v-139.21c0-5.12-3.53-7.23-7.89-4.72l-50.55,29.14c-4.36,2.51-7.89,8.7-7.89,13.82v139.21c0,5.12,3.53,7.23,7.89,4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M129.55,624.55l50.48-29.12c4.35-2.51,7.88-8.69,7.88-13.81v-139.11c0-5.11-3.53-7.22-7.88-4.71l-50.48,29.12c-4.35,2.51-7.88,8.69-7.88,13.8v139.11c0,5.11,3.53,7.22,7.88,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-469",
    d: "M129.59,624.53l50.41-29.09c4.35-2.51,7.87-8.69,7.87-13.79v-139.01c0-5.11-3.52-7.22-7.87-4.71l-50.41,29.1c-4.35,2.51-7.87,8.69-7.87,13.79v139.01c0,5.11,3.52,7.22,7.87,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M129.63,624.51l50.34-29.07c4.34-2.51,7.86-8.68,7.86-13.78v-138.9c0-5.11-3.52-7.21-7.86-4.71l-50.34,29.07c-4.34,2.51-7.86,8.68-7.86,13.78v138.9c0,5.11,3.52,7.21,7.86,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M129.67,624.49l50.27-29.05c4.33-2.51,7.85-8.67,7.85-13.77v-138.8c0-5.1-3.51-7.21-7.85-4.7l-50.27,29.05c-4.33,2.51-7.85,8.67-7.85,13.77v138.8c0,5.1,3.51,7.21,7.85,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M129.71,624.47l50.2-29.03c4.33-2.5,7.84-8.67,7.84-13.76v-138.7c0-5.1-3.51-7.2-7.84-4.7l-50.2,29.03c-4.33,2.5-7.84,8.67-7.84,13.76v138.7c0,5.1,3.51,7.2,7.84,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-404",
    d: "M129.75,624.45l50.13-29.01c4.32-2.5,7.83-8.66,7.83-13.75v-138.59c0-5.09-3.5-7.2-7.83-4.7l-50.13,29.01c-4.32,2.5-7.83,8.66-7.83,13.75v138.59c0,5.09,3.5,7.2,7.83,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M129.79,624.42l50.06-28.99c4.32-2.5,7.82-8.65,7.82-13.74v-138.49c0-5.09-3.5-7.19-7.82-4.69l-50.06,28.99c-4.32,2.5-7.82,8.65-7.82,13.74v138.49c0,5.09,3.5,7.19,7.82,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M129.83,624.4l49.99-28.96c4.31-2.5,7.8-8.65,7.8-13.73v-138.39c0-5.09-3.49-7.19-7.8-4.69l-49.99,28.97c-4.31,2.5-7.8,8.65-7.8,13.73v138.39c0,5.09,3.49,7.19,7.8,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M129.87,624.38l49.91-28.94c4.3-2.5,7.79-8.64,7.79-13.72v-138.28c0-5.08-3.49-7.18-7.79-4.68l-49.91,28.94c-4.3,2.5-7.79,8.64-7.79,13.72v138.28c0,5.08,3.49,7.18,7.79,4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M129.91,624.36l49.84-28.92c4.3-2.49,7.78-8.63,7.78-13.71v-138.18c0-5.08-3.48-7.17-7.78-4.68l-49.84,28.92c-4.3,2.49-7.78,8.63-7.78,13.71v138.18c0,5.08,3.48,7.18,7.78,4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-415",
    d: "M129.95,624.34l49.77-28.9c4.29-2.49,7.77-8.63,7.77-13.7v-138.07c0-5.08-3.48-7.17-7.77-4.68l-49.77,28.9c-4.29,2.49-7.77,8.63-7.77,13.7v138.07c0,5.08,3.48,7.17,7.77,4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M129.98,624.32l49.7-28.88c4.29-2.49,7.76-8.62,7.76-13.69v-137.97c0-5.07-3.47-7.16-7.76-4.67l-49.7,28.88c-4.29,2.49-7.76,8.62-7.76,13.69v137.97c0,5.07,3.47,7.16,7.76,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M130.02,624.3l49.63-28.86c4.28-2.49,7.75-8.61,7.75-13.68v-137.87c0-5.07-3.47-7.16-7.75-4.67l-49.63,28.86c-4.28,2.49-7.75,8.61-7.75,13.68v137.87c0,5.07,3.47,7.16,7.75,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-503",
    d: "M130.06,624.28l49.56-28.84c4.27-2.49,7.74-8.61,7.74-13.67v-137.76c0-5.06-3.46-7.15-7.74-4.67l-49.56,28.84c-4.27,2.49-7.74,8.61-7.74,13.67v137.76c0,5.06,3.46,7.15,7.74,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M130.1,624.25l49.49-28.81c4.27-2.48,7.73-8.6,7.73-13.66v-137.66c0-5.06-3.46-7.15-7.73-4.66l-49.49,28.81c-4.27,2.48-7.73,8.6-7.73,13.66v137.66c0,5.06,3.46,7.15,7.73,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M130.14,624.23l49.42-28.79c4.26-2.48,7.72-8.59,7.72-13.65v-137.56c0-5.06-3.45-7.14-7.72-4.66l-49.42,28.79c-4.26,2.48-7.72,8.59-7.72,13.65v137.56c0,5.06,3.46,7.14,7.72,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M130.18,624.21l49.35-28.77c4.26-2.48,7.71-8.59,7.71-13.64v-137.45c0-5.05-3.45-7.14-7.71-4.66l-49.35,28.77c-4.26,2.48-7.71,8.59-7.71,13.64v137.45c0,5.05,3.45,7.14,7.71,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M130.22,624.19l49.28-28.75c4.25-2.48,7.7-8.58,7.7-13.63v-137.35c0-5.05-3.45-7.13-7.7-4.65l-49.28,28.75c-4.25,2.48-7.69,8.58-7.69,13.63v137.35c0,5.05,3.45,7.13,7.69,4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M130.26,624.17l49.21-28.73c4.24-2.48,7.68-8.57,7.68-13.62v-137.25c0-5.04-3.44-7.13-7.68-4.65l-49.21,28.73c-4.24,2.48-7.68,8.57-7.68,13.62v137.25c0,5.04,3.44,7.13,7.68,4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-509",
    d: "M130.3,624.15l49.14-28.71c4.24-2.48,7.67-8.57,7.67-13.61v-137.14c0-5.04-3.44-7.12-7.67-4.65l-49.14,28.71c-4.24,2.48-7.67,8.57-7.67,13.61v137.14c0,5.04,3.44,7.12,7.67,4.65Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M133.09,468.69l5.08-2.93c.71-.41,1.28-.06,1.28,.76h0c0,2.07,1.43,2.93,3.2,1.91l25.99-14.98c1.77-1.02,3.2-3.52,3.2-5.6h0c0-.83,.57-1.83,1.28-2.24l5.08-2.93c3.72-2.14,6.73-.34,6.73,4.02v132.75c0,4.36-3.01,9.64-6.73,11.78l-45.1,26c-3.72,2.14-6.73,.34-6.73-4.02v-132.75c0-4.36,3.01-9.64,6.73-11.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M133.11,468.72l5.08-2.93c.71-.41,1.28-.06,1.28,.76h0c0,2.07,1.43,2.93,3.2,1.91l25.98-14.97c1.76-1.02,3.2-3.52,3.2-5.59h0c0-.83,.57-1.83,1.28-2.23l5.08-2.93c3.72-2.14,6.73-.34,6.73,4.02v132.7c0,4.36-3.01,9.64-6.73,11.78l-45.08,25.99c-3.72,2.14-6.73,.34-6.73-4.02v-132.7c0-4.36,3.01-9.64,6.73-11.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-508",
    d: "M133.13,468.74l5.08-2.93c.7-.41,1.28-.06,1.28,.76h0c0,2.07,1.43,2.93,3.19,1.91l25.97-14.97c1.76-1.02,3.19-3.52,3.19-5.59h0c0-.83,.57-1.83,1.28-2.23l5.08-2.93c3.71-2.14,6.73-.34,6.73,4.02v132.64c0,4.36-3.01,9.63-6.73,11.77l-45.06,25.98c-3.71,2.14-6.73,.34-6.73-4.02v-132.64c0-4.36,3.01-9.63,6.73-11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-526",
    d: "M133.16,468.76l5.08-2.93c.7-.41,1.28-.06,1.28,.76h0c0,2.07,1.43,2.92,3.19,1.91l25.95-14.96c1.76-1.02,3.19-3.52,3.19-5.59h0c0-.83,.57-1.83,1.28-2.23l5.08-2.93c3.71-2.14,6.72-.34,6.72,4.02v132.59c0,4.36-3.01,9.63-6.72,11.77l-45.05,25.97c-3.71,2.14-6.72,.34-6.72-4.02v-132.59c0-4.36,3.01-9.63,6.72-11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-406",
    d: "M133.18,468.79l5.08-2.93c.7-.41,1.28-.06,1.28,.76h0c0,2.07,1.43,2.92,3.19,1.91l25.94-14.96c1.76-1.02,3.19-3.52,3.19-5.59h0c0-.83,.57-1.83,1.28-2.23l5.08-2.93c3.71-2.14,6.72-.34,6.72,4.02v132.53c0,4.36-3.01,9.62-6.72,11.76l-45.03,25.96c-3.71,2.14-6.72,.34-6.72-4.02v-132.53c0-4.36,3.01-9.62,6.72-11.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-424",
    d: "M133.21,468.81l5.07-2.92c.7-.41,1.27-.06,1.27,.76h0c0,2.07,1.43,2.92,3.19,1.91l25.93-14.95c1.76-1.02,3.19-3.52,3.19-5.58h0c0-.83,.57-1.83,1.27-2.23l5.07-2.92c3.71-2.14,6.72-.34,6.72,4.01v132.48c0,4.36-3.01,9.62-6.72,11.76l-45.01,25.95c-3.71,2.14-6.72,.34-6.72-4.01v-132.48c0-4.36,3.01-9.62,6.72-11.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-474",
    d: "M133.23,468.84l5.07-2.92c.7-.41,1.27-.06,1.27,.76h0c0,2.07,1.43,2.92,3.19,1.91l25.92-14.94c1.76-1.02,3.19-3.51,3.19-5.58h0c0-.83,.57-1.82,1.27-2.23l5.07-2.92c3.71-2.14,6.71-.34,6.71,4.01v132.43c0,4.35-3.01,9.62-6.71,11.75l-44.99,25.94c-3.71,2.14-6.71,.34-6.71-4.01v-132.43c0-4.35,3.01-9.62,6.71-11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-479",
    d: "M133.25,468.86l5.07-2.92c.7-.41,1.27-.06,1.27,.76h0c0,2.07,1.43,2.92,3.19,1.9l25.91-14.94c1.76-1.01,3.19-3.51,3.19-5.58h0c0-.83,.57-1.82,1.27-2.23l5.07-2.92c3.71-2.14,6.71-.34,6.71,4.01v132.37c0,4.35-3.01,9.61-6.71,11.75l-44.97,25.93c-3.71,2.14-6.71,.34-6.71-4.01v-132.37c0-4.35,3.01-9.61,6.71-11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-478",
    d: "M133.28,468.88l5.07-2.92c.7-.41,1.27-.06,1.27,.76h0c0,2.07,1.43,2.92,3.19,1.9l25.9-14.93c1.76-1.01,3.19-3.51,3.19-5.58h0c0-.83,.57-1.82,1.27-2.23l5.07-2.92c3.71-2.14,6.71-.34,6.71,4.01v132.32c0,4.35-3,9.61-6.71,11.74l-44.96,25.91c-3.71,2.14-6.71,.34-6.71-4.01v-132.32c0-4.35,3-9.61,6.71-11.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M133.3,468.91l5.06-2.92c.7-.41,1.27-.06,1.27,.76h0c0,2.07,1.43,2.92,3.19,1.9l25.89-14.93c1.76-1.01,3.19-3.51,3.19-5.58h0c0-.83,.57-1.82,1.27-2.23l5.06-2.92c3.7-2.14,6.71-.34,6.71,4.01v132.27c0,4.35-3,9.6-6.71,11.74l-44.94,25.9c-3.7,2.14-6.71,.34-6.71-4.01v-132.27c0-4.35,3-9.6,6.71-11.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-524",
    d: "M133.33,468.93l5.06-2.92c.7-.41,1.27-.06,1.27,.76h0c0,2.06,1.43,2.92,3.18,1.9l25.88-14.92c1.76-1.01,3.18-3.51,3.18-5.57h0c0-.82,.57-1.82,1.27-2.23l5.06-2.92c3.7-2.13,6.7-.34,6.7,4.01v132.21c0,4.35-3,9.6-6.7,11.74l-44.92,25.89c-3.7,2.13-6.7,.34-6.7-4.01v-132.21c0-4.35,3-9.6,6.7-11.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-482",
    d: "M133.35,468.96l5.06-2.92c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.43,2.92,3.18,1.9l25.87-14.91c1.76-1.01,3.18-3.51,3.18-5.57h0c0-.82,.57-1.82,1.27-2.23l5.06-2.92c3.7-2.13,6.7-.34,6.7,4v132.16c0,4.35-3,9.6-6.7,11.73l-44.9,25.88c-3.7,2.13-6.7,.34-6.7-4v-132.16c0-4.34,3-9.6,6.7-11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-421",
    d: "M133.37,468.98l5.06-2.92c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.42,2.91,3.18,1.9l25.86-14.91c1.76-1.01,3.18-3.51,3.18-5.57h0c0-.82,.57-1.82,1.27-2.22l5.06-2.92c3.7-2.13,6.7-.34,6.7,4v132.11c0,4.34-3,9.59-6.7,11.73l-44.88,25.87c-3.7,2.13-6.7,.34-6.7-4v-132.11c0-4.34,3-9.59,6.7-11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M133.4,469.01l5.06-2.91c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.42,2.91,3.18,1.9l25.85-14.9c1.76-1.01,3.18-3.5,3.18-5.57h0c0-.82,.57-1.82,1.27-2.22l5.06-2.92c3.7-2.13,6.7-.34,6.7,4v132.05c0,4.34-3,9.59-6.7,11.72l-44.86,25.86c-3.7,2.13-6.7,.34-6.7-4v-132.05c0-4.34,3-9.59,6.7-11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M133.42,469.03l5.05-2.91c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.42,2.91,3.18,1.9l25.84-14.9c1.76-1.01,3.18-3.5,3.18-5.56h0c0-.82,.57-1.82,1.27-2.22l5.05-2.91c3.7-2.13,6.69-.34,6.69,4v132c0,4.34-3,9.59-6.69,11.72l-44.85,25.85c-3.7,2.13-6.69,.34-6.69-4v-132c0-4.34,3-9.59,6.69-11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M133.45,469.05l5.05-2.91c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.42,2.91,3.18,1.9l25.83-14.89c1.75-1.01,3.18-3.5,3.18-5.56h0c0-.82,.57-1.82,1.27-2.22l5.05-2.91c3.69-2.13,6.69-.34,6.69,4v131.94c0,4.34-3,9.58-6.69,11.71l-44.83,25.84c-3.69,2.13-6.69,.34-6.69-4v-131.94c0-4.34,3-9.58,6.69-11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M133.47,469.08l5.05-2.91c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.42,2.91,3.18,1.9l25.82-14.88c1.75-1.01,3.18-3.5,3.18-5.56h0c0-.82,.57-1.82,1.27-2.22l5.05-2.91c3.69-2.13,6.69-.34,6.69,4v131.89c0,4.34-2.99,9.58-6.69,11.71l-44.81,25.83c-3.69,2.13-6.69,.34-6.69-4v-131.89c0-4.34,2.99-9.58,6.69-11.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-435",
    d: "M133.49,469.1l5.05-2.91c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.42,2.91,3.17,1.9l25.81-14.88c1.75-1.01,3.17-3.5,3.17-5.56h0c0-.82,.57-1.82,1.27-2.22l5.05-2.91c3.69-2.13,6.68-.34,6.68,3.99v131.84c0,4.33-2.99,9.57-6.68,11.7l-44.79,25.82c-3.69,2.13-6.68,.34-6.68-3.99v-131.84c0-4.33,2.99-9.57,6.68-11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M133.52,469.13l5.05-2.91c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.42,2.91,3.17,1.9l25.8-14.87c1.75-1.01,3.17-3.5,3.17-5.56h0c0-.82,.57-1.82,1.27-2.22l5.05-2.91c3.69-2.13,6.68-.34,6.68,3.99v131.78c0,4.33-2.99,9.57-6.68,11.7l-44.77,25.81c-3.69,2.13-6.68,.34-6.68-3.99v-131.78c0-4.33,2.99-9.57,6.68-11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M133.54,469.15l5.04-2.91c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.42,2.91,3.17,1.9l25.79-14.86c1.75-1.01,3.17-3.5,3.17-5.55h0c0-.82,.57-1.81,1.27-2.22l5.04-2.91c3.69-2.13,6.68-.34,6.68,3.99v131.73c0,4.33-2.99,9.57-6.68,11.69l-44.75,25.8c-3.69,2.13-6.68,.34-6.68-3.99v-131.73c0-4.33,2.99-9.57,6.68-11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-411",
    d: "M133.57,469.17l5.04-2.91c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.42,2.9,3.17,1.89l25.78-14.86c1.75-1.01,3.17-3.49,3.17-5.55h0c0-.82,.57-1.81,1.27-2.22l5.04-2.91c3.69-2.13,6.68-.34,6.68,3.99v131.68c0,4.33-2.99,9.56-6.68,11.69l-44.74,25.79c-3.69,2.13-6.68,.34-6.68-3.99v-131.68c0-4.33,2.99-9.56,6.68-11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-396",
    d: "M133.59,469.2l5.04-2.91c.7-.4,1.27-.06,1.27,.76h0c0,2.06,1.42,2.9,3.17,1.89l25.77-14.85c1.75-1.01,3.17-3.49,3.17-5.55h0c0-.82,.57-1.81,1.27-2.22l5.04-2.91c3.69-2.12,6.67-.34,6.67,3.99v131.62c0,4.33-2.99,9.56-6.67,11.68l-44.72,25.78c-3.69,2.12-6.67,.34-6.67-3.99v-131.62c0-4.33,2.99-9.56,6.67-11.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M133.61,469.22l5.04-2.9c.7-.4,1.27-.06,1.27,.76h0c0,2.05,1.42,2.9,3.17,1.89l25.75-14.85c1.75-1.01,3.17-3.49,3.17-5.55h0c0-.82,.57-1.81,1.27-2.22l5.04-2.9c3.68-2.12,6.67-.34,6.67,3.99v131.57c0,4.33-2.99,9.55-6.67,11.68l-44.7,25.77c-3.68,2.12-6.67,.34-6.67-3.99v-131.57c0-4.33,2.99-9.55,6.67-11.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M133.64,469.25l5.04-2.9c.7-.4,1.27-.06,1.27,.76h0c0,2.05,1.42,2.9,3.17,1.89l25.74-14.84c1.75-1.01,3.17-3.49,3.17-5.54h0c0-.82,.57-1.81,1.27-2.21l5.04-2.9c3.68-2.12,6.67-.34,6.67,3.98v131.51c0,4.32-2.99,9.55-6.67,11.67l-44.68,25.76c-3.68,2.12-6.67,.34-6.67-3.98v-131.51c0-4.32,2.99-9.55,6.67-11.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M133.66,469.27l5.03-2.9c.7-.4,1.26-.06,1.26,.76h0c0,2.05,1.42,2.9,3.17,1.89l25.73-14.83c1.75-1.01,3.17-3.49,3.17-5.54h0c0-.82,.57-1.81,1.26-2.21l5.03-2.9c3.68-2.12,6.67-.34,6.67,3.98v131.46c0,4.32-2.98,9.55-6.67,11.67l-44.66,25.75c-3.68,2.12-6.67,.34-6.67-3.98v-131.46c0-4.32,2.98-9.55,6.67-11.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M133.69,469.29l5.03-2.9c.7-.4,1.26-.06,1.26,.76h0c0,2.05,1.42,2.9,3.16,1.89l25.72-14.83c1.75-1.01,3.16-3.49,3.16-5.54h0c0-.82,.57-1.81,1.26-2.21l5.03-2.9c3.68-2.12,6.66-.34,6.66,3.98v131.41c0,4.32-2.98,9.54-6.66,11.66l-44.65,25.74c-3.68,2.12-6.66,.34-6.66-3.98v-131.41c0-4.32,2.98-9.54,6.66-11.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-497",
    d: "M133.71,469.32l5.03-2.9c.7-.4,1.26-.06,1.26,.76h0c0,2.05,1.42,2.9,3.16,1.89l25.71-14.82c1.75-1.01,3.16-3.49,3.16-5.54h0c0-.82,.57-1.81,1.26-2.21l5.03-2.9c3.68-2.12,6.66-.34,6.66,3.98v131.35c0,4.32-2.98,9.54-6.66,11.66l-44.63,25.73c-3.68,2.12-6.66,.34-6.66-3.98v-131.35c0-4.32,2.98-9.54,6.66-11.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M133.73,469.34l5.03-2.9c.7-.4,1.26-.06,1.26,.75h0c0,2.05,1.42,2.9,3.16,1.89l25.7-14.82c1.75-1.01,3.16-3.48,3.16-5.54h0c0-.82,.57-1.81,1.26-2.21l5.03-2.9c3.68-2.12,6.66-.34,6.66,3.98v131.3c0,4.32-2.98,9.53-6.66,11.65l-44.61,25.72c-3.68,2.12-6.66,.34-6.66-3.98v-131.3c0-4.32,2.98-9.53,6.66-11.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M133.76,469.37l5.03-2.9c.7-.4,1.26-.06,1.26,.75h0c0,2.05,1.42,2.9,3.16,1.89l25.69-14.81c1.75-1.01,3.16-3.48,3.16-5.53h0c0-.82,.57-1.81,1.26-2.21l5.03-2.9c3.68-2.12,6.66-.34,6.66,3.98v131.25c0,4.32-2.98,9.53-6.66,11.65l-44.59,25.7c-3.68,2.12-6.65,.34-6.65-3.98v-131.25c0-4.32,2.98-9.53,6.65-11.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M133.78,469.39l5.02-2.9c.7-.4,1.26-.06,1.26,.75h0c0,2.05,1.41,2.89,3.16,1.89l25.68-14.8c1.75-1.01,3.16-3.48,3.16-5.53h0c0-.82,.57-1.81,1.26-2.21l5.02-2.9c3.67-2.12,6.65-.34,6.65,3.98v131.19c0,4.31-2.98,9.53-6.65,11.64l-44.57,25.69c-3.67,2.12-6.65,.34-6.65-3.98v-131.19c0-4.31,2.98-9.53,6.65-11.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.54,464.71l50.55-29.14c2.01-1.16,3.84-1.32,5.24-.67h0l4.01,2.15c-1.4-.68-3.25-.53-5.29,.65l-50.55,29.14c-4.36,2.51-7.89,8.7-7.89,13.82v139.21c0,2.42,.8,4.15,2.09,5.06l-3.06-1.65c-1.82-.65-2.99-2.59-2.99-5.53v-139.21c0-5.12,3.53-11.3,7.89-13.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.27,622.62h0c1.07,0,1.24-4.05,1.24-5.12v-138.57c.41-3.42,.02-4.73-1.05-4.73h0c-1.07,0-2.39,.1-2.82,4.73v138.57c0,3.29,1.56,5.12,2.63,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M120.23,622.49h.05c1.05,0,1.22-3.95,1.22-5v-138.56c.4-3.34,.01-4.62-1.04-4.62h-.05c-1.05,0-2.34,.1-2.76,4.62v138.56c0,3.21,1.53,5,2.57,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-484",
    d: "M120.18,622.36h.1c1.03,0,1.21-3.84,1.21-4.87v-138.54c.39-3.25,0-4.5-1.02-4.5h-.1c-1.03,0-2.3,.11-2.7,4.5v138.54c0,3.12,1.49,4.87,2.52,4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-483",
    d: "M120.14,622.23h.15c1.01,0,1.19-3.74,1.19-4.75v-138.52c.37-3.17,0-4.39-1.01-4.39h-.15c-1.01,0-2.25,.11-2.64,4.39v138.52c0,3.04,1.45,4.75,2.46,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-410",
    d: "M120.1,622.1h.2c.99,0,1.17-3.63,1.17-4.62v-138.51c.36-3.08-.01-4.28-1-4.28h-.2c-.99,0-2.2,.12-2.58,4.28v138.51c0,2.96,1.42,4.62,2.41,4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-397",
    d: "M120.05,621.96h.25c.97,0,1.16-3.53,1.16-4.5v-138.49c.35-3-.02-4.16-.99-4.16h-.25c-.97,0-2.15,.12-2.52,4.16v138.49c0,2.88,1.38,4.5,2.35,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M120.01,621.83h.3c.95,0,1.14-3.42,1.14-4.37v-138.48c.34-2.91-.03-4.05-.98-4.05h-.3c-.95,0-2.1,.13-2.46,4.05v138.48c0,2.8,1.35,4.37,2.3,4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M119.96,621.7h.35c.93,0,1.12-3.32,1.12-4.25v-138.46c.33-2.83-.04-3.94-.97-3.94h-.35c-.93,0-2.05,.14-2.4,3.94v138.46c0,2.72,1.31,4.25,2.24,4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M119.92,621.57h.4c.91,0,1.11-3.22,1.11-4.12v-138.45c.32-2.74-.05-3.82-.96-3.82h-.4c-.91,0-2,.14-2.34,3.82v138.45c0,2.64,1.28,4.12,2.19,4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M119.88,621.44h.45c.89,0,1.09-3.11,1.09-4v-138.43c.31-2.66-.06-3.71-.95-3.71h-.45c-.89,0-1.96,.15-2.28,3.71v138.43c0,2.55,1.24,4,2.13,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-452",
    d: "M119.83,621.31h.49c.87,0,1.07-3.01,1.07-3.88v-138.42c.3-2.57-.06-3.59-.93-3.59h-.49c-.87,0-1.91,.15-2.22,3.59v138.42c0,2.47,1.21,3.88,2.08,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M119.79,621.18h.54c.85,0,1.06-2.9,1.06-3.75v-138.4c.28-2.49-.07-3.48-.92-3.48h-.54c-.85,0-1.86,.16-2.16,3.48v138.4c0,2.39,1.17,3.75,2.02,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M119.74,621.04h.59c.83,0,1.04-2.8,1.04-3.63v-138.39c.27-2.4-.08-3.37-.91-3.37h-.59c-.83,0-1.81,.16-2.09,3.37v138.39c0,2.31,1.14,3.63,1.97,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M119.7,620.91h.64c.81,0,1.02-2.69,1.02-3.5v-138.37c.26-2.31-.09-3.25-.9-3.25h-.64c-.81,0-1.76,.17-2.03,3.25v138.37c0,2.23,1.1,3.5,1.91,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M119.66,620.78h.69c.79,0,1.01-2.59,1.01-3.38v-138.36c.25-2.23-.1-3.14-.89-3.14h-.69c-.79,0-1.71,.17-1.97,3.14v138.36c0,2.15,1.07,3.38,1.86,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M119.61,620.65h.74c.77,0,.99-2.48,.99-3.25v-138.34c.24-2.14-.11-3.03-.88-3.03h-.74c-.77,0-1.66,.18-1.91,3.03v138.34c0,2.06,1.03,3.25,1.8,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M119.57,620.52h.79c.75,0,.97-2.38,.97-3.13v-138.32c.23-2.06-.12-2.91-.87-2.91h-.79c-.75,0-1.61,.18-1.85,2.91v138.32c0,1.98,.99,3.13,1.75,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-398",
    d: "M119.52,620.39h.84c.73,0,.96-2.27,.96-3v-138.31c.22-1.97-.12-2.8-.85-2.8h-.84c-.73,0-1.57,.19-1.79,2.8v138.31c0,1.9,.96,3,1.69,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-519",
    d: "M119.48,620.26h.89c.71,0,.94-2.17,.94-2.88v-138.29c.2-1.89-.13-2.69-.84-2.69h-.89c-.71,0-1.52,.19-1.73,2.69v138.29c0,1.82,.92,2.88,1.63,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M119.44,620.12h.94c.69,0,.92-2.06,.92-2.76v-138.28c.19-1.8-.14-2.57-.83-2.57h-.94c-.69,0-1.47,.2-1.67,2.57v138.28c0,1.74,.89,2.76,1.58,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M119.39,619.99h.99c.67,0,.91-1.96,.91-2.63v-138.26c.18-1.72-.15-2.46-.82-2.46h-.99c-.67,0-1.42,.2-1.61,2.46v138.26c0,1.66,.85,2.63,1.52,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M119.35,619.86h1.04c.65,0,.89-1.86,.89-2.51v-138.25c.17-1.63-.16-2.34-.81-2.34h-1.04c-.65,0-1.37,.21-1.55,2.34v138.25c0,1.58,.82,2.51,1.47,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-434",
    d: "M119.3,619.73h1.09c.63,0,.87-1.75,.87-2.38v-138.23c.16-1.55-.17-2.23-.8-2.23h-1.09c-.63,0-1.32,.21-1.49,2.23v138.23c0,1.49,.78,2.38,1.41,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-511",
    d: "M119.26,619.6h1.14c.61,0,.86-1.65,.86-2.26v-138.22c.15-1.46-.18-2.12-.79-2.12h-1.14c-.61,0-1.27,.22-1.43,2.12v138.22c0,1.41,.75,2.26,1.36,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M119.22,619.47h1.19c.59,0,.84-1.54,.84-2.13v-138.2c.14-1.38-.18-2-.78-2h-1.19c-.59,0-1.22,.22-1.37,2v138.2c0,1.33,.71,2.13,1.3,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M119.17,619.34h1.24c.57,0,.82-1.44,.82-2.01v-138.19c.12-1.29-.19-1.89-.76-1.89h-1.24c-.57,0-1.18,.23-1.31,1.89v138.19c0,1.25,.68,2.01,1.25,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M119.13,619.2h1.29c.55,0,.81-1.33,.81-1.88v-138.17c.11-1.21-.2-1.78-.75-1.78h-1.29c-.55,0-1.13,.23-1.25,1.78v138.17c0,1.17,.64,1.88,1.19,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M119.08,619.07h1.34c.53,0,.79-1.23,.79-1.76v-138.15c.1-1.12-.21-1.66-.74-1.66h-1.34c-.53,0-1.08,.24-1.19,1.66v138.15c0,1.09,.61,1.76,1.14,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M119.04,618.94h1.39c.51,0,.77-1.12,.77-1.64v-138.14c.09-1.04-.22-1.55-.73-1.55h-1.39c-.51,0-1.03,.24-1.13,1.55v138.14c0,1.01,.57,1.64,1.08,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-430",
    d: "M119,618.81h1.43c.49,0,.76-1.02,.76-1.51v-138.12c.08-.95-.23-1.44-.72-1.44h-1.43c-.49,0-.98,.25-1.06,1.44v138.12c0,.92,.53,1.51,1.03,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M118.95,618.68h1.48c.47,0,.74-.91,.74-1.39v-138.11c.07-.87-.24-1.32-.71-1.32h-1.48c-.47,0-.93,.26-1,1.32v138.11c0,.84,.5,1.39,.97,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M118.91,618.55h1.53c.45,0,.72-.81,.72-1.26v-138.09c.06-.78-.24-1.21-.7-1.21h-1.53c-.45,0-.88,.26-.94,1.21v138.09c0,.76,.46,1.26,.92,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M118.86,618.42h1.58c.43,0,.71-.71,.71-1.14v-138.08c.05-.69-.25-1.09-.69-1.09h-1.58c-.43,0-.84,.27-.88,1.09v138.08c0,.68,.43,1.14,.86,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M118.82,618.28h1.63c.41,0,.69-.6,.69-1.01v-138.06c.03-.61-.26-.98-.67-.98h-1.63c-.41,0-.79,.27-.82,.98v138.06c0,.6,.39,1.01,.81,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M118.78,618.15h1.68c.39,0,.67-.5,.67-.89v-138.05c.02-.52-.27-.87-.66-.87h-1.68c-.39,0-.74,.28-.76,.87v138.05c0,.52,.36,.89,.75,.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M118.73,618.02h1.73c.37,0,.66-.39,.66-.76v-138.03c.01-.44-.28-.75-.65-.75h-1.73c-.37,0-.69,.28-.7,.75v138.03c0,.44,.32,.76,.7,.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 118.05,
    y: 478.59,
    width: 3.06,
    height: 139.3,
    rx: 0.64,
    ry: 0.64
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.24,473.92l2.43,.8c1.43-1.72,2.52-5.16,8.82-8.99l49.75-28.86c4.54-.44,2.55-.99,1.69-1.36l-.77-.32c-.86-.37-1.89-.56-4.04,.34l-53.47,31.1c-1.89,.99-4.38,5.6-4.41,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-505",
    d: "M119.32,473.84l2.4,.79c1.43-1.73,2.51-5.1,8.7-8.87l49.82-28.89c4.47-.44,2.51-.98,1.65-1.35l-.76-.32c-.85-.37-1.87-.55-3.98,.33l-53.47,31.1c-1.86,.98-4.35,5.53-4.37,7.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M119.39,473.75l2.36,.78c1.43-1.74,2.51-5.05,8.59-8.76l49.88-28.92c4.39-.43,2.46-.97,1.62-1.33l-.76-.32c-.84-.36-1.84-.54-3.92,.33l-53.46,31.09c-1.83,.96-4.31,5.45-4.32,7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M119.47,473.67l2.32,.77c1.43-1.74,2.5-5,8.47-8.64l49.95-28.96c4.31-.42,2.42-.95,1.59-1.31l-.75-.31c-.83-.36-1.82-.53-3.86,.32l-53.45,31.09c-1.8,.94-4.27,5.38-4.28,7.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M119.54,473.58l2.28,.75c1.44-1.75,2.5-4.95,8.36-8.52l50.02-28.99c4.23-.42,2.37-.94,1.56-1.29l-.74-.31c-.82-.35-1.79-.52-3.8,.31l-53.45,31.09c-1.77,.93-4.24,5.31-4.23,6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M119.61,473.5l2.24,.74c1.44-1.76,2.49-4.9,8.24-8.4l50.09-29.02c4.15-.41,2.33-.92,1.52-1.27l-.73-.3c-.8-.35-1.77-.51-3.73,.31l-53.44,31.08c-1.74,.91-4.2,5.23-4.19,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-400",
    d: "M119.69,473.41l2.2,.73c1.44-1.77,2.48-4.84,8.12-8.28l50.15-29.06c4.07-.4,2.29-.91,1.49-1.25l-.72-.3c-.79-.34-1.74-.51-3.67,.3l-53.43,31.08c-1.71,.89-4.17,5.16-4.14,6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-525",
    d: "M119.76,473.33l2.17,.72c1.44-1.78,2.48-4.79,8.01-8.16l50.22-29.09c3.99-.4,2.24-.9,1.46-1.23l-.71-.3c-.78-.34-1.72-.5-3.61,.29l-53.43,31.07c-1.67,.88-4.13,5.08-4.1,6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-461",
    d: "M119.84,473.24l2.13,.71c1.44-1.79,2.47-4.74,7.89-8.04l50.29-29.12c3.92-.39,2.2-.88,1.43-1.21l-.7-.29c-.77-.33-1.69-.49-3.55,.29l-53.42,31.07c-1.64,.86-4.1,5.01-4.05,6.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M119.91,473.16l2.09,.69c1.44-1.79,2.46-4.69,7.77-7.92l50.35-29.15c3.84-.38,2.15-.87,1.39-1.2l-.7-.29c-.76-.33-1.67-.48-3.49,.28l-53.42,31.06c-1.61,.85-4.06,4.93-4.01,6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M119.99,473.07l2.05,.68c1.44-1.8,2.46-4.64,7.66-7.8l50.42-29.19c3.76-.38,2.11-.86,1.36-1.18l-.69-.29c-.75-.32-1.64-.47-3.43,.27l-53.41,31.06c-1.58,.83-4.02,4.86-3.97,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M120.06,472.99l2.01,.67c1.44-1.81,2.45-4.58,7.54-7.68l50.49-29.22c3.68-.37,2.06-.84,1.33-1.16l-.68-.28c-.74-.32-1.62-.47-3.37,.27l-53.4,31.05c-1.55,.81-3.99,4.78-3.92,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M120.14,472.9l1.97,.66c1.44-1.82,2.45-4.53,7.43-7.56l50.56-29.25c3.6-.36,2.02-.83,1.3-1.14l-.67-.28c-.72-.31-1.6-.46-3.31,.26l-53.4,31.05c-1.52,.8-3.95,4.71-3.88,6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-419",
    d: "M120.21,472.82l1.94,.64c1.44-1.83,2.44-4.48,7.31-7.45l50.62-29.29c3.52-.36,1.98-.81,1.26-1.12l-.66-.28c-.71-.31-1.57-.45-3.25,.25l-53.39,31.04c-1.49,.78-3.92,4.64-3.83,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M120.29,472.73l1.9,.63c1.45-1.84,2.43-4.43,7.19-7.33l50.69-29.32c3.44-.35,1.93-.8,1.23-1.1l-.65-.27c-.7-.3-1.55-.44-3.19,.25l-53.38,31.04c-1.46,.76-3.88,4.56-3.79,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M120.36,472.65l1.86,.62c1.45-1.84,2.43-4.38,7.08-7.21l50.76-29.35c3.36-.34,1.89-.79,1.2-1.08l-.64-.27c-.69-.3-1.52-.43-3.13,.24l-53.38,31.04c-1.42,.75-3.84,4.49-3.74,6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M120.44,472.56l1.82,.61c1.45-1.85,2.42-4.32,6.96-7.09l50.82-29.39c3.29-.34,1.84-.77,1.17-1.06l-.63-.27c-.68-.29-1.5-.43-3.07,.24l-53.37,31.03c-1.39,.73-3.81,4.41-3.7,5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M120.51,472.48l1.78,.6c1.45-1.86,2.41-4.27,6.84-6.97l50.89-29.42c3.21-.33,1.8-.76,1.13-1.05l-.63-.26c-.67-.29-1.47-.42-3.01,.23l-53.36,31.03c-1.36,.72-3.77,4.34-3.65,5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M120.59,472.39l1.74,.58c1.45-1.87,2.41-4.22,6.73-6.85l50.96-29.45c3.13-.33,1.76-.74,1.1-1.03l-.62-.26c-.65-.28-1.45-.41-2.95,.22l-53.36,31.02c-1.33,.7-3.74,4.26-3.61,5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M120.66,472.31l1.71,.57c1.45-1.88,2.4-4.17,6.61-6.73l51.03-29.48c3.05-.32,1.71-.73,1.07-1.01l-.61-.26c-.64-.28-1.42-.4-2.89,.22l-53.35,31.02c-1.3,.68-3.7,4.19-3.57,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M120.73,472.22l1.67,.56c1.45-1.89,2.39-4.12,6.5-6.61l51.09-29.52c2.97-.31,1.67-.72,1.04-.99l-.6-.25c-.63-.27-1.4-.39-2.83,.21l-53.35,31.01c-1.27,.67-3.67,4.11-3.52,5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M120.81,472.14l1.63,.55c1.45-1.89,2.39-4.06,6.38-6.49l51.16-29.55c2.89-.31,1.62-.7,1-.97l-.59-.25c-.62-.27-1.37-.39-2.76,.2l-53.34,31.01c-1.24,.65-3.63,4.04-3.48,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M120.88,472.05l1.59,.54c1.45-1.9,2.38-4.01,6.26-6.37l51.23-29.58c2.81-.3,1.58-.69,.97-.95l-.58-.24c-.61-.26-1.35-.38-2.7,.2l-53.33,31c-1.2,.63-3.59,3.96-3.43,5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-403",
    d: "M120.96,471.97l1.55,.52c1.45-1.91,2.38-3.96,6.15-6.25l51.29-29.62c2.74-.29,1.53-.68,.94-.93l-.57-.24c-.6-.26-1.32-.37-2.64,.19l-53.33,31c-1.17,.62-3.56,3.89-3.39,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M121.03,471.88l1.51,.51c1.46-1.92,2.37-3.91,6.03-6.14l51.36-29.65c2.66-.29,1.49-.66,.91-.91l-.57-.24c-.59-.25-1.3-.36-2.58,.18l-53.32,30.99c-1.14,.6-3.52,3.82-3.34,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M121.11,471.8l1.48,.5c1.46-1.93,2.36-3.86,5.91-6.02l51.43-29.68c2.58-.28,1.45-.65,.87-.9l-.56-.23c-.57-.25-1.27-.35-2.52,.18l-53.31,30.99c-1.11,.59-3.49,3.74-3.3,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-401",
    d: "M121.18,471.71l1.44,.49c1.46-1.94,2.36-3.8,5.8-5.9l51.5-29.72c2.5-.27,1.4-.63,.84-.88l-.55-.23c-.56-.24-1.25-.35-2.46,.17l-53.31,30.99c-1.08,.57-3.45,3.67-3.25,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M121.26,471.63l1.4,.48c1.46-1.94,2.35-3.75,5.68-5.78l51.56-29.75c2.42-.27,1.36-.62,.81-.86l-.54-.23c-.55-.24-1.22-.34-2.4,.16l-53.3,30.98c-1.05,.55-3.42,3.59-3.21,4.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M121.33,471.54l1.36,.46c1.46-1.95,2.34-3.7,5.56-5.66l51.63-29.78c2.34-.26,1.31-.61,.77-.84l-.53-.22c-.54-.23-1.2-.33-2.34,.16l-53.3,30.98c-1.02,.54-3.38,3.52-3.16,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-440",
    d: "M121.41,471.46l1.32,.45c1.46-1.96,2.34-3.65,5.45-5.54l51.7-29.82c2.26-.25,1.27-.59,.74-.82l-.52-.22c-.53-.23-1.17-.32-2.28,.15l-53.29,30.97c-.99,.52-3.34,3.44-3.12,4.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-454",
    d: "M121.48,471.37l1.28,.44c1.46-1.97,2.33-3.6,5.33-5.42l51.76-29.85c2.18-.25,1.23-.58,.71-.8l-.51-.22c-.52-.22-1.15-.31-2.22,.15l-53.28,30.97c-.95,.5-3.31,3.37-3.08,4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M121.56,471.29l1.25,.43c1.46-1.98,2.33-3.54,5.22-5.3l51.83-29.88c2.11-.24,1.18-.57,.68-.78l-.51-.21c-.5-.22-1.12-.3-2.16,.14l-53.28,30.96c-.92,.49-3.27,3.29-3.03,4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M121.63,471.2l1.21,.41c1.46-1.99,2.32-3.49,5.1-5.18l51.9-29.91c2.03-.24,1.14-.55,.64-.76l-.5-.21c-.49-.21-1.1-.3-2.1,.13l-53.27,30.96c-.89,.47-3.24,3.22-2.99,4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M121.71,471.12l1.17,.4c1.46-1.99,2.31-3.44,4.98-5.06l51.97-29.95c1.95-.23,1.09-.54,.61-.75l-.49-.21c-.48-.21-1.07-.29-2.04,.13l-53.26,30.95c-.86,.46-3.2,3.15-2.94,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M121.78,471.03l1.13,.39c1.47-2,2.31-3.39,4.87-4.95l52.03-29.98c1.87-.22,1.05-.52,.58-.73l-.48-.2c-.47-.2-1.05-.28-1.98,.12l-53.26,30.95c-.83,.44-3.16,3.07-2.9,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-485",
    d: "M121.85,470.95l1.09,.38c1.47-2.01,2.3-3.34,4.75-4.83l52.1-30.01c1.79-.22,1-.51,.55-.71l-.47-.2c-.46-.2-1.02-.27-1.92,.11l-53.25,30.94c-.8,.42-3.13,3-2.85,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-448",
    d: "M121.93,470.86l1.06,.37c1.47-2.02,2.29-3.28,4.63-4.71l52.17-30.05c1.71-.21,.96-.5,.51-.69l-.46-.2c-.45-.19-1-.26-1.86,.11l-53.24,30.94c-.77,.41-3.09,2.92-2.81,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M122,470.78l1.02,.35c1.47-2.03,2.29-3.23,4.52-4.59l52.23-30.08c1.63-.2,.92-.48,.48-.67l-.45-.19c-.44-.19-.97-.26-1.79,.1l-53.24,30.94c-.73,.39-3.06,2.85-2.76,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M122.08,470.69l.98,.34c1.47-2.04,2.28-3.18,4.4-4.47l52.3-30.11c1.56-.2,.87-.47,.45-.65l-.44-.19c-.42-.18-.95-.25-1.73,.09l-53.23,30.93c-.7,.37-3.02,2.77-2.72,4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M122.15,470.61l.94,.33c1.47-2.04,2.28-3.13,4.29-4.35l52.37-30.15c1.48-.19,.83-.46,.42-.63l-.44-.18c-.41-.18-.93-.24-1.67,.09l-53.23,30.93c-.67,.36-2.99,2.7-2.68,3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M122.23,470.53l.9,.32c1.47-2.05,2.27-3.08,4.17-4.23l52.44-30.18c1.4-.18,.78-.44,.38-.61l-.43-.18c-.4-.17-.9-.23-1.61,.08l-53.22,30.92c-.64,.34-2.95,2.62-2.63,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M122.3,470.44l.86,.31c1.47-2.06,2.26-3.02,4.05-4.11l52.5-30.21c1.32-.18,.74-.43,.35-.6l-.42-.18c-.39-.17-.88-.22-1.55,.07l-53.21,30.92c-.61,.32-2.91,2.55-2.59,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M122.38,470.36l.83,.29c1.47-2.07,2.26-2.97,3.94-3.99l52.57-30.24c1.24-.17,.7-.41,.32-.58l-.41-.17c-.38-.16-.85-.22-1.49,.07l-53.21,30.91c-.58,.31-2.88,2.47-2.54,3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-422",
    d: "M122.45,470.27l.79,.28c1.47-2.08,2.25-2.92,3.82-3.87l52.64-30.28c1.16-.16,.65-.4,.29-.56l-.4-.17c-.37-.16-.83-.21-1.43,.06l-53.2,30.91c-.55,.29-2.84,2.4-2.5,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M122.53,470.19l.75,.27c1.48-2.09,2.24-2.87,3.7-3.75l52.7-30.31c1.08-.16,.61-.39,.25-.54l-.39-.17c-.35-.15-.8-.2-1.37,.06l-53.19,30.9c-.52,.28-2.81,2.33-2.45,3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M122.6,470.1l.71,.26c1.48-2.09,2.24-2.82,3.59-3.64l52.77-30.34c1-.15,.56-.37,.22-.52l-.38-.16c-.34-.15-.78-.19-1.31,.05l-53.19,30.9c-.48,.26-2.77,2.25-2.41,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M122.68,470.02l.67,.25c1.48-2.1,2.23-2.76,3.47-3.52l52.84-30.38c.93-.15,.52-.36,.19-.5l-.38-.16c-.33-.14-.75-.18-1.25,.04l-53.18,30.89c-.45,.24-2.74,2.18-2.36,3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M122.75,469.93l.63,.23c1.48-2.11,2.23-2.71,3.35-3.4l52.91-30.41c.85-.14,.47-.35,.16-.48l-.37-.16c-.32-.14-.73-.18-1.19,.04l-53.17,30.89c-.42,.23-2.7,2.1-2.32,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-417",
    d: "M122.83,469.85l.6,.22c1.48-2.12,2.22-2.66,3.24-3.28l52.97-30.44c.77-.13,.43-.33,.12-.46l-.36-.15c-.31-.13-.7-.17-1.13,.03l-53.17,30.89c-.39,.21-2.66,2.03-2.27,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M122.9,469.76l.56,.21c1.48-2.13,2.21-2.61,3.12-3.16l53.04-30.48c.69-.13,.39-.32,.09-.45l-.35-.15c-.3-.13-.68-.16-1.07,.02l-53.16,30.88c-.36,.19-2.63,1.95-2.23,3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M122.97,469.68l.52,.2c1.48-2.14,2.21-2.56,3.01-3.04l53.11-30.51c.61-.12,.34-.3,.06-.43l-.34-.15c-.28-.12-.65-.15-1.01,.02l-53.16,30.88c-.33,.18-2.59,1.88-2.19,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M123.05,469.59l.48,.19c1.48-2.15,2.2-2.51,2.89-2.92l53.17-30.54c.53-.11,.3-.29,.02-.41l-.33-.14c-.27-.12-.63-.14-.95,0l-53.15,30.87c-.3,.16-2.56,1.8-2.14,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-413",
    d: "M123.12,469.51l.44,.17c1.48-2.15,2.19-2.45,2.77-2.8l53.24-30.57c.45-.11,.25-.28,0-.39l-.32-.14c-.26-.11-.6-.14-.89,0l-53.14,30.87c-.26,.15-2.52,1.73-2.1,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-413",
    d: "M123.2,469.42l.4,.16c1.48-2.16,2.19-2.4,2.66-2.68l53.31-30.61c.38-.1,.21-.26-.04-.37l-.31-.14c-.25-.11-.58-.13-.82,0l-53.14,30.86c-.23,.13-2.48,1.66-2.05,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M123.27,469.34l.37,.15c1.48-2.17,2.18-2.35,2.54-2.56l53.38-30.64c.3-.09,.17-.25-.07-.35l-.31-.13c-.24-.1-.55-.12-.76,0l-53.13,30.86c-.2,.11-2.45,1.58-2.01,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M123.35,469.25l.33,.14c1.49-2.18,2.18-2.3,2.42-2.44l53.44-30.67c.22-.09,.12-.24-.11-.33l-.3-.13c-.23-.1-.53-.11-.7-.02l-53.12,30.85c-.17,.1-2.41,1.51-1.96,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M123.42,469.17l.29,.12c1.49-2.19,2.17-2.25,2.31-2.33l53.51-30.71c.14-.08,.08-.22-.14-.31l-.29-.12c-.22-.09-.5-.1-.64-.02l-53.12,30.85c-.14,.08-2.38,1.43-1.92,2.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.65,484.98s1.64,1.06,3.97,.11l-.02,.73s-2.1,.79-3.95-.21v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M130.15,467.02l49.14-28.71c2.78-1.62,5.21-1.28,6.55,.57-1.4-1.3-3.56-1.4-6,.03l-48.91,28.57c-4.22,2.46-7.64,8.53-7.64,13.54v136.49c0,4.27,2.48,6.4,5.82,5.41-3.75,1.59-6.65-.53-6.65-5.15v-137.14c0-5.04,3.44-11.13,7.67-13.61Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.87,511.66h0c.57,0,.66-.44,.66-.55v-14.95c0-.31-.06-.46-.56-.51h0c-.57,0-1.53-.12-1.51,.51v14.95c0,.62,.84,.55,1.41,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M119.84,511.65h.04c.56,0,.65-.43,.65-.54v-14.94c0-.3-.06-.45-.55-.5h-.04c-.56,0-1.49-.11-1.47,.5v14.94c0,.6,.81,.54,1.37,.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M119.81,511.63h.07c.55,0,.64-.42,.64-.53v-14.94c0-.29-.06-.44-.54-.49h-.07c-.55,0-1.45-.11-1.44,.49v14.94c0,.59,.79,.53,1.34,.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M119.79,511.62h.11c.53,0,.62-.41,.62-.52v-14.93c0-.29-.06-.43-.53-.48h-.11c-.53,0-1.41-.1-1.4,.48v14.93c0,.57,.77,.52,1.3,.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M119.76,511.61h.15c.52,0,.61-.4,.61-.51v-14.93c0-.28-.06-.43-.52-.47h-.15c-.52,0-1.38-.1-1.36,.47v14.93c0,.56,.75,.51,1.27,.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M119.73,511.59h.19c.5,0,.59-.39,.59-.5v-14.92c0-.28-.06-.42-.5-.46h-.19c-.5,0-1.34-.09-1.32,.46v14.92c0,.54,.73,.5,1.23,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M119.7,511.58h.22c.49,0,.58-.38,.58-.49v-14.91c0-.27-.06-.41-.49-.45h-.22c-.49,0-1.3-.09-1.29,.45v14.91c0,.53,.71,.49,1.2,.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M119.67,511.56h.26c.48,0,.57-.37,.57-.47v-14.91c0-.26-.06-.4-.48-.44h-.26c-.48,0-1.26-.08-1.25,.44v14.91c0,.51,.69,.47,1.16,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M119.64,511.55h.3c.46,0,.55-.36,.55-.46v-14.9c0-.26-.06-.39-.47-.43h-.3c-.46,0-1.22-.08-1.21,.43v14.9c0,.5,.67,.46,1.13,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M119.61,511.53h.33c.45,0,.54-.35,.54-.45v-14.89c0-.25-.06-.38-.46-.42h-.33c-.45,0-1.18-.07-1.17,.42v14.89c0,.48,.64,.45,1.09,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M119.58,511.52h.37c.44,0,.52-.33,.52-.44v-14.89c0-.25-.06-.37-.45-.41h-.37c-.44,0-1.15-.07-1.13,.41v14.89c0,.47,.62,.44,1.06,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M119.56,511.51h.41c.42,0,.51-.32,.51-.43v-14.88c0-.24-.06-.37-.44-.4h-.41c-.42,0-1.11-.06-1.1,.4v14.88c0,.45,.6,.43,1.03,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M119.53,511.49h.44c.41,0,.49-.31,.49-.42v-14.87c0-.23-.06-.36-.43-.39h-.44c-.41,0-1.07-.06-1.06,.39v14.87c0,.44,.58,.42,.99,.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-501",
    d: "M119.5,511.48h.48c.4,0,.48-.3,.48-.41v-14.87c0-.23-.06-.35-.41-.38h-.48c-.4,0-1.03-.05-1.02,.38v14.87c0,.42,.56,.41,.96,.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M119.47,511.46h.52c.38,0,.47-.29,.47-.4v-14.86c0-.22-.06-.34-.4-.37h-.52c-.38,0-.99-.05-.98,.37v14.86c0,.41,.54,.4,.92,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-480",
    d: "M119.44,511.45h.56c.37,0,.45-.28,.45-.39v-14.86c0-.21-.06-.33-.39-.36h-.56c-.37,0-.96-.04-.95,.36v14.86c0,.39,.52,.39,.89,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M119.41,511.43h.59c.36,0,.44-.27,.44-.38v-14.85c0-.21-.06-.32-.38-.35h-.59c-.36,0-.92-.03-.91,.35v14.85c0,.38,.5,.38,.85,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-527",
    d: "M119.38,511.42h.63c.34,0,.42-.26,.42-.36v-14.84c0-.2-.06-.32-.37-.34h-.63c-.34,0-.88-.03-.87,.34v14.84c0,.37,.47,.36,.82,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-465",
    d: "M119.35,511.41h.67c.33,0,.41-.25,.41-.35v-14.84c0-.2-.06-.31-.36-.33h-.67c-.33,0-.84-.02-.83,.33v14.84c0,.35,.45,.35,.78,.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-530",
    d: "M119.32,511.39h.7c.32,0,.39-.24,.39-.34v-14.83c0-.19-.06-.3-.35-.32h-.7c-.32,0-.8-.02-.8,.32v14.83c0,.34,.43,.34,.75,.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M119.3,511.38h.74c.3,0,.38-.23,.38-.33v-14.82c0-.18-.06-.29-.33-.31h-.74c-.3,0-.76-.01-.76,.31v14.82c0,.32,.41,.33,.71,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M119.27,511.36h.78c.29,0,.37-.22,.37-.32v-14.82c0-.18-.06-.28-.32-.3h-.78c-.29,0-.73,0-.72,.3v14.82c0,.31,.39,.32,.68,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M119.24,511.35h.81c.27,0,.35-.21,.35-.31v-14.81c0-.17-.06-.27-.31-.29h-.81c-.27,0-.69,0-.68,.29v14.81c0,.29,.37,.31,.64,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-408",
    d: "M119.21,511.34h.85c.26,0,.34-.2,.34-.3v-14.8c0-.17-.06-.26-.3-.28h-.85c-.26,0-.65,0-.64,.28v14.8c0,.28,.35,.3,.61,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M119.18,511.32h.89c.25,0,.32-.19,.32-.29v-14.8c0-.16-.06-.26-.29-.27h-.89c-.25,0-.61,0-.61,.27v14.8c0,.26,.32,.29,.57,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M119.15,511.31h.93c.23,0,.31-.18,.31-.28v-14.79c0-.15-.06-.25-.28-.26h-.93c-.23,0-.57,.01-.57,.26v14.79c0,.25,.3,.28,.54,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M119.12,511.29h.96c.22,0,.3-.17,.3-.26v-14.79c0-.15-.07-.24-.27-.25h-.96c-.22,0-.54,.02-.53,.25v14.79c0,.23,.28,.26,.5,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M119.09,511.28h1c.21,0,.28-.16,.28-.25v-14.78c0-.14-.07-.23-.26-.24h-1c-.21,0-.5,.02-.49,.24v14.78c0,.22,.26,.25,.47,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-489",
    d: "M119.06,511.26h1.04c.19,0,.27-.15,.27-.24v-14.77c0-.13-.07-.22-.24-.23h-1.04c-.19,0-.46,.03-.46,.23v14.77c0,.2,.24,.24,.43,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M119.04,511.25h1.07c.18,0,.25-.14,.25-.23v-14.77c0-.13-.07-.21-.23-.22h-1.07c-.18,0-.42,.03-.42,.22v14.77c0,.19,.22,.23,.4,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-438",
    d: "M119.01,511.24h1.11c.17,0,.24-.13,.24-.22v-14.76c0-.12-.07-.2-.22-.21h-1.11c-.17,0-.38,.04-.38,.21v14.76c0,.17,.2,.22,.36,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-518",
    d: "M118.98,511.22h1.15c.15,0,.22-.12,.22-.21v-14.75c0-.12-.07-.2-.21-.2h-1.15c-.15,0-.34,.04-.34,.2v14.75c0,.16,.18,.21,.33,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M118.95,511.21h1.18c.14,0,.21-.11,.21-.2v-14.75c0-.11-.07-.19-.2-.19h-1.18c-.14,0-.31,.05-.3,.19v14.75c0,.14,.15,.2,.29,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M118.92,511.19h1.22c.13,0,.2-.1,.2-.19v-14.74c0-.1-.07-.18-.19-.18h-1.22c-.13,0-.27,.05-.27,.18v14.74c0,.13,.13,.19,.26,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-513",
    d: "M118.89,511.18h1.26c.11,0,.18-.09,.18-.18v-14.73c0-.1-.07-.17-.18-.17h-1.26c-.11,0-.23,.06-.23,.17v14.73c0,.11,.11,.18,.22,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M118.86,511.17h1.3c.1,0,.17-.08,.17-.17v-14.73c0-.09-.07-.16-.17-.16h-1.3c-.1,0-.19,.06-.19,.16v14.73c0,.1,.09,.17,.19,.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-473",
    x: 118.68,
    y: 496.12,
    width: 1.64,
    height: 15.03,
    rx: 0.15,
    ry: 0.15
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.87,521.15h0c.57,0,.66-.23,.66-.29v-7.96c0-.16-.06-.24-.56-.27h0c-.57,0-1.53-.06-1.51,.27v7.96c0,.33,.84,.29,1.41,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-475",
    d: "M119.84,521.14h.04c.56,0,.65-.23,.65-.29v-7.96c0-.16-.06-.24-.55-.27h-.04c-.56,0-1.49-.06-1.47,.27v7.96c0,.32,.81,.29,1.37,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-462",
    d: "M119.81,521.13h.08c.54,0,.63-.22,.63-.28v-7.95c0-.16-.06-.24-.54-.26h-.08c-.54,0-1.45-.06-1.43,.26v7.95c0,.31,.79,.28,1.34,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M119.78,521.13h.12c.53,0,.62-.22,.62-.28v-7.95c0-.15-.05-.23-.52-.26h-.12c-.53,0-1.41-.05-1.4,.26v7.95c0,.31,.77,.28,1.3,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-504",
    d: "M119.75,521.12h.16c.52,0,.6-.21,.6-.27v-7.94c0-.15-.05-.23-.51-.25h-.16c-.52,0-1.37-.05-1.36,.25v7.94c0,.3,.75,.27,1.26,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M119.72,521.11h.2c.5,0,.59-.21,.59-.27v-7.94c0-.15-.05-.23-.5-.25h-.2c-.5,0-1.33-.05-1.32,.25v7.94c0,.29,.73,.27,1.23,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M119.69,521.1h.24c.49,0,.57-.2,.57-.26v-7.93c0-.15-.05-.22-.49-.25h-.24c-.49,0-1.29-.04-1.28,.25v7.93c0,.28,.71,.26,1.19,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M119.66,521.09h.28c.47,0,.56-.2,.56-.26v-7.93c0-.14-.05-.22-.47-.24h-.28c-.47,0-1.25-.04-1.24,.24v7.93c0,.28,.68,.26,1.16,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-409",
    d: "M119.63,521.09h.31c.46,0,.54-.19,.54-.25v-7.92c0-.14-.05-.22-.46-.24h-.31c-.46,0-1.21-.04-1.2,.24v7.92c0,.27,.66,.25,1.12,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M119.6,521.08h.35c.44,0,.53-.19,.53-.25v-7.92c0-.14-.05-.21-.45-.23h-.35c-.44,0-1.17-.03-1.16,.23v7.92c0,.26,.64,.25,1.08,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M119.57,521.07h.39c.43,0,.51-.18,.51-.24v-7.91c0-.14-.05-.21-.44-.23h-.39c-.43,0-1.14-.03-1.12,.23v7.91c0,.25,.62,.24,1.05,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-477",
    d: "M119.54,521.06h.43c.42,0,.5-.18,.5-.24v-7.91c0-.13-.05-.2-.42-.22h-.43c-.42,0-1.1-.03-1.08,.22v7.91c0,.25,.6,.24,1.01,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M119.51,521.06h.47c.4,0,.48-.17,.48-.23v-7.9c0-.13-.05-.2-.41-.22h-.47c-.4,0-1.06-.02-1.05,.22v7.9c0,.24,.57,.23,.98,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M119.48,521.05h.51c.39,0,.46-.17,.46-.23v-7.9c0-.13-.05-.2-.4-.21h-.51c-.39,0-1.02-.02-1.01,.21v7.9c0,.23,.55,.23,.94,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M119.45,521.04h.55c.37,0,.45-.16,.45-.22v-7.89c0-.12-.05-.19-.39-.21h-.55c-.37,0-.98-.02-.97,.21v7.89c0,.22,.53,.22,.9,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M119.42,521.03h.59c.36,0,.43-.16,.43-.22v-7.89c0-.12-.05-.19-.37-.21h-.59c-.36,0-.94-.02-.93,.21v7.89c0,.22,.51,.22,.87,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M119.39,521.03h.63c.35,0,.42-.15,.42-.21v-7.88c0-.12-.05-.19-.36-.2h-.63c-.35,0-.9-.01-.89,.2v7.88c0,.21,.49,.21,.83,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M119.36,521.02h.67c.33,0,.4-.15,.4-.21v-7.88c0-.12-.05-.18-.35-.2h-.67c-.33,0-.86,0-.85,.2v7.88c0,.2,.47,.21,.8,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-426",
    d: "M119.33,521.01h.71c.32,0,.39-.14,.39-.2v-7.87c0-.11-.05-.18-.34-.19h-.71c-.32,0-.82,0-.81,.19v7.87c0,.2,.44,.2,.76,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M119.3,521h.75c.3,0,.37-.14,.37-.2v-7.87c0-.11-.05-.17-.32-.19h-.75c-.3,0-.78,0-.77,.19v7.87c0,.19,.42,.2,.72,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M119.27,521h.79c.29,0,.36-.13,.36-.19v-7.86c0-.11-.05-.17-.31-.18h-.79c-.29,0-.74,0-.73,.18v7.86c0,.18,.4,.19,.69,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M119.24,520.99h.83c.27,0,.34-.13,.34-.19v-7.86c0-.1-.05-.17-.3-.18h-.83c-.27,0-.7,0-.7,.18v7.86c0,.17,.38,.19,.65,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M119.21,520.98h.87c.26,0,.33-.12,.33-.18v-7.85c0-.1-.05-.16-.29-.17h-.87c-.26,0-.66,0-.66,.17v7.85c0,.17,.36,.18,.62,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M119.18,520.97h.9c.25,0,.31-.12,.31-.18v-7.85c0-.1-.05-.16-.27-.17h-.9c-.25,0-.62,0-.62,.17v7.85c0,.16,.33,.18,.58,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M119.15,520.97h.94c.23,0,.3-.11,.3-.17v-7.84c0-.1-.05-.16-.26-.17h-.94c-.23,0-.58,.01-.58,.17v7.84c0,.15,.31,.17,.54,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M119.12,520.96h.98c.22,0,.28-.11,.28-.17v-7.84c0-.09-.05-.15-.25-.16h-.98c-.22,0-.55,.02-.54,.16v7.84c0,.14,.29,.17,.51,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M119.09,520.95h1.02c.2,0,.27-.1,.27-.16v-7.83c0-.09-.05-.15-.24-.16h-1.02c-.2,0-.51,.02-.5,.16v7.83c0,.14,.27,.16,.47,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M119.06,520.94h1.06c.19,0,.25-.1,.25-.16v-7.83c0-.09-.05-.15-.22-.15h-1.06c-.19,0-.47,.02-.46,.15v7.83c0,.13,.25,.16,.44,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M119.03,520.94h1.1c.18,0,.24-.09,.24-.15v-7.82c0-.08-.05-.14-.21-.15h-1.1c-.18,0-.43,.03-.42,.15v7.82c0,.12,.22,.15,.4,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-433",
    d: "M119,520.93h1.14c.16,0,.22-.09,.22-.15v-7.82c0-.08-.05-.14-.2-.14h-1.14c-.16,0-.39,.03-.38,.14v7.82c0,.11,.2,.15,.36,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M118.97,520.92h1.18c.15,0,.2-.08,.2-.14v-7.81c0-.08-.05-.13-.19-.14h-1.18c-.15,0-.35,.03-.35,.14v7.81c0,.11,.18,.14,.33,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M118.94,520.91h1.22c.13,0,.19-.08,.19-.14v-7.81c0-.08-.05-.13-.17-.13h-1.22c-.13,0-.31,.03-.31,.13v7.81c0,.1,.16,.14,.29,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M118.91,520.91h1.26c.12,0,.17-.07,.17-.13v-7.8c0-.07-.05-.13-.16-.13h-1.26c-.12,0-.27,.04-.27,.13v7.8c0,.09,.14,.13,.26,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-450",
    d: "M118.88,520.9h1.3c.1,0,.16-.07,.16-.13v-7.8c0-.07-.05-.12-.15-.13h-1.3c-.1,0-.23,.04-.23,.13v7.8c0,.08,.12,.13,.22,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M118.85,520.89h1.34c.09,0,.14-.06,.14-.12v-7.79c0-.07-.05-.12-.14-.12h-1.34c-.09,0-.19,.04-.19,.12v7.79c0,.08,.09,.12,.18,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M118.82,520.88h1.38c.08,0,.13-.06,.13-.12v-7.79c0-.06-.05-.12-.12-.12h-1.38c-.08,0-.15,.05-.15,.12v7.79c0,.07,.07,.12,.15,.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 118.68,
    y: 512.87,
    width: 1.64,
    height: 8,
    rx: 0.11,
    ry: 0.11
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 186.52,
    y: 449.41,
    width: 1.37,
    height: 121.83,
    transform: "translate(374.42 1020.66) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M125.75,467.67l54.01-30.36c.52-.31,.69-.97,.38-1.49h0c-.31-.52-.97-.69-1.49-.38l-54.01,30.36c-.52,.31-.69,.97-.38,1.49h0c.31,.52,.97,.69,1.49,.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-423",
    d: "M153.41,458.78l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96h0c0,.36,.25,.5,.55,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M152.86,458.44h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M152.86,458.43h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-449",
    d: "M152.85,458.41h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-432",
    d: "M152.85,458.4h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-529",
    d: "M152.85,458.38h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M152.84,458.37h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M152.84,458.35h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M152.84,458.34h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-436",
    d: "M152.83,458.32h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M152.83,458.31h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M152.83,458.29h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M152.82,458.28h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M152.82,458.26h0c0,.36,.25,.5,.55,.33l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M153.36,458.57l7.01-4.04c.3-.17,.55-.6,.55-.96h0c0-.36-.25-.5-.55-.33l-7.01,4.04c-.3,.17-.55,.6-.55,.96h0c0,.36,.25,.5,.55,.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M149.35,460.51c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M149.35,460.49c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M149.34,460.47c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M149.34,460.45c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-502",
    d: "M149.33,460.42c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-466",
    d: "M149.33,460.4c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M149.32,460.38c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M149.32,460.36c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.31,460.34c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M149.31,460.32c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M149.3,460.3c0,.37,.26,.52,.57,.34,.32-.18,.57-.63,.57-1s-.26-.52-.57-.34c-.32,.18-.57,.63-.57,1Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M184.18,553.24h.61v-106.71c0-1.83-.63-3.2-1.77-3.86-1.12-.64-2.57-.52-4.1,.36l-5.25,2.91c-.66,.38-1.18,1.29-1.18,2.06,0,1.62-1.15,4.34-2.44,5.09l-20.89,12.04,.3,.53,20.89-12.04c1.48-.85,2.75-3.8,2.75-5.62,0-.56,.4-1.26,.87-1.53l5.25-2.91c1.33-.77,2.57-.9,3.49-.37,.95,.55,1.47,1.73,1.47,3.33v106.71Z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-75",
    cx: 273.07,
    cy: 345.98,
    rx: 42.45,
    ry: 43.57,
    transform: "translate(-166.95 371.48) rotate(-55.03)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-70",
    cx: 276.51,
    cy: 471.16,
    rx: 42.45,
    ry: 43.57,
    transform: "translate(-268.07 427.77) rotate(-55.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-64",
    cx: 309.63,
    cy: 451.37,
    rx: 42.45,
    ry: 43.57,
    transform: "translate(-237.71 446.44) rotate(-55.03)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 353.51,
    cy: 521.49,
    rx: 42.45,
    ry: 43.57,
    transform: "translate(-276.44 512.37) rotate(-55.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-82",
    cx: 319.95,
    cy: 501.27,
    rx: 31.85,
    ry: 55.99,
    transform: "translate(-274.19 476.21) rotate(-55.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-57",
    cx: 344.04,
    cy: 474.31,
    rx: 31.85,
    ry: 55.99,
    transform: "translate(-241.82 484.44) rotate(-55.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 274.93,
    cy: 518.76,
    rx: 31.85,
    ry: 55.99,
    transform: "translate(-307.75 446.78) rotate(-55.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-78",
    cx: 364.98,
    cy: 576.4,
    rx: 31.85,
    ry: 55.99,
    transform: "translate(-276.86 807.68) rotate(-77.47)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-63",
    cx: 237.79,
    cy: 492.67,
    rx: 42.45,
    ry: 43.57,
    transform: "translate(-302.22 405.22) rotate(-55.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-81",
    cx: 178.36,
    cy: 627.93,
    rx: 42.45,
    ry: 43.57,
    transform: "translate(-438.44 414.23) rotate(-55.03)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-61",
    cx: 158.68,
    cy: 613.59,
    rx: 42.45,
    ry: 43.57,
    transform: "translate(-435.09 392) rotate(-55.04)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-62",
    cx: 299.45,
    cy: 331.07,
    rx: 42.45,
    ry: 43.57,
    transform: "translate(-143.47 386.71) rotate(-55.03)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M227.03,408.63c45.87-8.07,142.16-58.59,215.05-112.84,72.9-54.25,94.8-91.69,48.93-83.62-45.88,8.07-142.17,58.6-215.06,112.84-72.9,54.25-94.8,91.69-48.92,83.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M482.25,314.33l184.38-106.39s-1.81-1.37-2.75-.9l-183.69,106.02c-.17,.1-.27,.27-.27,.47v106.81c0,.8,2.06,1.95,2.06,1.95v-107.49c0-.19,.1-.37,.27-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M481.97,314.82v107.3c0,.41,.45,.67,.81,.46l184.37-106.57c.17-.1,.27-.27,.27-.47l-.15-107.05c0-.41-.45-.67-.81-.46l-184.23,106.33c-.17,.1-.27,.27-.27,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M629.6,225.71c-16.5,6.47-54.98,27.54-85.94,47.06-30.96,19.52-42.69,30.1-26.19,23.63,16.5-6.47,54.98-27.54,85.94-47.06,30.96-19.52,42.69-30.1,26.18-23.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M479.4,312.9c-1.27,17.52-1.55,61.38-.62,97.95,.93,36.57,2.71,52.02,3.98,34.49,1.27-17.53,1.55-61.38,.62-97.96-.93-36.57-2.71-52.02-3.98-34.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-445"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "490.69 359.33 488.61 360.49 488.61 403.85 490.69 402.7 490.69 359.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "494.43 357.26 492.35 358.41 492.35 401.78 494.43 400.62 494.43 357.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "498.17 355.18 496.09 356.33 496.09 399.7 498.17 398.55 498.17 355.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "501.92 353.1 499.84 354.26 499.84 397.62 501.92 396.47 501.92 353.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "505.66 351.03 503.58 352.18 503.58 395.55 505.66 394.39 505.66 351.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "509.4 348.95 507.32 350.1 507.32 393.47 509.4 392.32 509.4 348.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "513.14 346.87 511.06 348.03 511.06 391.39 513.14 390.24 513.14 346.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "516.89 344.8 514.81 345.95 514.81 389.32 516.89 388.16 516.89 344.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "520.63 342.72 518.55 343.87 518.55 387.24 520.63 386.09 520.63 342.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "524.37 340.64 522.29 341.8 522.29 385.16 524.37 384.01 524.37 340.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "528.12 338.57 526.04 339.72 526.04 383.09 528.12 381.93 528.12 338.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "531.86 336.49 529.78 337.64 529.78 381.01 531.86 379.86 531.86 336.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "535.6 334.41 533.52 335.57 533.52 378.93 535.6 377.78 535.6 334.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "539.34 332.34 537.27 333.49 537.27 376.86 539.34 375.7 539.34 332.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "543.09 330.26 541.01 331.41 541.01 374.78 543.09 373.62 543.09 330.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "546.83 328.18 544.75 329.34 544.75 372.7 546.83 371.55 546.83 328.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "550.57 326.11 548.49 327.26 548.49 370.63 550.57 369.47 550.57 326.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "554.32 324.03 552.24 325.18 552.24 368.55 554.32 367.39 554.32 324.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "558.06 321.95 555.98 323.11 555.98 366.47 558.06 365.32 558.06 321.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "561.8 319.88 559.72 321.03 559.72 364.39 561.8 363.24 561.8 319.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "565.55 317.8 563.47 318.95 563.47 362.32 565.55 361.16 565.55 317.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "569.29 315.72 567.21 316.88 567.21 360.24 569.29 359.09 569.29 315.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "573.03 313.65 570.95 314.8 570.95 358.16 573.03 357.01 573.03 313.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "660.78 264.96 662.86 263.8 662.86 307.17 660.78 308.32 660.78 264.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "657.04 267.03 659.12 265.88 659.12 309.24 657.04 310.4 657.04 267.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "653.3 269.11 655.38 267.96 655.38 311.32 653.3 312.48 653.3 269.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "649.55 271.19 651.63 270.03 651.63 313.4 649.55 314.55 649.55 271.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "645.81 273.26 647.89 272.11 647.89 315.48 645.81 316.63 645.81 273.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "642.07 275.34 644.15 274.19 644.15 317.55 642.07 318.71 642.07 275.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "638.33 277.42 640.4 276.26 640.4 319.63 638.33 320.78 638.33 277.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "634.58 279.49 636.66 278.34 636.66 321.71 634.58 322.86 634.58 279.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "630.84 281.57 632.92 280.42 632.92 323.78 630.84 324.94 630.84 281.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "627.1 283.65 629.18 282.49 629.18 325.86 627.1 327.01 627.1 283.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "623.35 285.72 625.43 284.57 625.43 327.94 623.35 329.09 623.35 285.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "619.61 287.8 621.69 286.65 621.69 330.01 619.61 331.17 619.61 287.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "615.87 289.88 617.95 288.72 617.95 332.09 615.87 333.24 615.87 289.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "612.12 291.95 614.2 290.8 614.2 334.17 612.12 335.32 612.12 291.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "608.38 294.03 610.46 292.88 610.46 336.24 608.38 337.4 608.38 294.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "604.64 296.11 606.72 294.95 606.72 338.32 604.64 339.47 604.64 296.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "600.9 298.19 602.98 297.03 602.98 340.4 600.9 341.55 600.9 298.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "597.15 300.26 599.23 299.11 599.23 342.47 597.15 343.63 597.15 300.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "593.41 302.34 595.49 301.18 595.49 344.55 593.41 345.7 593.41 302.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "589.67 304.42 591.75 303.26 591.75 346.63 589.67 347.78 589.67 304.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "585.92 306.49 588 305.34 588 348.7 585.92 349.86 585.92 306.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "582.18 308.57 584.26 307.41 584.26 350.78 582.18 351.93 582.18 308.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "578.44 310.65 580.52 309.49 580.52 352.86 578.44 354.01 578.44 310.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "576.77 311.57 574.69 312.72 574.69 356.09 576.77 354.93 576.77 311.57"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M501.3,346.47l-2.2,1.22v-.95l1.88-4.98,1.6-.89v3.96l.71-.39v.92l-.71,.39v1.5l-1.29,.71v-1.5Zm0-.92v-2.71l-1.11,3.32,1.11-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M503.82,344.73c0-.36,.07-.71,.21-1.05,.14-.34,.35-.65,.63-.94-.22-.02-.4-.11-.54-.28-.14-.17-.21-.42-.21-.76,0-.52,.16-1.01,.47-1.48,.31-.46,.77-.86,1.36-1.19,.59-.33,1.04-.43,1.35-.31,.31,.12,.46,.43,.46,.95,0,.36-.07,.69-.2,1.01-.13,.31-.31,.6-.53,.86,.28-.03,.49,.05,.63,.25,.14,.19,.21,.48,.21,.85,0,.59-.15,1.14-.46,1.64-.31,.5-.8,.94-1.47,1.31-1.29,.72-1.94,.43-1.94-.86Zm2.42-.6c.07-.23,.1-.51,.1-.83,0-.29-.04-.5-.12-.62-.08-.13-.23-.13-.46,0-.23,.13-.39,.31-.47,.54-.08,.23-.12,.5-.12,.81,0,.28,.04,.5,.12,.64,.08,.14,.24,.15,.47,.02,.25-.14,.41-.33,.48-.56Zm.03-3.71c0-.23-.04-.39-.13-.48-.09-.09-.21-.08-.38,0-.17,.1-.3,.24-.39,.42-.09,.18-.13,.39-.13,.62,0,.66,.18,.89,.53,.69,.34-.19,.51-.61,.51-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M510.11,337.63l-1.96,1.09v-.93l3.31-1.84v.8l-1.53,6.43-1.34,.74,1.52-6.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M551.35,311.05c-.28,0-.46-.12-.56-.34-.1-.23-.15-.56-.15-.98l1.34-.74c0,.37,.04,.61,.12,.73,.08,.12,.23,.12,.45,0,.18-.1,.31-.22,.39-.37,.08-.15,.13-.32,.16-.52,.02-.2,.03-.46,.03-.8,0-.39-.04-.66-.12-.8-.08-.15-.25-.15-.5-.01-.32,.18-.53,.48-.62,.92l-1.19,.66,.1-3.68,3.32-1.84v1.05l-2.2,1.22-.07,1.45c.08-.14,.23-.29,.43-.46,.2-.17,.42-.32,.64-.45,.5-.27,.87-.31,1.12-.09,.25,.21,.38,.63,.38,1.27,0,.5-.05,.95-.15,1.34-.1,.39-.3,.76-.58,1.11s-.69,.67-1.21,.96c-.49,.27-.87,.4-1.14,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M557.17,306.45l-2.2,1.22v-.95l1.88-4.98,1.6-.89v3.96l.71-.39v.92l-.71,.39v1.5l-1.29,.71v-1.5Zm0-.92v-2.71l-1.11,3.33,1.11-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M560.12,305.92c-.3-.17-.46-.56-.46-1.17v-.22l1.38-.76v.21c0,.32,.05,.53,.13,.63,.08,.1,.23,.08,.45-.04,.22-.12,.37-.28,.45-.47,.08-.19,.12-.44,.12-.77s-.06-.56-.17-.66c-.12-.1-.33-.07-.63,.09-.01,0-.09,.04-.24,.13v-.89l.22-.12c.31-.18,.53-.37,.65-.58,.12-.21,.18-.49,.18-.82,0-.27-.04-.45-.13-.54-.09-.08-.24-.06-.46,.06-.22,.12-.36,.27-.44,.46-.08,.18-.12,.42-.12,.7v.28l-1.38,.76v-.35c0-.56,.17-1.08,.51-1.57,.34-.49,.82-.91,1.43-1.25,.62-.34,1.1-.46,1.44-.36,.34,.11,.51,.43,.51,.99,0,.36-.08,.72-.25,1.06-.17,.35-.39,.62-.66,.84,.61-.14,.91,.19,.91,1,0,.61-.15,1.18-.46,1.7-.31,.52-.8,.97-1.47,1.34-.69,.38-1.19,.49-1.49,.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M596.9,301.92c-.3-.17-.46-.56-.46-1.17v-.22l1.38-.76v.21c0,.32,.05,.53,.13,.63,.08,.1,.23,.08,.45-.04,.22-.12,.37-.28,.45-.47,.08-.19,.12-.44,.12-.77s-.06-.56-.17-.66c-.11-.1-.33-.07-.63,.09-.01,0-.09,.04-.24,.13v-.89l.21-.12c.31-.18,.53-.37,.65-.58,.12-.21,.18-.49,.18-.82,0-.27-.04-.45-.13-.54-.09-.08-.24-.06-.46,.06-.22,.12-.36,.27-.44,.46-.08,.18-.12,.42-.12,.7v.28l-1.38,.76v-.35c0-.56,.17-1.08,.51-1.58,.34-.49,.81-.91,1.43-1.25,.62-.34,1.1-.46,1.44-.36,.34,.11,.51,.43,.51,.99,0,.36-.09,.72-.25,1.06-.17,.34-.39,.62-.66,.84,.61-.14,.91,.19,.91,1,0,.61-.16,1.18-.47,1.7-.31,.52-.8,.97-1.47,1.34-.69,.38-1.19,.49-1.49,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M600.99,299.19l1.76-3.36,.13-.25c.22-.41,.37-.75,.48-1,.1-.26,.16-.5,.16-.73,0-.21-.04-.34-.13-.4-.09-.06-.22-.04-.39,.06-.24,.14-.41,.31-.51,.53-.1,.22-.14,.48-.14,.77v.29l-1.35,.75v-.31c0-.6,.16-1.16,.48-1.69,.32-.53,.82-.98,1.5-1.35,.63-.35,1.1-.47,1.43-.36,.33,.11,.49,.43,.49,.97,0,.33-.07,.66-.21,.99-.14,.34-.35,.78-.64,1.32l-.1,.19-1.39,2.62,2.14-1.19v.96l-3.7,2.05v-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M605.51,295.69c0-.36,.07-.71,.21-1.05,.14-.34,.35-.65,.64-.94-.22-.02-.4-.11-.54-.28-.14-.17-.21-.42-.21-.76,0-.52,.16-1.01,.47-1.48,.31-.46,.77-.86,1.36-1.19,.59-.33,1.04-.43,1.35-.31,.31,.12,.46,.43,.46,.95,0,.36-.07,.69-.2,1.01-.13,.31-.31,.6-.53,.86,.28-.03,.49,.05,.63,.25,.14,.19,.21,.48,.21,.85,0,.59-.15,1.14-.46,1.64-.31,.5-.8,.94-1.48,1.31-1.29,.72-1.94,.43-1.94-.86Zm2.42-.6c.07-.23,.1-.51,.1-.83,0-.29-.04-.5-.12-.62-.08-.13-.23-.13-.46,0-.23,.13-.39,.31-.47,.54-.08,.23-.12,.5-.12,.81,0,.28,.04,.5,.12,.64,.08,.14,.24,.15,.47,.02,.25-.14,.41-.33,.48-.56Zm.03-3.71c0-.23-.04-.39-.13-.48-.09-.09-.21-.08-.38,.01-.17,.09-.3,.23-.39,.42-.09,.18-.13,.39-.13,.62,0,.66,.17,.89,.53,.69,.34-.19,.51-.61,.51-1.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M641.72,271.86l-2.2,1.22v-.95l1.89-4.98,1.6-.89v3.96l.7-.39v.92l-.7,.39v1.5l-1.29,.71v-1.5Zm0-.92v-2.71l-1.11,3.33,1.11-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M644.67,271.33c-.3-.17-.46-.56-.46-1.17v-.22l1.38-.76v.21c0,.32,.05,.53,.13,.63,.08,.1,.23,.08,.45-.04,.22-.12,.37-.28,.45-.47,.08-.19,.12-.44,.12-.77s-.06-.56-.17-.66-.33-.07-.63,.09c-.01,0-.09,.04-.24,.13v-.89l.21-.12c.32-.18,.53-.37,.65-.58,.12-.21,.18-.49,.18-.82,0-.27-.04-.45-.13-.54-.09-.08-.24-.06-.46,.06-.21,.12-.36,.27-.44,.46-.08,.18-.12,.42-.12,.7v.28l-1.38,.76v-.35c0-.56,.17-1.08,.51-1.57,.34-.49,.82-.91,1.43-1.25,.62-.34,1.1-.46,1.44-.36,.34,.1,.51,.43,.51,.98,0,.36-.08,.72-.25,1.06-.17,.35-.39,.63-.66,.84,.61-.14,.91,.19,.91,1,0,.61-.15,1.18-.46,1.7-.31,.52-.8,.97-1.47,1.34-.69,.38-1.19,.49-1.49,.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M649.5,268.91c-.27,0-.46-.12-.56-.34-.1-.23-.15-.56-.15-.98l1.34-.74c0,.37,.04,.61,.12,.74,.08,.12,.23,.12,.45,0,.18-.1,.31-.22,.39-.38,.08-.15,.13-.32,.16-.52,.02-.2,.03-.46,.03-.8,0-.39-.04-.66-.12-.8-.08-.15-.25-.15-.5-.01-.32,.18-.53,.48-.62,.92l-1.19,.66,.1-3.68,3.32-1.84v1.05l-2.2,1.22-.07,1.45c.08-.14,.23-.29,.43-.46,.2-.17,.42-.32,.64-.45,.49-.27,.87-.31,1.12-.09,.25,.21,.38,.63,.38,1.27,0,.5-.05,.95-.15,1.34-.1,.39-.3,.76-.58,1.11-.28,.35-.69,.67-1.21,.96-.49,.27-.87,.41-1.14,.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M505.92,354.11c0-.36-.33-.47-.74-.24-.41,.23-.74,.7-.74,1.06s.33,.47,.74,.24c.41-.23,.74-.7,.74-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M557.82,315.97c0-.36-.33-.47-.74-.24s-.74,.7-.74,1.06,.33,.47,.74,.24,.74-.7,.74-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M604.45,306.3c0-.36-.33-.47-.74-.24-.41,.23-.74,.7-.74,1.06s.33,.47,.74,.24c.41-.23,.74-.7,.74-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M647.59,277.75c0-.36-.33-.47-.74-.24-.41,.23-.74,.7-.74,1.06s.33,.47,.74,.24c.41-.23,.74-.7,.74-1.06Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("image", {
    width: 149,
    height: 116,
    transform: "translate(89 592)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "437.81 597.46 446.88 592.92 455.96 597.46 446.88 601.99 437.81 597.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "437.81 565.7 446.88 561.16 455.96 565.7 446.88 570.23 437.81 565.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "437.81 506.71 446.88 502.18 455.96 506.71 446.88 511.25 437.81 506.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "437.81 597.46 437.81 565.7 446.88 570.23 446.88 601.99 437.81 597.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "446.88 601.99 446.88 570.23 455.96 565.7 455.96 597.46 446.88 601.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "437.81 629.22 446.88 624.68 455.96 629.22 446.88 633.75 437.81 629.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "437.81 629.22 437.81 597.46 446.88 601.99 446.88 633.75 437.81 629.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "446.88 633.75 446.88 601.99 455.96 597.46 455.96 629.22 446.88 633.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "446.88 511.25 446.88 570.23 437.81 565.7 437.81 506.71 446.88 511.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "446.88 511.25 455.96 506.71 455.96 565.7 446.88 570.23 446.88 511.25"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-486",
    points: "481.93 593.89 498.01 585.85 514.08 593.89 498.01 601.93 481.93 593.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-309",
    points: "481.93 553.7 498.01 545.66 514.08 553.7 498.01 561.74 481.93 553.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "481.93 489.39 498.01 481.35 514.08 489.39 498.01 497.43 481.93 489.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "481.93 593.89 481.93 553.7 498.01 561.74 498.01 601.93 481.93 593.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "498.01 601.93 498.01 561.74 514.08 553.7 514.08 593.89 498.01 601.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "481.93 618.01 498.01 609.97 514.08 618.01 498.01 626.05 481.93 618.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "481.93 618.01 481.93 593.89 498.01 601.93 498.01 626.05 481.93 618.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "498.01 626.05 498.01 601.93 514.08 593.89 514.08 618.01 498.01 626.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "498.01 497.43 498.01 561.74 481.93 553.7 481.93 489.39 498.01 497.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "498.01 497.43 514.08 489.39 514.08 553.7 498.01 561.74 498.01 497.43"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "528.55 574.77 537.63 570.23 546.7 574.77 537.63 579.31 528.55 574.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "528.55 561.16 537.63 556.62 546.7 561.16 537.63 565.7 528.55 561.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "528.55 533.94 537.63 529.4 546.7 533.94 537.63 538.47 528.55 533.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "528.55 574.77 528.55 561.16 537.63 565.7 537.63 579.31 528.55 574.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "537.63 579.31 537.63 565.7 546.7 561.16 546.7 574.77 537.63 579.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "528.55 583.84 537.63 579.31 546.7 583.84 537.63 588.38 528.55 583.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "528.55 583.84 528.55 574.77 537.63 579.31 537.63 588.38 528.55 583.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "537.63 588.38 537.63 579.31 546.7 574.77 546.7 583.84 537.63 588.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "537.63 538.47 537.63 565.7 528.55 561.16 528.55 533.94 537.63 538.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "537.63 538.47 546.7 533.94 546.7 561.16 537.63 565.7 537.63 538.47"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "446.88 633.75 455.96 629.22 492.65 647.61 483.57 652.15 446.88 633.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "498.01 626.05 514.08 618.01 550.64 635.64 534.56 643.68 498.01 626.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "537.63 588.38 546.7 583.84 580.3 599.77 571.22 604.31 537.63 588.38"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-269"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M156.61,578.46c-25.47,14.4-46.07,5.34-45.94-20.21,.14-25.54,20.97-58.04,46.43-72.45,25.47-14.4,46.08-5.34,45.94,20.2-.14,25.54-20.97,58.04-46.43,72.45Zm.48-89.93c-23.97,13.56-43.57,44.14-43.7,68.18-.13,24.04,19.27,32.57,43.24,19.02,23.97-13.56,43.57-44.14,43.7-68.18,.13-24.04-19.27-32.57-43.24-19.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M156.65,571.64c-21.72,12.28-39.3,4.55-39.18-17.23,.12-21.79,17.88-49.5,39.6-61.79,21.72-12.28,39.3-4.55,39.18,17.23-.12,21.79-17.88,49.5-39.6,61.79Zm.41-76.29c-20.22,11.44-36.76,37.24-36.87,57.52-.11,20.28,16.25,27.48,36.48,16.04,20.22-11.44,36.76-37.24,36.87-57.52,.11-20.28-16.25-27.48-36.48-16.04Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M144.2,553.6v1.78c-.02,1.37,.58,1.53,1.54,.99,.96-.54,1.56-1.38,1.57-2.75l.02-4.23c0-1.37-.59-1.55-1.55-1.01-.96,.54-1.56,1.4-1.57,2.78v.58l-2.85,1.61,.61-11.45,7.94-4.49v2.74l-5.24,2.96-.27,4.72c.55-1.21,1.43-2.21,2.63-2.89,2.22-1.25,3.33-.32,3.32,2.51l-.02,4.28c-.02,3.08-1.56,5.7-4.51,7.37-2.96,1.67-4.48,.78-4.46-2.3v-1.59l2.85-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M152.12,540.74c.02-3.07,1.64-5.74,4.6-7.41,2.96-1.67,4.56-.83,4.55,2.24l-.05,9.99c-.02,3.08-1.64,5.75-4.6,7.42-2.96,1.67-4.56,.83-4.54-2.25l.05-9.99Zm2.96,8.48c0,1.37,.59,1.55,1.55,1.01,.96-.54,1.56-1.4,1.57-2.78l.05-10.38c0-1.37-.59-1.55-1.55-1.01-.96,.54-1.56,1.4-1.57,2.78l-.05,10.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M163.05,532.89c.01-1.98,1.03-3.65,2.92-4.71,1.89-1.07,2.9-.54,2.89,1.43l-.03,6.31c-.01,1.98-1.03,3.65-2.92,4.72-1.89,1.07-2.89,.54-2.88-1.43l.03-6.31Zm1.88,5.37c0,.85,.35,1.01,.98,.65,.6-.34,.99-.91,.99-1.76l.03-6.59c0-.85-.38-.99-.98-.65-.63,.36-.99,.91-.99,1.76l-.03,6.59Zm8.59-14.22l1.78-1.01-7.66,23.49-1.78,1.01,7.66-23.49Zm-1.01,10.51c0-1.98,1.03-3.65,2.92-4.71,1.89-1.07,2.9-.54,2.89,1.43l-.03,6.31c-.01,1.97-1.03,3.65-2.92,4.71-1.89,1.07-2.89,.54-2.88-1.43l.03-6.31Zm3.89-2.34c0-.85-.38-.99-.98-.65-.63,.36-.99,.91-.99,1.76l-.03,6.59c0,.85,.35,1.01,.98,.65,.6-.34,.99-.92,.99-1.77"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M266.87,535.34c3.85,.11,5.13,3.16,5.12,8.26-.08,39.13-.04,78.2-.04,117.29v4.47c1.16-1.91,1.91-3.07,2.61-4.28,8.25-14.22,16.49-28.45,24.72-42.69,2.04-3.53,4.37-5.68,7.16-5.74,2.45-.05,4.11,1.52,4.04,4.72-.05,2.42-.64,5.71-1.89,7.91-12.69,22.25-25.55,44.37-38.41,66.49-.89,1.54-2.19,2.75-3.29,4.11-.94,.44-1.88,.87-2.82,1.31-1.63-.78-3.43-1.26-4.86-2.39-12.21-9.67-24.34-19.47-36.52-29.19-2.03-1.62-2.99-4.07-2.08-8.06,.83-3.63,2.68-6.34,5.32-8.05,2.57-1.66,4.47-.95,6.21,.46,8,6.52,16.04,12.97,24.04,19.47,.73,.59,1.34,1.38,2,2.07l.81-.7v-3.56c0-39.22,.05-78.46-.06-117.63-.01-5.16,1.36-9.29,5.14-12.97,.94-.44,1.88-.87,2.82-1.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-467",
    d: "M398.27,363.99c1.81,.05,2.41,1.48,2.41,3.88-.04,18.39-.02,36.75-.02,55.12v2.1c.55-.9,.9-1.44,1.23-2.01,3.88-6.68,7.75-13.37,11.62-20.06,.96-1.66,2.05-2.67,3.36-2.7,1.15-.02,1.93,.71,1.9,2.22-.02,1.14-.3,2.68-.89,3.72-5.96,10.46-12.01,20.85-18.05,31.25-.42,.72-1.03,1.29-1.55,1.93-.44,.2-.88,.41-1.33,.61-.77-.37-1.61-.59-2.29-1.12-5.74-4.54-11.44-9.15-17.16-13.72-.95-.76-1.4-1.91-.98-3.79,.39-1.71,1.26-2.98,2.5-3.78,1.21-.78,2.1-.45,2.92,.22,3.76,3.06,7.54,6.1,11.3,9.15,.34,.28,.63,.65,.94,.97,.13-.11,.25-.22,.38-.33v-1.67c0-18.43,.02-36.87-.03-55.28,0-2.43,.64-4.37,2.41-6.1,.44-.2,.88-.41,1.33-.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M624.68,281.27c-3.85-.11-5.13-3.16-5.12-8.26,.08-39.13,.04-78.2,.04-117.29v-4.47c-1.16,1.91-1.91,3.07-2.61,4.28-8.25,14.22-16.49,28.45-24.72,42.69-2.04,3.53-4.37,5.68-7.16,5.74-2.45,.05-4.11-1.52-4.04-4.72,.05-2.42,.64-5.71,1.89-7.91,12.69-22.25,25.55-44.37,38.41-66.49,.89-1.54,2.19-2.75,3.29-4.11,.94-.44,1.88-.87,2.82-1.31,1.63,.78,3.43,1.26,4.86,2.39,12.21,9.67,24.34,19.47,36.52,29.19,2.03,1.62,2.99,4.07,2.08,8.06-.83,3.63-2.68,6.34-5.32,8.05-2.57,1.66-4.47,.95-6.21-.46-8-6.52-16.04-12.97-24.04-19.47-.73-.59-1.34-1.38-2-2.07-.27,.23-.54,.47-.81,.7v3.56c0,39.22-.05,78.46,.06,117.63,.01,5.16-1.36,9.29-5.14,12.97-.94,.44-1.88,.87-2.82,1.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-407",
    d: "M93.25,523.93c-1.46-.04-1.94-1.2-1.94-3.13,.03-14.82,.02-29.62,.02-44.43v-1.69c-.44,.72-.72,1.16-.99,1.62-3.12,5.39-6.25,10.77-9.36,16.17-.77,1.34-1.65,2.15-2.71,2.17-.93,.02-1.56-.57-1.53-1.79,.02-.92,.24-2.16,.72-3,4.81-8.43,9.68-16.81,14.55-25.18,.34-.58,.83-1.04,1.25-1.56,.36-.16,.71-.33,1.07-.49,.62,.3,1.3,.48,1.84,.91,4.62,3.66,9.22,7.37,13.83,11.06,.77,.61,1.13,1.54,.79,3.05-.31,1.38-1.01,2.4-2.02,3.05-.97,.63-1.69,.36-2.35-.17-3.03-2.47-6.07-4.91-9.11-7.38-.27-.22-.51-.52-.76-.78l-.31,.27v1.35c0,14.86-.02,29.72,.02,44.55,0,1.96-.52,3.52-1.95,4.91-.36,.16-.71,.33-1.07,.49Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeviceConection01);
export default __webpack_public_path__ + "static/media/img-device-conection-01.a07dd3b3b1ccbd055498ec3c6b67c1b9.svg";
export { ForwardRef as ReactComponent };